// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.flowchest-platform-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border-top: 1px solid #e8e8e8;
  color: #666;
  font-size: 0.8rem;
  background: #fff;
  /* Pinned to the viewport: dashboard pages position content absolutely, so a
     sticky/in-flow footer ends up mid-screen once the page scrolls. */
  position: fixed;
  bottom: 0;
  right: 0;
  left: 240px;
  z-index: 20;
  transition: left 0.3s ease;
}
.flowchest-platform-footer.sidebar-collapsed, .flowchest-platform-footer.sidebar-overlay {
  left: 0;
}

@media (max-width: 1024px) {
  .flowchest-platform-footer {
    left: 200px;
  }
}
@media (max-width: 768px) {
  .flowchest-platform-footer {
    left: 0;
    padding: 0.5rem;
  }
}
.flowchest-platform-footer img {
  height: 18px;
  width: auto;
}

.app-layout.theme-dark-layout .flowchest-platform-footer,
body.theme-dark .flowchest-platform-footer {
  background: #1e1e1e;
  border-top-color: #333;
  color: #aaa;
}

.app-layout.theme-dark-layout .org-scope-switcher--mobile,
body.theme-dark .org-scope-switcher--mobile {
  background: #1e1e1e;
  border-bottom-color: #333;
}

.app-layout.theme-dark-layout .org-scope-switcher select,
body.theme-dark .org-scope-switcher select {
  background: #2a2a2a;
  border-color: #444;
  color: #eee;
}

.org-brand-logo {
  max-height: 36px;
  width: auto;
  object-fit: contain;
}

.org-scope-switcher {
  display: flex;
  gap: 0.4rem;
  align-items: center;
}

.org-scope-switcher--desktop {
  margin-left: 0.75rem;
}

.org-scope-switcher select {
  max-width: 160px;
  font: inherit;
  font-size: 0.8rem;
  padding: 0.25rem 0.4rem;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background: #fff;
}

.org-scope-switcher--mobile {
  display: none;
}

.org-scope-switcher--sidebar {
  flex-direction: column;
  align-items: stretch;
  gap: 0.35rem;
  padding: 0 12px 8px;
}

.org-scope-switcher--sidebar select {
  max-width: none;
  width: 100%;
  font-size: 0.85rem;
  padding: 0.45rem 0.5rem;
}

.org-scope-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #888;
  margin-top: 4px;
}

@media (max-width: 768px) {
  .org-scope-switcher--mobile {
    display: flex;
    position: sticky;
    top: 56px;
    z-index: 90;
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    gap: 8px;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
  }
  .org-scope-switcher--mobile select {
    flex: 1;
    max-width: none;
    min-width: 0;
    font-size: 0.8rem;
    padding: 0.4rem 0.5rem;
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 8px 0;
}

p {
  margin: 0;
}

.spacer {
  flex: 1;
}

.toolbar {
  height: 60px;
  margin: -8px;
  display: flex;
  align-items: center;
  background-color: #1976d2;
  color: white;
  font-weight: 600;
}

.toolbar img {
  margin: 0 16px;
}

.toolbar #twitter-logo {
  height: 40px;
  margin: 0 16px;
}

.toolbar #twitter-logo:hover {
  opacity: 0.8;
}

.content {
  display: flex;
  margin: 32px auto;
  padding: 0 16px;
  max-width: 960px;
  flex-direction: column;
  align-items: center;
}

svg.material-icons {
  height: 24px;
  width: auto;
}

svg.material-icons:not(:last-child) {
  margin-right: 8px;
}

.card svg.material-icons path {
  fill: #888;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 16px;
}

.card {
  border-radius: 4px;
  border: 1px solid #eee;
  background-color: #fafafa;
  height: 40px;
  width: 200px;
  margin: 0 8px 16px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  line-height: 24px;
}

.card-container .card:not(:last-child) {
  margin-right: 0;
}

.card.card-small {
  height: 16px;
  width: 168px;
}

.card-container .card:not(.highlight-card) {
  cursor: pointer;
}

.card-container .card:not(.highlight-card):hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);
}

.card-container .card:not(.highlight-card):hover .material-icons path {
  fill: rgb(105, 103, 103);
}

.card.highlight-card {
  background-color: #1976d2;
  color: white;
  font-weight: 600;
  border: none;
  min-width: 30%;
  position: relative;
}

.card.card.highlight-card span {
  margin-left: 60px;
}

svg#rocket {
  width: 80px;
  position: absolute;
  left: -10px;
  top: -24px;
}

svg#rocket-smoke {
  height: 100vh;
  position: absolute;
  top: 10px;
  right: 180px;
  z-index: -10;
}

a,
a:visited,
a:hover {
  color: #1976d2;
  text-decoration: none;
}

a:hover {
  color: #125699;
}

.terminal {
  position: relative;
  width: 80%;
  max-width: 600px;
  border-radius: 6px;
  padding-top: 45px;
  margin-top: 8px;
  overflow: hidden;
  background-color: rgb(15, 15, 16);
}

.terminal::before {
  content: "•••";
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background: rgb(58, 58, 58);
  color: #c2c3c4;
  width: 100%;
  font-size: 2rem;
  line-height: 0;
  padding: 14px 0;
  text-indent: 4px;
}

.terminal pre {
  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  color: white;
  padding: 0 1rem 1rem;
  margin: 0;
}

.circle-link {
  height: 40px;
  width: 40px;
  border-radius: 40px;
  margin: 8px;
  background-color: white;
  border: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: 1s ease-out;
}

.circle-link:hover {
  transform: translateY(-0.25rem);
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
}

footer {
  margin-top: 8px;
  display: flex;
  align-items: center;
  line-height: 20px;
}

footer a {
  display: flex;
  align-items: center;
}

.github-star-badge {
  color: #24292e;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 3px 10px;
  border: 1px solid rgba(27, 31, 35, 0.2);
  border-radius: 3px;
  background-image: linear-gradient(-180deg, #fafbfc, #eff3f6 90%);
  margin-left: 4px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.github-star-badge:hover {
  background-image: linear-gradient(-180deg, #f0f3f6, #e6ebf1 90%);
  border-color: rgba(27, 31, 35, 0.35);
  background-position: -0.5em;
}

.github-star-badge .material-icons {
  height: 16px;
  width: 16px;
  margin-right: 4px;
}

svg#clouds {
  position: fixed;
  bottom: -160px;
  left: -230px;
  z-index: -10;
  width: 1920px;
}

/*my code starts here*/
.fixed-header {
  position: sticky;
  top: 0px;
  z-index: 10;
  display: flex;
  padding: 0px 3rem;
}
.fixed-header a {
  min-width: unset;
  display: block;
  padding: 0px;
}
.fixed-header a:hover {
  background: transparent;
}
.fixed-header div {
  flex: 1;
}
.fixed-header .mat-icon {
  width: 30px;
  margin-right: 0px !important;
  font-size: 28px !important;
}
.fixed-header .mat-icon:last-of-type {
  margin-right: 0px !important;
}
.fixed-header .mat-icon ~ span {
  margin-right: 0px !important;
  width: 25px;
  height: auto;
}

/* Responsive Styles */
@media screen and (max-width: 767px) {
  .card-container > *:not(.circle-link),
  .terminal {
    width: 100%;
  }
  .card:not(.highlight-card) {
    height: 16px;
    margin: 8px 0;
  }
  .card.highlight-card span {
    margin-left: 72px;
  }
  svg#rocket-smoke {
    right: 120px;
    transform: rotate(-5deg);
  }
}
@media screen and (max-width: 575px) {
  svg#rocket-smoke {
    display: none;
    visibility: hidden;
  }
}
.filler {
  flex: 1 1 auto;
}

.gap {
  margin-right: 10px;
}

.mat-option-text {
  font-size: 15px !important;
}

.toolbar {
  position: sticky;
  position: -webkit-sticky; /* For macOS/iOS Safari */
  top: 0; /* Sets the sticky toolbar to be on top */
  z-index: 1000; /* Ensure that your app's content doesn't overlap the toolbar */
}

.mat-badge-content {
  background: red;
}

nav {
  display: flex;
  align-items: center;
  background: #00a9d4;
  height: 60px;
  position: relative;
}

.icon {
  cursor: pointer;
  margin-right: 50px;
  line-height: 60px;
}

.icon span {
  background: #f00;
  padding: 7px;
  border-radius: 50%;
  color: #fff;
  vertical-align: top;
  margin-left: -25px;
}

.icon img {
  display: inline-block;
  width: 40px;
  margin-top: 20px;
}

.icon:hover {
  opacity: 0.7;
}

.logo {
  flex: 1;
  margin-left: 50px;
  color: #eee;
  font-size: 20px;
  font-family: monospace;
}

.notifi-box {
  width: 300px;
  height: 0px;
  opacity: 0;
  position: absolute;
  top: 63px;
  right: 35px;
  transition: 1s opacity, 250ms height;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  z-index: 1;
}

.notifi-box h2 {
  font-size: 14px;
  padding: 10px;
  border-bottom: 1px solid #eee;
  color: #999;
}

.notifi-box h2 span {
  color: #f00;
}

.notifi-item {
  display: flex;
  border-bottom: 1px solid #eee;
  padding: 15px 5px;
  margin-bottom: 15px;
  cursor: pointer;
}

.notifi-item img {
  display: block;
  width: 50px;
  margin-right: 10px;
  border-radius: 50%;
}

.notifi-item .text h4 {
  color: #777;
  font-size: 16px;
  margin-top: 10px;
}

.notifi-item .text p {
  color: #aaa;
  font-size: 12px;
}

.mat-badge.hide-text .mat-badge-content {
  color: transparent;
}

.example-form {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
  margin-left: 420px;
}

.example-full-width {
  width: 100%;
}

::ng-deep .cdk-overlay-pane .mat-menu-panel {
  max-width: 536px;
  max-width: 536px;
  max-width: 536px;
  max-width: unset;
  min-width: 261px;
  width: auto;
  position: relative;
  transform-origin: 50% 100%;
  transition: all 0.5s linear;
  text-align: left;
  top: 34px !important;
  overflow: hidden;
  position: relative;
  z-index: 3;
}
::ng-deep .cdk-overlay-pane .mat-menu-panel:empty {
  display: none;
}
::ng-deep .cdk-overlay-pane .mat-menu-panel:focus {
  background: rgba(0, 0, 0, 0.04);
  outline: 0px;
}
::ng-deep .cdk-overlay-pane .mat-menu-panel .mat-menu-content .mat-menu-item {
  font-family: "Raleway";
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
::ng-deep .cdk-overlay-pane .mat-menu-panel button {
  margin: 5px 0px;
  position: relative;
  font-family: "Raileway";
  z-index: 2;
}
::ng-deep .cdk-overlay-pane .mat-menu-panel button:before {
  content: "";
  width: 2px;
  height: 100%;
  top: 0px;
  left: 0px;
  background: var(--fc-brand, #5ea1d8);
  position: absolute;
  transition: width 0.5s ease-in-out;
  z-index: -1;
}
::ng-deep .cdk-overlay-pane .mat-menu-panel button:focus {
  outline: 0px;
}
::ng-deep .cdk-overlay-pane .mat-menu-panel button:hover {
  color: #fff;
  background: #fff;
}
::ng-deep .cdk-overlay-pane .mat-menu-panel button:hover:before {
  width: 100%;
}

ngx-avatar {
  display: inline-block;
}

/*my code starts here*/
.flowbycat {
  height: auto;
}

.fix-head {
  position: sticky;
  top: 0px;
  z-index: 100;
}
.fix-head .material-icons {
  color: #212427 !important;
}

.fixed-header {
  position: sticky;
  top: 0px;
  z-index: 10;
  display: flex;
  padding: 0px 3rem;
  padding-right: calc(3rem + 0px);
  padding-left: calc(3rem + 0px);
  height: 80px;
  display: flex;
  align-items: center;
  border-bottom: 2px solid lightgrey;
}
.fixed-header a {
  min-width: unset;
  display: block;
  padding: 0px;
  text-align: left;
}
.fixed-header a:focus {
  outline: none !important;
}
.fixed-header a span:focus {
  outline: none !important;
}
.fixed-header a:hover {
  background: transparent;
}
.fixed-header div {
  flex: 1;
  align-items: center;
  text-align: center;
}

@media screen and (min-width: 993px) {
  .mobileonly {
    display: none;
  }
  .analyticmobile {
    display: none;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .flowbycat {
    min-height: 92vh !important;
  }
}
.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

@media only screen and (max-width: 1000px) and (min-width: 760px) {
  .mobileonly {
    display: none;
  }
}
.desktopmob {
  display: none !important;
}

@media (max-width: 767px) {
  .desktopmob {
    display: flex !important;
    flex-direction: column;
  }
  .right-nav {
    display: none;
  }
  .mobileonly {
    position: relative;
    top: 10px;
  }
}
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #ffffff;
  color: #000000;
  font-family: "Roboto", "Arial", sans-serif;
}

.app-layout.theme-light-layout {
  background-color: #ffffff;
  color: #000000;
}

.app-layout.theme-dark-layout {
  background-color: #0a0c10;
  color: #ffffff;
}

body.theme-dark {
  /* Account type switcher must stay readable on dark sidebar */
  /* Icon colours inside the mobile header search bar in dark mode */
}
body.theme-dark .app-layout {
  background-color: #0a0c10;
  color: #e2e8f0;
}
body.theme-dark .app-header {
  background-color: rgba(10, 12, 16, 0.95);
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
}
body.theme-dark .menu-button,
body.theme-dark .header-icon,
body.theme-dark .profile-button mat-icon {
  color: #f8fafc;
}
body.theme-dark .header-org-role {
  background: rgba(94, 161, 216, 0.2);
  border-color: rgba(94, 161, 216, 0.45);
  color: #93c5e8;
}
body.theme-dark .sidebar-account-option-role {
  color: #94a3b8;
}
body.theme-dark .sidebar-account-option--active .sidebar-account-option-role {
  color: #93c5e8;
}
body.theme-dark .menu-button:hover,
body.theme-dark .header-icon:hover,
body.theme-dark .search-icon-button:hover,
body.theme-dark .cancel-icon-button:hover {
  background-color: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}
body.theme-dark .search-box {
  background-color: #111827 !important;
  border-color: #475569 !important;
}
body.theme-dark .app-search-input {
  color: #e2e8f0 !important;
  -webkit-text-fill-color: #e2e8f0 !important;
  caret-color: #e2e8f0 !important;
  opacity: 1 !important;
}
body.theme-dark .app-search-input::placeholder {
  color: #94a3b8 !important;
  -webkit-text-fill-color: #94a3b8 !important;
  opacity: 1 !important;
}
body.theme-dark .app-sidebar {
  background-color: #0f172a;
  border-right: 1px solid rgba(148, 163, 184, 0.2);
}
body.theme-dark .sidebar-section .sidebar-section-header h3 {
  color: #94a3b8;
}
body.theme-dark .sidebar-item,
body.theme-dark .sidebar-item mat-icon {
  color: #e2e8f0;
}
body.theme-dark .sidebar-item:hover,
body.theme-dark .sidebar-item.active {
  background-color: rgba(148, 163, 184, 0.15);
}
body.theme-dark .sidebar-account-option {
  color: #e2e8f0;
}
body.theme-dark .sidebar-account-option mat-icon {
  color: #94a3b8;
}
body.theme-dark .sidebar-account-option:hover:not(.sidebar-account-option--active) {
  background: rgba(94, 161, 216, 0.16);
}
body.theme-dark .sidebar-account-option:hover:not(.sidebar-account-option--active) mat-icon {
  color: #93c5e8;
}
body.theme-dark .sidebar-account-option:hover:not(.sidebar-account-option--active) .sidebar-account-option-name {
  color: #f8fafc;
}
body.theme-dark .sidebar-account-option--active {
  background: rgba(94, 161, 216, 0.18);
  border-color: rgba(94, 161, 216, 0.45);
}
body.theme-dark .sidebar-account-option--active mat-icon,
body.theme-dark .sidebar-account-option--active .sidebar-account-option-check {
  color: #93c5e8 !important;
}
body.theme-dark .sidebar-account-option--active .sidebar-account-option-name {
  color: #f8fafc;
}
body.theme-dark .sidebar-account-option-name {
  color: #e2e8f0;
}
body.theme-dark .app-main-content {
  background-color: #0a0c10;
}
body.theme-dark .app-logo img {
  filter: brightness(1.05);
}
body.theme-dark .search-icon-button,
body.theme-dark .cancel-icon-button,
body.theme-dark .search-button {
  color: #e2e8f0;
}
body.theme-dark .search-history-dropdown,
body.theme-dark .mobile-search-history {
  background-color: #0f172a;
  border-color: rgba(148, 163, 184, 0.25);
}
body.theme-dark .search-history-header {
  background-color: #111827;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
}
body.theme-dark .search-history-title,
body.theme-dark .history-text,
body.theme-dark .no-history-message {
  color: #e2e8f0 !important;
}
body.theme-dark .search-history-item .history-icon,
body.theme-dark .search-history-item mat-icon.history-icon {
  color: #cbd5e1 !important;
}
body.theme-dark .search-history-hint {
  color: #93c5fd !important;
}
body.theme-dark .search-item-suggestion mat-icon.add-item-icon,
body.theme-dark .add-item-icon {
  color: #93c5fd !important;
}
body.theme-dark .remove-history-button mat-icon {
  color: #94a3b8 !important;
}
body.theme-dark .search-category-selector:hover, body.theme-dark .search-category-selector.active {
  background-color: rgba(255, 255, 255, 0.1);
}
body.theme-dark .search-category-label {
  color: #ffffff !important;
}
body.theme-dark .search-category-chevron {
  color: #ffffff !important;
}
body.theme-dark .search-cat-icon {
  color: #cbd5e1 !important;
}
body.theme-dark .search-cat-icon-img {
  filter: brightness(2) invert(0.1) !important;
  opacity: 0.85 !important;
}
body.theme-dark .search-category-chevron {
  color: #94a3b8 !important;
}
body.theme-dark .search-category-divider {
  background-color: #475569 !important;
}
body.theme-dark .search-category-dropdown,
body.theme-dark .search-category-dropdown--mobile {
  background-color: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4) !important;
}
body.theme-dark .search-category-option {
  color: #e2e8f0 !important;
  background-color: transparent !important;
}
body.theme-dark .search-category-option mat-icon {
  color: #cbd5e1 !important;
}
body.theme-dark .search-category-option .category-option-img {
  filter: brightness(2) !important;
  opacity: 0.85 !important;
}
body.theme-dark .search-category-option:hover {
  background-color: var(--fc-brand, #5ea1d8) !important;
  color: #ffffff !important;
}
body.theme-dark .search-category-option:hover mat-icon {
  color: #ffffff !important;
}
body.theme-dark .search-category-option.selected {
  background-color: transparent !important;
  color: #7bbde8 !important;
  font-weight: 600;
}
body.theme-dark .search-category-option.selected mat-icon {
  color: #7bbde8 !important;
}
body.theme-dark .search-category-option.selected:hover {
  background-color: var(--fc-brand, #5ea1d8) !important;
  color: #ffffff !important;
}
body.theme-dark .search-category-option.selected:hover mat-icon {
  color: #ffffff !important;
}
body.theme-dark .mobile-search-box-in-header {
  background: #111827 !important;
  border-color: #475569 !important;
}
body.theme-dark .search-item-suggestion:hover {
  background-color: rgba(59, 130, 246, 0.15) !important;
}
body.theme-dark .search-history-item:hover,
body.theme-dark .search-history-item.selected {
  background-color: rgba(148, 163, 184, 0.15);
}
body.theme-dark .clear-history-button {
  color: #93c5fd;
}
body.theme-dark .clear-history-button:hover {
  background-color: rgba(147, 197, 253, 0.15);
}
body.theme-dark .app-sidebar .sidebar-item .bundle-menu-icon {
  filter: brightness(1.2);
}
body.theme-dark .sidebar-backdrop {
  background-color: rgba(0, 0, 0, 0.65);
}
body.theme-dark .notification-badge {
  background-color: #ef4444;
}
body.theme-dark .profile-image {
  border: 1px solid rgba(148, 163, 184, 0.35);
}
body.theme-dark .mobile-search-box-in-header .mobile-search-field .app-search-input {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
  color: #e2e8f0 !important;
  -webkit-text-fill-color: #e2e8f0 !important;
  caret-color: #e2e8f0 !important;
  opacity: 1 !important;
}
body.theme-dark .mobile-search-box-in-header .mobile-search-field .app-search-input::placeholder {
  color: #94a3b8 !important;
  -webkit-text-fill-color: #94a3b8 !important;
  opacity: 1 !important;
}
body.theme-dark .mobile-search-box-in-header .mobile-search-field .cancel-icon-button,
body.theme-dark .mobile-search-box-in-header .mobile-search-field .search-icon-button {
  color: #94a3b8 !important;
}
body.theme-dark .mobile-search-box-in-header .mobile-search-field .cancel-icon-button mat-icon,
body.theme-dark .mobile-search-box-in-header .mobile-search-field .search-icon-button mat-icon {
  color: #94a3b8 !important;
}
@media (max-width: 768px) {
  body.theme-dark .app-header .search-box {
    background-color: transparent !important;
    border-color: transparent !important;
  }
  body.theme-dark .mobile-search-box-in-header .mobile-search-field .app-search-input {
    background: transparent !important;
  }
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 56px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  overflow: visible; /* Changed to visible to allow dropdown to show */
  /* When mobile search is active, ensure overflow is visible */
}
.app-header:has(.mobile-search-active) {
  overflow: visible;
}
@media (min-width: 956px) {
  .app-header {
    bottom: 0 !important;
  }
}

.app-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.menu-button {
  background: none;
  border: none;
  color: #000000;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.menu-button:hover {
  background-color: #f0f0f0;
}

.app-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.app-logo img {
  height: 45px;
  width: auto;
}

.app-search-container {
  flex: 1;
  max-width: 640px;
  margin: 0 40px;
}

.search-box {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #d0d0d0;
  border-radius: 40px;
  overflow: visible;
  height: 40px;
  position: relative;
}
.search-box.search-box-focused {
  border-color: #1a73e8;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.search-category-selector {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 12px;
  height: 100%;
  cursor: pointer;
  border-radius: 40px 0 0 40px;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  position: relative;
  white-space: nowrap;
  transition: background-color 0.15s;
}
.search-category-selector:hover, .search-category-selector.active {
  background-color: #f0f0f0;
}

.search-category-label {
  font-size: 14px;
  font-weight: 500;
  color: #111111;
  line-height: 1;
}

.theme-dark-layout .search-category-label,
body.theme-dark .search-category-label {
  color: #ffffff !important;
}

.theme-dark-layout .search-category-chevron {
  color: #ffffff !important;
}

.search-category-chevron {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #555;
  transition: transform 0.2s;
}
.search-category-selector.active .search-category-chevron {
  transform: rotate(180deg);
}

.search-category-divider {
  width: 1px;
  height: 22px;
  background-color: #d0d0d0;
  flex-shrink: 0;
  margin: 0 2px;
}

.search-category-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 160px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
  z-index: 1100;
  overflow: hidden;
  padding: 6px 0;
}

.search-category-dropdown--mobile {
  position: fixed;
  top: 56px;
  left: 8px;
  min-width: 160px;
  border-radius: 0 0 10px 10px;
  border-top: none;
}

.search-category-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #212427;
  text-align: left;
  transition: background-color 0.12s;
}
.search-category-option mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #606060 !important;
  flex-shrink: 0;
}
.search-category-option .category-option-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
  opacity: 0.7;
}
.search-category-option span {
  flex: 1;
  font-weight: 400;
}
.search-category-option:hover {
  background-color: var(--fc-brand, #5ea1d8);
  color: #ffffff;
}
.search-category-option:hover mat-icon,
.search-category-option:hover .category-option-img {
  color: #ffffff !important;
  opacity: 1;
}
.search-category-option.selected {
  background-color: transparent;
  color: var(--fc-brand, #5ea1d8);
  font-weight: 600;
}
.search-category-option.selected mat-icon,
.search-category-option.selected .category-option-img {
  color: var(--fc-brand, #5ea1d8) !important;
  opacity: 1;
}
.search-category-option.selected:hover {
  background-color: var(--fc-brand, #5ea1d8);
  color: #ffffff;
}
.search-category-option.selected:hover mat-icon,
.search-category-option.selected:hover .category-option-img {
  color: #ffffff !important;
}

.search-category-selector--mobile {
  padding: 0 6px 0 10px;
  border-radius: 0;
  gap: 1px;
}
.search-category-selector--mobile .search-category-label {
  display: none;
}
.search-category-selector--mobile .search-cat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #444;
}
.search-category-selector--mobile .search-cat-icon-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  opacity: 0.75;
}
.search-category-selector--mobile .search-category-chevron {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #666;
  transform: none !important;
}

.search-category-selector--indicator {
  cursor: default;
  pointer-events: none;
}
.search-category-selector--indicator:hover, .search-category-selector--indicator.active {
  background-color: transparent;
}

.search-category-dropdown--mobile {
  position: fixed;
  top: 56px;
  left: 8px;
  min-width: 140px;
  max-width: 180px;
  border-radius: 10px !important;
  border-top: 1px solid #e0e0e0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
  padding: 4px 0;
  z-index: 1200;
  background: #ffffff;
  border: 1px solid #e0e0e0;
}
.search-category-dropdown--mobile .search-category-option {
  padding: 11px 14px;
  font-size: 15px;
  gap: 10px;
}
.search-category-dropdown--mobile .search-category-option mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.search-category-dropdown--mobile .search-category-option.selected mat-icon {
  color: #1a73e8;
}
.search-category-dropdown--mobile .search-category-option.selected img.category-option-img {
  opacity: 1;
  filter: none;
}

.app-search-input {
  flex: 1;
  background: none;
  border: none;
  color: #000000;
  padding: 0 16px;
  padding-right: 96px;
  font-size: 16px;
  outline: none;
}

.app-search-input::placeholder {
  color: #666666;
}

.search-icon-button {
  position: absolute;
  right: 8px;
  background: transparent;
  border: none;
  color: #666666;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background-color 0.2s;
  z-index: 1;
  border-radius: 50%;
}

.search-icon-button:hover {
  color: #000000;
  background-color: #f0f0f0;
}

.search-icon-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.cancel-icon-button {
  position: absolute;
  right: 48px;
  background: transparent;
  border: none;
  color: #666666;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background-color 0.2s;
  z-index: 1;
  border-radius: 50%;
}

.cancel-icon-button:hover {
  color: #000000;
  background-color: #f0f0f0;
}

.cancel-icon-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.search-history-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  max-height: 400px;
  overflow-y: auto;
  margin-top: 0;
}
.search-history-dropdown::-webkit-scrollbar {
  width: 8px;
}
.search-history-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.search-history-dropdown::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.search-history-dropdown::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.search-history-hint {
  font-size: 11px;
  color: var(--fc-brand, #5ea1d8);
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: none;
}

.search-item-suggestion:hover {
  background-color: #f0f7ff;
}
.search-item-suggestion .add-item-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--fc-brand, #5ea1d8);
  flex-shrink: 0;
  opacity: 0.8;
  transition: opacity 0.15s;
}
.search-item-suggestion:hover .add-item-icon {
  opacity: 1;
}

.user-mention-suggestion:hover {
  background-color: #f0f7ff;
}

.mention-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 4px;
}

.mention-user-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 1;
  min-width: 0;
}

.mention-username {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mention-fullname {
  font-size: 12px;
  color: #606060;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fafafa;
}

.search-history-title {
  font-size: 14px;
  font-weight: 500;
  color: #606060;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.clear-history-button {
  background: none;
  border: none;
  color: #1a73e8;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.clear-history-button:hover {
  background-color: rgba(26, 115, 232, 0.1);
}

.search-history-list {
  padding: 4px 0;
}

.search-history-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.15s;
  position: relative;
}
.search-history-item:hover, .search-history-item.selected {
  background-color: #f5f5f5;
}
.search-history-item .history-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #606060;
  margin-right: 16px;
  flex-shrink: 0;
}
.search-history-item .history-text {
  flex: 1;
  font-size: 14px;
  color: #030303;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.search-history-item .remove-history-button {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #606060;
  opacity: 0;
  transition: opacity 0.2s, color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-left: 8px;
  flex-shrink: 0;
}
.search-history-item .remove-history-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.search-history-item .remove-history-button:hover {
  color: #030303;
  background-color: rgba(0, 0, 0, 0.05);
}
.search-history-item:hover .remove-history-button {
  opacity: 1;
}

.no-history-message {
  padding: 16px;
  text-align: center;
  color: #606060;
}
.no-history-message p {
  margin: 0;
  font-size: 14px;
}

.mobile-search-history {
  position: fixed !important;
  top: 62px !important;
  left: 8px !important;
  right: 8px !important;
  margin: 0;
  max-height: calc(100vh - 120px);
  z-index: 1002 !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  border-radius: 12px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
}

.mobile-search-box {
  position: relative;
}
.mobile-search-box.search-box-focused .mobile-search-field .app-search-input {
  border-color: #1a73e8;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.search-button {
  background: #f5f5f5;
  border: none;
  -webkit-appearance: none;
  color: #000000;
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.search-button:hover {
  background-color: #e0e0e0;
}

.app-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.translate-toggle-icon {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: all 0.2s ease;
}
.translate-toggle-icon mat-icon {
  color: #606060;
  transition: color 0.2s ease;
}
.translate-toggle-icon:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.translate-toggle-icon:hover mat-icon {
  color: var(--fc-brand, #5ea1d8);
}
.translate-toggle-icon.collapsed mat-icon {
  color: var(--fc-brand, #5ea1d8);
}
@media (min-width: 769px) {
  .translate-toggle-icon {
    display: none !important;
  }
}

.google-translate-header {
  display: flex !important;
  align-items: center;
  height: 40px;
  margin: 0 4px;
  padding: 4px 8px;
  background-color: #ffffff !important;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  visibility: visible !important;
  opacity: 1 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: visible;
  max-width: 200px;
}
.google-translate-header .goog-te-gadget {
  font-family: "Roboto", "Arial", sans-serif !important;
  font-size: 13px !important;
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.google-translate-header .goog-te-gadget-simple {
  background-color: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 4px 8px !important;
  font-size: 13px !important;
  color: #000000 !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  white-space: nowrap !important;
  height: auto !important;
  transition: background-color 0.2s !important;
}
.google-translate-header .goog-te-gadget-simple:hover {
  background-color: transparent !important;
}
.google-translate-header .goog-te-gadget-icon {
  margin-left: 4px !important;
  margin-right: 4px !important;
  display: inline-block !important;
}
.google-translate-header .goog-te-menu-value {
  color: #000000 !important;
}
.google-translate-header .goog-te-menu-value span {
  color: #000000 !important;
}
@media (max-width: 1200px) {
  .google-translate-header .goog-te-gadget-simple .goog-te-menu-value span {
    display: none;
  }
}

#google_translate_element_header {
  display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
}
#google_translate_element_header * {
  visibility: visible !important;
  opacity: 1 !important;
}

@media (min-width: 956px) {
  iframe.skiptranslate,
  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,
  iframe[class*=skiptranslate],
  iframe[id*=container],
  iframe[class*=VIpgJd],
  iframe[class*=VIpgJd-ZVi9od],
  iframe[class*=VIpgJd-ZVi9od-ORHb-OEVmcd] {
    position: fixed !important;
    bottom: 0 !important;
    left: auto !important;
    right: 0 !important;
    top: auto !important;
    width: auto !important;
    max-width: 400px !important;
    min-height: 60px !important;
    max-height: 300px !important;
    z-index: 1001 !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    border-left: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
  }
  .goog-te-banner-frame {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: fixed !important;
    bottom: 0 !important;
    left: auto !important;
    right: 0 !important;
    width: auto !important;
    max-width: 400px !important;
    min-height: 60px !important;
    max-height: 300px !important;
    z-index: 1001 !important;
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    border-left: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
  }
  body:has(iframe[class*=VIpgJd]) .app-header,
  body:has(iframe.skiptranslate) .app-header,
  body:has(.goog-te-banner-frame) .app-header {
    top: 0 !important;
    z-index: 1000 !important;
  }
  .goog-te-menu-frame {
    max-width: 100% !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
  .goog-te-menu-frame .goog-te-menu2 {
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
  #google_translate_element_header .goog-te-menu-frame,
  .google-translate-header .goog-te-menu-frame {
    max-height: 60vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
  .translate-banner-toggle {
    position: fixed !important;
    top: 14px !important;
    right: 20px !important;
    width: 32px !important;
    height: 32px !important;
    background-color: var(--fc-brand, #5ea1d8) !important;
    color: #ffffff !important;
    border: none !important;
    border-radius: 50% !important;
    cursor: pointer !important;
    display: none !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 1005 !important;
    box-shadow: 0 2px 8px rgba(94, 161, 216, 0.3) !important;
    transition: all 0.3s ease !important;
    font-size: 12px !important;
    line-height: 1 !important;
    padding: 0 !important;
  }
  .translate-banner-toggle:hover {
    background-color: #4a8fc4 !important;
    transform: scale(1.1) !important;
    box-shadow: 0 4px 12px rgba(94, 161, 216, 0.4) !important;
  }
  .translate-banner-toggle:active {
    transform: scale(0.95) !important;
  }
  .translate-banner-toggle::before {
    content: "▼" !important;
    display: block !important;
    transition: transform 0.3s ease !important;
  }
  .translate-banner-toggle.collapsed::before {
    content: "▲" !important;
  }
  body:has(.goog-te-banner-frame:not(.translate-collapsed)) .translate-banner-toggle,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)) .translate-banner-toggle {
    display: flex !important;
    top: 74px !important;
  }
  body:has(.goog-te-banner-frame.translate-collapsed) .translate-banner-toggle,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed) .translate-banner-toggle {
    display: flex !important;
    top: 14px !important;
  }
  .translate-toggle-button {
    position: fixed !important;
    top: 14px !important;
    right: 20px !important;
    width: 36px !important;
    height: 36px !important;
    background-color: var(--fc-brand, #5ea1d8) !important;
    color: #ffffff !important;
    border: none !important;
    border-radius: 50% !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 1005 !important;
    box-shadow: 0 2px 8px rgba(94, 161, 216, 0.3) !important;
    transition: all 0.3s ease !important;
    font-size: 14px !important;
    line-height: 1 !important;
    padding: 0 !important;
  }
  .translate-toggle-button:hover {
    background-color: #4a8fc4 !important;
    transform: scale(1.1) !important;
    box-shadow: 0 4px 12px rgba(94, 161, 216, 0.4) !important;
  }
  .translate-toggle-button:active {
    transform: scale(0.95) !important;
  }
  .translate-toggle-button::before {
    content: "▼" !important;
    display: block !important;
    transition: transform 0.3s ease !important;
    font-size: 14px !important;
  }
  .translate-toggle-button.collapsed::before {
    content: "▲" !important;
    transform: rotate(0deg) !important;
  }
  .translate-toggle-button.collapsed {
    top: 14px !important;
  }
  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed,
  .goog-te-banner-frame.translate-collapsed {
    height: 0 !important;
    min-height: 0 !important;
    max-height: 0 !important;
    opacity: 0 !important;
    visibility: hidden !important;
    display: none !important;
    border-bottom: none !important;
    overflow: hidden !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  body:has(.translate-collapsed) .app-header,
  body:has(iframe.translate-collapsed) .app-header,
  body:has(.goog-te-banner-frame.translate-collapsed) .app-header {
    margin-top: 0 !important;
    top: 0 !important;
  }
  body:has(.translate-collapsed),
  body:has(iframe.translate-collapsed),
  body:has(.goog-te-banner-frame.translate-collapsed) {
    padding-top: 0 !important;
  }
  body:has(.translate-collapsed) .app-main-content,
  body:has(iframe.translate-collapsed) .app-main-content,
  body:has(.goog-te-banner-frame.translate-collapsed) .app-main-content {
    padding-top: 56px !important;
  }
  body:has(.legal-page) .app-main-content,
  body:has(app-legal-center-layout) .app-main-content {
    padding-top: 0px !important;
  }
  body:has(.translate-collapsed) .app-sidebar,
  body:has(iframe.translate-collapsed) .app-sidebar,
  body:has(.goog-te-banner-frame.translate-collapsed) .app-sidebar {
    top: 56px !important;
    height: calc(100vh - 56px) !important;
  }
  .goog-te-banner-frame skipptr {
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
    padding: 16px !important;
    padding-bottom: max(16px, env(safe-area-inset-bottom)) !important;
    min-height: 60px !important;
    max-height: 300px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
    visibility: visible !important;
    opacity: 1 !important;
    text-align: right !important;
  }
  .goog-te-banner-frame skipptr * {
    color: #212529 !important;
    font-family: "Raleway", "Roboto", "Arial", sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 1.5 !important;
    text-align: right !important;
  }
  .goog-te-banner-frame skipptr a,
  .goog-te-banner-frame skipptr button {
    color: var(--fc-brand, #5ea1d8) !important;
    text-decoration: none !important;
    transition: color 0.2s ease !important;
    text-align: right !important;
  }
  .goog-te-banner-frame skipptr a:hover,
  .goog-te-banner-frame skipptr button:hover {
    color: #4a8fc4 !important;
    text-decoration: underline !important;
  }
  .goog-te-menu-frame {
    border-radius: 8px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid #e0e0e0 !important;
    overflow: hidden !important;
  }
  .goog-te-menu-frame .goog-te-menu2 {
    background-color: #ffffff !important;
    border-radius: 8px !important;
  }
  .goog-te-menu-frame .goog-te-menu2 .goog-te-menu2-item {
    padding: 10px 16px !important;
    color: #212529 !important;
    font-family: "Raleway", "Roboto", sans-serif !important;
    font-size: 14px !important;
    transition: background-color 0.2s ease !important;
  }
  .goog-te-menu-frame .goog-te-menu2 .goog-te-menu2-item:hover {
    background-color: #f0f7ff !important;
    color: var(--fc-brand, #5ea1d8) !important;
  }
  .goog-te-menu-frame .goog-te-menu2 .goog-te-menu2-item.goog-te-menu2-item-selected {
    background-color: var(--fc-brand, #5ea1d8) !important;
    color: #ffffff !important;
    font-weight: 600 !important;
  }
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd[style*="visibility:visible"]) .goog-te-banner-frame {
    background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%) !important;
    border-top: 2px solid var(--fc-brand, #5ea1d8) !important;
  }
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd[style*="visibility:visible"]) .goog-te-banner-frame skipptr * {
    color: #212529 !important;
    font-family: "Raleway", "Roboto", sans-serif !important;
  }
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd[style*="visibility:visible"]) .goog-te-banner-frame skipptr *:first-child {
    font-weight: 600 !important;
    color: var(--fc-brand, #5ea1d8) !important;
  }
  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd {
    transition: all 0.3s ease !important;
  }
  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd[style*="visibility:visible"]:hover {
    box-shadow: 0 -6px 20px rgba(94, 161, 216, 0.25) !important;
  }
  body:has(iframe.skiptranslate:not(.translate-collapsed)) .app-header,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)) .app-header,
  body:has(iframe[class*=skiptranslate]:not(.translate-collapsed)) .app-header,
  body:has(iframe[id*=container]:not(.translate-collapsed)) .app-header,
  body:has(iframe[class*=VIpgJd]:not(.translate-collapsed)) .app-header,
  body:has(.goog-te-banner-frame:not(.translate-collapsed)) .app-header {
    margin-top: 0 !important;
    top: 0 !important;
  }
  body:has(iframe.skiptranslate.translate-collapsed) .app-header,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed) .app-header,
  body:has(iframe[class*=skiptranslate].translate-collapsed) .app-header,
  body:has(iframe[id*=container].translate-collapsed) .app-header,
  body:has(iframe[class*=VIpgJd].translate-collapsed) .app-header,
  body:has(.goog-te-banner-frame.translate-collapsed) .app-header {
    margin-top: 0 !important;
    top: 0 !important;
  }
  body:has(iframe.skiptranslate:not(.translate-collapsed)),
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)),
  body:has(iframe[class*=skiptranslate]:not(.translate-collapsed)),
  body:has(iframe[class*=VIpgJd]:not(.translate-collapsed)),
  body:has(.goog-te-banner-frame:not(.translate-collapsed)) {
    padding-bottom: 0 !important;
  }
  body:has(iframe.skiptranslate.translate-collapsed),
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed),
  body:has(iframe[class*=skiptranslate].translate-collapsed),
  body:has(iframe[class*=VIpgJd].translate-collapsed),
  body:has(.goog-te-banner-frame.translate-collapsed) {
    padding-bottom: 0 !important;
  }
  body:has(iframe.skiptranslate:not(.translate-collapsed)) .app-main-content,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)) .app-main-content,
  body:has(iframe[class*=skiptranslate]:not(.translate-collapsed)) .app-main-content,
  body:has(iframe[id*=container]:not(.translate-collapsed)) .app-main-content,
  body:has(iframe[class*=VIpgJd]:not(.translate-collapsed)) .app-main-content,
  body:has(.goog-te-banner-frame:not(.translate-collapsed)) .app-main-content {
    padding-top: 56px !important;
    padding-bottom: 0 !important;
  }
  body:has(iframe.skiptranslate.translate-collapsed) .app-main-content,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed) .app-main-content,
  body:has(iframe[class*=skiptranslate].translate-collapsed) .app-main-content,
  body:has(iframe[id*=container].translate-collapsed) .app-main-content,
  body:has(iframe[class*=VIpgJd].translate-collapsed) .app-main-content,
  body:has(.goog-te-banner-frame.translate-collapsed) .app-main-content {
    padding-top: 56px !important;
    padding-bottom: 0 !important;
  }
  body:has(.legal-page) .app-main-content,
  body:has(app-legal-center-layout) .app-main-content {
    padding-top: 0px !important;
  }
  body:has(iframe.skiptranslate:not(.translate-collapsed)) .app-sidebar,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)) .app-sidebar,
  body:has(iframe[class*=skiptranslate]:not(.translate-collapsed)) .app-sidebar,
  body:has(iframe[id*=container]:not(.translate-collapsed)) .app-sidebar,
  body:has(iframe[class*=VIpgJd]:not(.translate-collapsed)) .app-sidebar,
  body:has(.goog-te-banner-frame:not(.translate-collapsed)) .app-sidebar {
    top: 56px !important;
    height: calc(100vh - 56px) !important;
  }
  body:has(iframe.skiptranslate.translate-collapsed) .app-sidebar,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed) .app-sidebar,
  body:has(iframe[class*=skiptranslate].translate-collapsed) .app-sidebar,
  body:has(iframe[id*=container].translate-collapsed) .app-sidebar,
  body:has(iframe[class*=VIpgJd].translate-collapsed) .app-sidebar,
  body:has(.goog-te-banner-frame.translate-collapsed) .app-sidebar {
    top: 56px !important;
    height: calc(100vh - 56px) !important;
  }
  iframe.skiptranslate ~ * .app-header,
  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd ~ * .app-header,
  iframe[class*=skiptranslate] ~ * .app-header,
  iframe[class*=VIpgJd] ~ * .app-header,
  .goog-te-banner-frame ~ * .app-header {
    position: sticky !important;
    top: 0 !important;
  }
  body:has(.goog-te-banner-frame),
  html:has(.goog-te-banner-frame) {
    padding-top: 0 !important;
  }
  body:has(.goog-te-banner-frame) {
    position: relative !important;
  }
  body iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,
  html body iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,
  body iframe[class*=VIpgJd-ZVi9od-ORHb-OEVmcd],
  html body iframe[class*=VIpgJd-ZVi9od-ORHb-OEVmcd],
  body iframe.skiptranslate,
  html body iframe.skiptranslate,
  body iframe[class*=skiptranslate],
  html body iframe[class*=skiptranslate],
  body iframe[class*=VIpgJd],
  html body iframe[class*=VIpgJd],
  body iframe[id*=container],
  html body iframe[id*=container] {
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    left: auto !important;
    right: 0 !important;
    width: auto !important;
    max-width: 400px !important;
    margin: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    transform: none !important;
  }
  html body iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not([style*="display: none"]),
  html body iframe[class*=VIpgJd-ZVi9od-ORHb-OEVmcd]:not([style*="display: none"]),
  html body iframe.skiptranslate:not([style*="display: none"]),
  html body iframe[class*=skiptranslate]:not([style*="display: none"]),
  html body iframe[class*=VIpgJd]:not([style*="display: none"]),
  html body iframe[id*=container]:not([style*="display: none"]),
  html body iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,
  html body iframe[class*=VIpgJd-ZVi9od-ORHb-OEVmcd],
  html body iframe.skiptranslate,
  html body iframe[class*=skiptranslate],
  html body iframe[class*=VIpgJd],
  html body iframe[id*=container] {
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding: 0 !important;
    padding-top: 0 !important;
    transform: none !important;
    z-index: 1001 !important;
    vertical-align: baseline !important;
  }
}
@media (max-width: 955px) {
  #google_translate_element {
    position: fixed !important;
    top: 56px !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1000 !important;
    background-color: #ffffff !important;
    padding: 8px !important;
    border-bottom: 1px solid #e0e0e0 !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  }
  #google_translate_element .goog-te-gadget {
    width: 100% !important;
  }
  #google_translate_element .goog-te-gadget-simple {
    width: 100% !important;
    justify-content: center !important;
  }
  .goog-te-banner-frame {
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1001 !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 60px !important;
    max-height: 300px !important;
    margin-bottom: 0 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
    visibility: visible !important;
    opacity: 1 !important;
    display: block !important;
  }
  .goog-te-menu-frame {
    max-width: 100% !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
  .goog-te-menu-frame .goog-te-menu2 {
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
  #google_translate_element_mobile .goog-te-menu-frame,
  .mobile-translate-container .goog-te-menu-frame {
    max-height: 60vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
  .chatbot-stickyfooter {
    z-index: 1002 !important;
    position: fixed !important;
    bottom: 0 !important;
    transition: bottom 0.3s ease !important;
  }
  body:has(.goog-te-banner-frame:not([style*="display: none"])) .chatbot-stickyfooter,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not([style*="display: none"])) .chatbot-stickyfooter {
    bottom: 60px !important;
  }
  .chatbot-wrapper {
    z-index: 1002 !important;
    transition: bottom 0.3s ease !important;
  }
  body:has(.goog-te-banner-frame:not([style*="display: none"])) .chatbot-wrapper,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not([style*="display: none"])) .chatbot-wrapper {
    bottom: 60px !important;
  }
  body:has(.dialoguebox) .chatbot-wrapper,
  body:has(.dialoguebox) .chatbot-btn,
  body:has(.dialoguebox) .chatbot-stickyfooter,
  body:has(.cdk-overlay-pane) .chatbot-wrapper,
  body:has(.cdk-overlay-pane) .chatbot-btn,
  body:has(.cdk-overlay-pane) .chatbot-stickyfooter,
  body:has(.cdk-overlay-backdrop) .chatbot-wrapper,
  body:has(.cdk-overlay-backdrop) .chatbot-btn,
  body:has(.cdk-overlay-backdrop) .chatbot-stickyfooter {
    display: none !important;
  }
  iframe.skiptranslate,
  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,
  iframe[class*=skiptranslate],
  iframe[id*=container] {
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1001 !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 60px !important;
    max-height: 300px !important;
    margin-bottom: 0 !important;
    visibility: visible !important;
    opacity: 1 !important;
    display: block !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
  }
  .goog-te-banner-frame skipptr {
    background-color: #ffffff !important;
    border-top: 1px solid #e0e0e0 !important;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
    padding: 16px !important;
    padding-bottom: max(16px, env(safe-area-inset-bottom)) !important;
    min-height: 60px !important;
    max-height: 300px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .goog-te-banner-frame > * {
    max-height: 100% !important;
    overflow-y: auto !important;
  }
  body:has(iframe.skiptranslate) .app-main-content,
  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd) .app-main-content,
  body:has(iframe[class*=skiptranslate]) .app-main-content,
  body:has(iframe[id*=container]) .app-main-content {
    padding-bottom: 180px !important;
  }
  body:has(.goog-te-banner-frame) .app-main-content {
    padding-top: 0 !important;
    padding-bottom: 180px !important;
  }
  .mobile-translate-floating-btn {
    position: fixed !important;
    bottom: 40px !important;
    right: 16px !important;
    width: 50px !important;
    height: 50px !important;
    border-radius: 50% !important;
    background-color: var(--fc-brand, #5ea1d8) !important;
    color: #ffffff !important;
    border: none !important;
    outline: none !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    cursor: pointer !important;
    z-index: 900 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 0.3s ease !important;
    visibility: visible !important;
    opacity: 1 !important;
    padding: 0 !important;
    padding-bottom: max(20px, env(safe-area-inset-bottom)) !important;
    margin: 0 !important;
    min-width: 50px !important;
    max-width: 50px !important;
    min-height: 50px !important;
    max-height: 50px !important;
    box-sizing: border-box !important;
  }
  .mobile-translate-floating-btn mat-icon {
    font-size: 24px !important;
    width: 24px !important;
    height: 24px !important;
    margin: 0 auto !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #ffffff !important;
    line-height: 1 !important;
    border: none !important;
    outline: none !important;
  }
  .mobile-translate-floating-btn .selected-language-badge {
    display: none !important;
  }
  .mobile-translate-floating-btn:hover {
    background-color: #4a8fc4 !important;
    transform: scale(1.05) !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
  }
  .mobile-translate-floating-btn:active {
    transform: scale(0.95) !important;
  }
  body:has(.dialoguebox) .mobile-translate-floating-btn {
    display: none !important;
  }
  .mobile-translate-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1002;
    background-color: transparent;
    border-radius: 0;
    width: 100%;
    min-height: 0;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    pointer-events: none;
  }
  .mobile-translate-container.expanded {
    min-height: 80px;
    max-height: 400px;
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: auto;
    padding: 16px;
    padding-bottom: 76px;
    background-color: #ffffff;
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    display: block !important;
  }
  .mobile-translate-container.expanded * {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .mobile-translate-container.expanded .goog-te-gadget {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .mobile-translate-container.expanded .goog-te-gadget-simple {
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .mobile-translate-container.expanded .goog-te-combo {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .mobile-translate-container.expanded #google_translate_element_mobile {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    min-height: 40px;
  }
  .mobile-translate-container .goog-te-gadget {
    font-family: "Roboto", "Arial", sans-serif !important;
    font-size: 14px !important;
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
  }
  .mobile-translate-container .goog-te-gadget-simple {
    background-color: transparent !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    border-radius: 8px !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
    color: #000000 !important;
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    margin: 0 !important;
  }
  .mobile-translate-container .goog-te-menu-value {
    color: #000000 !important;
  }
  .mobile-translate-container #google_translate_element_mobile {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .mobile-translate-container #google_translate_element_mobile * {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .mobile-translate-container #google_translate_element_mobile .goog-te-gadget {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    width: 100% !important;
  }
  .mobile-translate-container #google_translate_element_mobile .goog-te-gadget-simple {
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    width: 100% !important;
  }
  .mobile-translate-container #google_translate_element_mobile .goog-te-menu-value {
    display: inline-block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  .mobile-translate-container .goog-te-menu-frame {
    max-width: 100% !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
  .mobile-translate-container .goog-te-menu-frame .goog-te-menu2 {
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
}
.header-icon {
  background: none;
  border: none;
  color: #000000;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.2s;
}

.header-icon:hover {
  background-color: #f0f0f0;
}

.theme-toggle-button {
  border-radius: 999px;
  padding: 2px;
  background: transparent;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.theme-toggle-button:focus,
.theme-toggle-button:active,
.theme-toggle-button:focus-visible {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.theme-toggle-button:hover {
  background: transparent;
}

.theme-toggle-track {
  width: 48px;
  height: 26px;
  border-radius: 999px;
  background: #e5e7eb;
  border: none;
  outline: none !important;
  box-shadow: none !important;
  display: inline-flex;
  align-items: center;
  padding: 1px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.theme-toggle-track.active {
  background: #1f2937;
  border: none;
  outline: none !important;
  box-shadow: none !important;
}

.theme-toggle-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateX(0);
  transition: transform 0.2s ease, color 0.2s ease;
}

.theme-toggle-track.active .theme-toggle-thumb {
  transform: translateX(22px);
  color: #f8fafc;
  background: #0f172a;
}

.theme-toggle-thumb mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.notification-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: #ff0000;
  color: transparent;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  font-size: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: relative;
}
.profile-button:focus, .profile-button:active, .profile-button:focus-visible {
  outline: none;
  border: none;
}
.profile-button mat-icon {
  outline: none;
  transition: box-shadow 0.2s ease;
  border-radius: 50%;
}
.profile-button mat-icon:focus, .profile-button mat-icon:active, .profile-button mat-icon:focus-visible {
  outline: none;
  border: none;
}

.profile-image {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  transition: box-shadow 0.2s ease;
}

.profile-button:focus .profile-image,
.profile-button:active .profile-image,
.profile-button.cdk-focused .profile-image,
.profile-button[aria-expanded=true] .profile-image,
.profile-button.mat-mdc-menu-trigger[aria-expanded=true] .profile-image,
.profile-button.active-profile .profile-image {
  box-shadow: 0 0 0 3px var(--fc-brand, #5ea1d8);
}

.profile-button:focus mat-icon,
.profile-button:active mat-icon,
.profile-button.cdk-focused mat-icon,
.profile-button[aria-expanded=true] mat-icon,
.profile-button.mat-mdc-menu-trigger[aria-expanded=true] mat-icon,
.profile-button.active-profile mat-icon {
  box-shadow: 0 0 0 3px var(--fc-brand, #5ea1d8);
  border-radius: 50%;
}

@media (max-width: 768px) {
  .profile-button:focus .profile-image, .profile-button:active .profile-image, .profile-button.cdk-focused .profile-image, .profile-button[aria-expanded=true] .profile-image, .profile-button.mat-mdc-menu-trigger[aria-expanded=true] .profile-image, .profile-button.active-profile .profile-image {
    box-shadow: 0 0 0 3px var(--fc-brand, #5ea1d8);
  }
  .profile-button:focus mat-icon, .profile-button:active mat-icon, .profile-button.cdk-focused mat-icon, .profile-button[aria-expanded=true] mat-icon, .profile-button.mat-mdc-menu-trigger[aria-expanded=true] mat-icon, .profile-button.active-profile mat-icon {
    box-shadow: 0 0 0 3px var(--fc-brand, #5ea1d8);
    border-radius: 50%;
  }
}
.app-sidebar {
  position: fixed;
  left: 0;
  top: 56px;
  width: 240px;
  height: calc(100vh - 56px);
  background-color: #ffffff;
  border-right: 1px solid #e0e0e0;
  overflow-y: auto;
  transition: transform 0.3s ease;
  z-index: 999;
}

.about-us-page ~ .app-sidebar,
.how-it-works-page ~ .app-sidebar,
.faq-support-page ~ .app-sidebar,
body:has(.about-us-page) .app-sidebar,
body:has(.how-it-works-page) .app-sidebar,
body:has(.faq-support-page) .app-sidebar {
  top: 0 !important;
  height: 100vh !important;
  z-index: 1001 !important;
}

.app-sidebar.sidebar-collapsed {
  transform: translateX(-100%);
}

.sidebar-backdrop {
  display: none;
  z-index: 1500;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}
@media (max-width: 768px) {
  .sidebar-backdrop {
    display: block;
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
}
.sidebar-backdrop.show {
  opacity: 1;
  pointer-events: auto;
}

@media (max-width: 768px) {
  body:has(.about-us-page) .sidebar-backdrop,
  body:has(.how-it-works-page) .sidebar-backdrop,
  body:has(.faq-support-page) .sidebar-backdrop {
    top: 0 !important;
  }
}

.sidebar-content {
  padding: 12px 0;
}

.sidebar-section {
  margin-bottom: 16px;
}
.sidebar-section .sidebar-section-header {
  padding: 8px 24px 4px;
  margin-bottom: 4px;
}
.sidebar-section .sidebar-section-header h3 {
  font-size: 11px;
  font-weight: 500;
  color: #606060;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
  padding: 0;
}

.sidebar-account-type {
  padding: 0 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-account-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #212427;
  cursor: pointer;
  text-align: left;
}
.sidebar-account-option mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #606060;
  transition: color 0.15s ease;
}
.sidebar-account-option:hover:not(.sidebar-account-option--active) {
  background: rgba(94, 161, 216, 0.08);
}
.sidebar-account-option:hover:not(.sidebar-account-option--active) mat-icon {
  color: var(--fc-brand, #5ea1d8);
}
.sidebar-account-option:hover:not(.sidebar-account-option--active) .sidebar-account-option-name {
  color: #1a3d5c;
}
.sidebar-account-option--active {
  background: rgba(94, 161, 216, 0.12);
  border-color: rgba(94, 161, 216, 0.35);
}
.sidebar-account-option--active mat-icon {
  color: var(--fc-brand, #5ea1d8);
}
.sidebar-account-option--active .sidebar-account-option-name {
  font-weight: 600;
}
.sidebar-account-option--active:hover mat-icon {
  color: var(--fc-brand, #5ea1d8);
}

.sidebar-account-option-text {
  flex: 1;
  min-width: 0;
}

.sidebar-account-option-name {
  display: block;
  font-size: 13px;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-account-option-role {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.2;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-account-option--active .sidebar-account-option-role {
  color: #3d7aad;
  font-weight: 500;
}

.sidebar-account-option-check {
  color: var(--fc-brand, #5ea1d8) !important;
  flex-shrink: 0;
}

.header-org-role {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 140px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.14);
  border: 1px solid rgba(94, 161, 216, 0.35);
  color: #2f5f82;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}
.header-org-role mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: inherit;
}

.header-org-role-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-menu {
  min-width: 240px;
}

::ng-deep .profile-menu .profile-menu-account-trigger .menu-account-current,
::ng-deep .mat-mdc-menu-panel.profile-menu .menu-account-current,
::ng-deep .profile-menu .profile-menu-role-row .menu-account-current,
::ng-deep .mat-mdc-menu-panel.profile-menu .profile-menu-role-row .menu-account-current {
  margin-left: auto;
  padding-left: 12px;
  font-size: 12px;
  color: #6b7280;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::ng-deep .profile-menu .profile-menu-role-row,
::ng-deep .mat-mdc-menu-panel.profile-menu .profile-menu-role-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 40px;
  padding: 0 16px;
  color: #374151;
  font-size: 14px;
  pointer-events: none;
}
::ng-deep .profile-menu .profile-menu-role-row mat-icon,
::ng-deep .mat-mdc-menu-panel.profile-menu .profile-menu-role-row mat-icon {
  color: #3d7aad;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
::ng-deep .profile-menu .profile-menu-role-row .menu-account-current,
::ng-deep .mat-mdc-menu-panel.profile-menu .profile-menu-role-row .menu-account-current {
  color: #1a3d5c;
  font-weight: 600;
}

::ng-deep .mat-mdc-menu-panel.account-type-submenu,
::ng-deep .mat-menu-panel.account-type-submenu {
  min-width: 280px;
  max-width: 320px;
}

::ng-deep .account-type-submenu .account-type-menu-item,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item {
  display: flex !important;
  align-items: center !important;
  gap: 10px;
  height: auto !important;
  min-height: 48px !important;
  line-height: 1.2 !important;
  padding: 10px 14px 10px 12px !important;
  position: relative;
  /* Keep only the leading icon in Material's icon slot; badge is not an icon. */
}
::ng-deep .account-type-submenu .account-type-menu-item .account-type-menu-leading.mat-icon,
::ng-deep .account-type-submenu .account-type-menu-item .mat-icon.account-type-menu-leading,
::ng-deep .account-type-submenu .account-type-menu-item mat-icon.account-type-menu-leading,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item .account-type-menu-leading.mat-icon,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item .mat-icon.account-type-menu-leading,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item mat-icon.account-type-menu-leading,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item .account-type-menu-leading.mat-icon,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item .mat-icon.account-type-menu-leading,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item mat-icon.account-type-menu-leading {
  flex-shrink: 0;
  margin-right: 0 !important;
  color: #606060;
  transition: color 0.15s ease;
}
::ng-deep .account-type-submenu .account-type-menu-item:hover,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item:hover,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item:hover {
  background: rgba(94, 161, 216, 0.1) !important;
}
::ng-deep .account-type-submenu .account-type-menu-item:hover .account-type-menu-leading.mat-icon,
::ng-deep .account-type-submenu .account-type-menu-item:hover .mat-icon.account-type-menu-leading,
::ng-deep .account-type-submenu .account-type-menu-item:hover mat-icon.account-type-menu-leading,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item:hover .account-type-menu-leading.mat-icon,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item:hover .mat-icon.account-type-menu-leading,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item:hover mat-icon.account-type-menu-leading,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item:hover .account-type-menu-leading.mat-icon,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item:hover .mat-icon.account-type-menu-leading,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item:hover mat-icon.account-type-menu-leading {
  color: #3d7aad;
}
::ng-deep .account-type-submenu .account-type-menu-item:hover .account-type-menu-name,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item:hover .account-type-menu-name,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item:hover .account-type-menu-name {
  color: #1a3d5c;
}
::ng-deep .account-type-submenu .account-type-menu-item .account-type-menu-text,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item .account-type-menu-text,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item .account-type-menu-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  padding-right: 4px;
}
::ng-deep .account-type-submenu .account-type-menu-item .account-type-menu-name,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item .account-type-menu-name,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item .account-type-menu-name {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #212427;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .account-type-submenu .account-type-menu-item .account-type-menu-desc,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item .account-type-menu-desc,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item .account-type-menu-desc {
  display: block;
  font-size: 11px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .account-type-submenu .account-type-menu-item .account-type-selected-badge,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item .account-type-selected-badge,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item .account-type-selected-badge {
  flex: 0 0 auto;
  margin-left: auto;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #2f5f82;
  background: rgba(94, 161, 216, 0.22);
  border: 1px solid rgba(94, 161, 216, 0.35);
  line-height: 1.2;
  white-space: nowrap;
}
::ng-deep .account-type-submenu .account-type-menu-item.account-type-menu-item--active,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active {
  background: rgba(94, 161, 216, 0.1);
}
::ng-deep .account-type-submenu .account-type-menu-item.account-type-menu-item--active .account-type-menu-name,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active .account-type-menu-name,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active .account-type-menu-name {
  font-weight: 600;
}
::ng-deep .account-type-submenu .account-type-menu-item.account-type-menu-item--active .account-type-menu-leading.mat-icon,
::ng-deep .account-type-submenu .account-type-menu-item.account-type-menu-item--active .mat-icon.account-type-menu-leading,
::ng-deep .account-type-submenu .account-type-menu-item.account-type-menu-item--active mat-icon.account-type-menu-leading,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active .account-type-menu-leading.mat-icon,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active .mat-icon.account-type-menu-leading,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active mat-icon.account-type-menu-leading,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active .account-type-menu-leading.mat-icon,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active .mat-icon.account-type-menu-leading,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active mat-icon.account-type-menu-leading {
  color: #3d7aad;
}
::ng-deep .account-type-submenu .account-type-menu-item.account-type-menu-item--active:hover,
::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active:hover,
::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item.account-type-menu-item--active:hover {
  background: rgba(94, 161, 216, 0.16) !important;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  padding: 10px 24px;
  background: none;
  border: none;
  color: #212427;
  cursor: pointer;
  font-size: 14px;
  outline: none;
  border-radius: 8px;
  font-weight: 400;
  text-align: left;
  transition: background-color 0.2s ease;
  border-radius: 0;
}
.sidebar-item:focus, .sidebar-item:active, .sidebar-item:focus-visible {
  outline: none;
  border: none;
  box-shadow: none;
}
.sidebar-item.active {
  background: #e3f2fd;
  color: #0b3c61;
  font-weight: 600;
}
.sidebar-item:hover {
  background-color: #f0f0f0;
}
.sidebar-item.active {
  background-color: #f0f0f0;
  font-weight: 500;
}
.sidebar-item mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #212427;
}
.sidebar-item .bundle-menu-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.sidebar-item span {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-main-content {
  margin-left: 240px;
  background-color: #ffffff;
  min-height: 100vh;
  transition: margin-left 0.3s ease;
  padding-top: 56px; /* start content immediately below fixed header */
}

/* Leave room so content is not hidden behind the fixed platform footer. */
.app-layout:has(.flowchest-platform-footer) .app-main-content {
  padding-bottom: 3rem;
}

body:has(.about-us-page) .app-main-content,
body:has(.how-it-works-page) .app-main-content,
body:has(.faq-support-page) .app-main-content,
body:has(.legal-page) .app-main-content,
body:has(app-legal-center-layout) .app-main-content,
.app-main-content:has(.legal-page),
.app-main-content:has(app-legal-center-layout) {
  padding-top: 0px !important;
  margin-left: 0 !important;
  background-color: transparent !important;
  background: transparent !important;
}

body:has(.about-us-page) .page-header,
body:has(.how-it-works-page) .page-header,
body:has(.faq-support-page) .page-header {
  margin-top: 0 !important;
}

body:has(.about-us-page) .main-container,
body:has(.how-it-works-page) .main-container,
body:has(.faq-support-page) .main-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Full-width routes (dashboards, settings, profiles) should not reserve sidebar space */
.app-main-content.sidebar-overlay {
  margin-left: 0;
  padding-top: 56px; /* keep consistent top offset on full-width routes */
}

body:has(.legal-page) .app-main-content.sidebar-overlay,
body:has(app-legal-center-layout) .app-main-content.sidebar-overlay {
  padding-top: 0px !important;
}

/* Mobile search box when active in header */
.mobile-search-box-in-header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;
  z-index: 1001;
}

.mobile-search-box-in-header .mobile-search-field {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  overflow: visible;
  gap: 4px;
  height: 100%;
}

.mobile-search-box-in-header .mobile-search-field mat-chip-grid {
  flex: 0 1 auto;
  max-width: 45%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.mobile-search-box-in-header .mobile-search-field mat-chip-grid::-webkit-scrollbar {
  display: none;
}

.mobile-search-box-in-header .mobile-search-field mat-chip-row {
  display: inline-flex;
}

.mobile-search-box-in-header .mobile-search-field .app-search-input {
  flex: 1;
  min-width: 80px;
  padding: 8px 12px;
  padding-right: 8px;
  border: none;
  border-radius: 0;
  font-size: 16px;
  background: transparent;
  color: #111827;
  height: 32px;
  outline: none;
}

.mobile-search-box-in-header .mobile-search-field .cancel-icon-button,
.mobile-search-box-in-header .mobile-search-field .search-icon-button {
  flex-shrink: 0;
  padding: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606060;
}

.mobile-search-box-in-header .mobile-search-field .cancel-icon-button:hover,
.mobile-search-box-in-header .mobile-search-field .search-icon-button:hover {
  background: transparent;
}

.mobile-search-box-in-header .mobile-search-field .cancel-icon-button mat-icon,
.mobile-search-box-in-header .mobile-search-field .search-icon-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

/* Mobile search container when active */
.app-search-container.mobile-search-active {
  flex: 1;
  margin: 0 8px;
  min-width: 0;
  position: relative;
  overflow: visible; /* Allow dropdown to show */
  z-index: 1001; /* Ensure it's above header */
}

.mobile-search-field .cancel-icon-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: #666666;
  border-radius: 50%;
  transition: color 0.2s, background-color 0.2s;
  flex-shrink: 0;
}
.mobile-search-field .cancel-icon-button:hover {
  color: #000000;
  background-color: #f0f0f0;
}

.mobile-search-field .cancel-icon-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.mobile-search-icon-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: #666666;
  border-radius: 50%;
  transition: color 0.2s, background-color 0.2s;
  flex-shrink: 0;
}
.mobile-search-icon-button:hover {
  color: #000000;
  background-color: #f0f0f0;
}
.mobile-search-icon-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.mobile-search-box .cancel-button {
  background: none;
  border: none;
  color: #212427;
  font-size: 14px;
  padding: 6px 8px;
  cursor: pointer;
  margin-left: 4px;
}

.app-main-content.sidebar-collapsed {
  margin-left: 0;
}

.notification-menu {
  max-width: 400px;
  max-height: 500px;
  overflow-y: auto;
}

.notification-menu-section-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
  padding: 8px 16px 4px;
  margin: 0;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 16px 10px 20px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
  transition: background-color 0.15s ease;
  cursor: pointer;
}
.notification-item:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
.notification-item.unread {
  background-color: rgba(6, 95, 212, 0.06);
}
.notification-item.unread::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: #065fd4;
  border-radius: 0 2px 2px 0;
}
.notification-item.unread:hover {
  background-color: rgba(6, 95, 212, 0.1);
}

.notification-unread-dot {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #065fd4;
  flex-shrink: 0;
  pointer-events: none;
}

.notification-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  cursor: pointer;
}

.notification-avatar-icon {
  width: 40px;
  height: 40px;
  font-size: 40px;
  color: #666666;
  flex-shrink: 0;
  cursor: pointer;
}

.notification-content {
  flex: 1;
  min-width: 0;
  cursor: pointer;
}

.notification-message {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #444;
  margin: 0 0 4px 0;
  line-height: 1.5;
  /* Preserve API newlines: title / body / meta on separate lines */
  white-space: pre-line;
}
.notification-message.notification-message--unread {
  font-weight: 600;
  color: #111;
}

.notification-time {
  font-size: 12px;
  color: #888;
}

.notification-menu .notification-thumbnail {
  flex-shrink: 0;
  width: 72px;
  height: 54px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #f9f9f9;
}
.notification-menu .notification-thumbnail .thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.notification-menu .notification-thumbnail--clickable {
  cursor: pointer;
}

body.theme-dark .notification-menu-section-title {
  color: #94a3b8;
}
body.theme-dark .notification-item {
  border-bottom-color: rgba(148, 163, 184, 0.15);
}
body.theme-dark .notification-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}
body.theme-dark .notification-item.unread {
  background-color: rgba(59, 130, 246, 0.14);
}
body.theme-dark .notification-item.unread::before {
  background-color: #60a5fa;
}
body.theme-dark .notification-item.unread:hover {
  background-color: rgba(59, 130, 246, 0.2);
}
body.theme-dark .notification-unread-dot {
  background-color: #60a5fa;
}
body.theme-dark .notification-message {
  color: #cbd5e1;
}
body.theme-dark .notification-message.notification-message--unread {
  font-weight: 600;
  color: #f1f5f9;
}
body.theme-dark .notification-time {
  color: #94a3b8;
}
body.theme-dark .notification-avatar-icon {
  color: #94a3b8;
}
body.theme-dark .notification-menu .notification-thumbnail {
  background-color: #1e293b;
}

::ng-deep .create-flow-menu .mat-mdc-menu-content {
  padding: 8px 0;
  min-width: 280px;
}
::ng-deep .create-flow-menu .mat-mdc-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  min-height: auto;
  height: auto;
}
::ng-deep .create-flow-menu .mat-mdc-menu-item mat-icon {
  color: var(--fc-brand, #5ea1d8);
  font-size: 24px;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
::ng-deep .create-flow-menu .mat-mdc-menu-item .menu-item-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}
::ng-deep .create-flow-menu .mat-mdc-menu-item .menu-item-content .menu-item-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  line-height: 1.2;
}
::ng-deep .create-flow-menu .mat-mdc-menu-item .menu-item-content .menu-item-description {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.2;
  white-space: normal;
}
::ng-deep .create-flow-menu .mat-mdc-menu-item:hover {
  background: #f3f4f6;
}

/* Tablet View */
:root {
  --app-header: 56px;
}

@media (max-width: 1024px) {
  .app-sidebar {
    width: 200px;
  }
  .app-main-content {
    margin-left: 200px;
  }
  .app-search-container {
    max-width: 400px;
    margin: 0 20px;
  }
}
/* Mobile view - app style */
/* Ensure translate button is always visible on mobile */
@media (max-width: 768px) {
  .mobile-translate-floating-btn {
    position: fixed !important;
    bottom: 40px !important;
    right: 16px !important;
    width: 50px !important;
    height: 50px !important;
    border-radius: 50% !important;
    background-color: var(--fc-brand, #5ea1d8) !important;
    color: #ffffff !important;
    border: none !important;
    outline: none !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    visibility: visible !important;
    opacity: 1 !important;
    padding: 0 !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    cursor: pointer !important;
    z-index: 1003 !important;
    margin: 0 !important;
    min-width: 50px !important;
    max-width: 50px !important;
    min-height: 50px !important;
    max-height: 50px !important;
    box-sizing: border-box !important;
  }
  .mobile-translate-floating-btn mat-icon {
    font-size: 24px !important;
    width: 24px !important;
    height: 24px !important;
    color: #ffffff !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    outline: none !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 1 !important;
  }
}
/* Ensure translate button is always visible on desktop - same style as mobile */
@media (min-width: 769px) {
  .mobile-translate-floating-btn {
    position: fixed !important;
    bottom: 40px !important;
    right: 16px !important;
    width: 50px !important;
    height: 50px !important;
    border-radius: 50% !important;
    background-color: var(--fc-brand, #5ea1d8) !important;
    color: #ffffff !important;
    border: none !important;
    outline: none !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    visibility: visible !important;
    opacity: 1 !important;
    z-index: 1003 !important;
  }
  .mobile-translate-floating-btn mat-icon {
    color: #ffffff !important;
    margin: 0 auto !important;
    padding: 0 !important;
    border: none !important;
    outline: none !important;
  }
  .mobile-translate-container {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1002 !important;
  }
  .mobile-translate-container.expanded {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  body:has(.goog-te-banner-frame) .mobile-translate-floating-btn,
  body:has(iframe.skiptranslate) .mobile-translate-floating-btn {
    position: fixed !important;
    bottom: 40px !important;
    right: 16px !important;
    width: 50px !important;
    height: 50px !important;
    border-radius: 50% !important;
    background-color: var(--fc-brand, #5ea1d8) !important;
    color: #ffffff !important;
    border: none !important;
    outline: none !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  body:has(.goog-te-banner-frame) .mobile-translate-floating-btn mat-icon,
  body:has(iframe.skiptranslate) .mobile-translate-floating-btn mat-icon {
    color: #ffffff !important;
    margin: 0 auto !important;
    padding: 0 !important;
    border: none !important;
    outline: none !important;
  }
}
/* Mobile view - app style */
@media (max-width: 768px) {
  .app-header {
    padding: 0 8px;
    height: 56px;
    -moz-column-gap: 8px;
         column-gap: 8px; /* tighten gaps to avoid crowding */
    box-sizing: border-box;
  }
  .app-logo img {
    height: 35px;
    display: block; /* prevent inline baseline shift */
  }
  .app-search-container {
    max-width: none;
    margin: 0 4px; /* tighter to increase available width */
    flex: 1 1 auto;
    min-width: 0; /* Allow flex shrinking */
    overflow: hidden; /* Prevent content from overflowing */
  }
  .app-header-left {
    gap: 8px;
    flex-shrink: 0; /* Prevent left section from shrinking */
  }
  .app-header-right {
    gap: 6px;
    align-items: center;
    flex-shrink: 0; /* Prevent right section from shrinking */
  }
  /* Keep role discoverable via profile menu on small screens. */
  .header-org-role {
    max-width: 34px;
    padding: 4px 6px;
    justify-content: center;
  }
  .header-org-role .header-org-role-text {
    display: none;
  }
  .search-box {
    height: 36px;
    width: auto;
    background: transparent; /* icon only */
    border: none;
    border-radius: 0;
  }
  .mobile-search-box-in-header {
    background: #ffffff;
    border: 1px solid #d0d0d0;
    border-radius: 24px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    overflow: visible;
  }
  .mobile-search-box-in-header.search-box-focused {
    border-color: #1a73e8;
  }
  .search-button {
    background: transparent;
    -webkit-appearance: none;
    box-shadow: none;
  }
  .app-search-input {
    font-size: 16px;
    padding: 0 12px;
  }
  .search-button {
    padding: 8px 12px;
    background: transparent;
    -webkit-appearance: none;
    box-shadow: none;
  }
  .header-icon {
    padding: 6px;
  }
  .profile-image {
    width: 28px;
    height: 28px;
  }
  .menu-button {
    padding: 6px;
  }
  /* Sidebar - Hidden by default on mobile */
  .app-sidebar {
    width: 100%;
    max-width: 280px;
    position: fixed;
    top: 0px;
    left: 0;
    height: calc(100vh - 0px);
    transform: translateX(-100%);
    z-index: 2000;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  }
  .app-sidebar:not(.sidebar-collapsed) {
    transform: translateX(0);
  }
  /* Main content - Full width on mobile */
  .app-main-content {
    margin-left: 0 !important;
    width: 100%;
    padding-bottom: 200px !important;
  }
  body:has(iframe.skiptranslate) .app-main-content, body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd) .app-main-content, body:has(iframe[class*=skiptranslate]) .app-main-content, body:has(iframe[id*=container]) .app-main-content {
    padding-bottom: 250px !important;
  }
  /* Mobile search active styles */
  .app-search-container.mobile-search-active {
    flex: 1;
    margin: 0 8px;
    min-width: 0;
  }
  .mobile-search-box-in-header {
    height: 100%;
  }
  .mobile-search-box-in-header .mobile-search-field {
    height: 36px;
  }
  .mobile-search-box-in-header .mobile-search-field mat-chip-grid {
    max-width: 40vw;
  }
  .mobile-search-box-in-header .mobile-search-field .app-search-input {
    font-size: 16px;
    padding: 8px 12px;
    min-width: 110px;
  }
  .mobile-search-box-in-header .mobile-search-history {
    max-height: calc(100vh - 100px); /* Ensure dropdown doesn't go off screen */
  }
  /* Sidebar item adjustments for mobile */
  .sidebar-item {
    padding: 12px 20px;
    gap: 20px;
    font-size: 16px;
  }
  .sidebar-item mat-icon {
    font-size: 24px;
    width: 24px;
    height: 24px;
  }
}
/* Extra Small Mobile */
@media (max-width: 480px) {
  .app-header {
    padding: 0 4px;
  }
  .app-search-container {
    margin: 0 4px;
  }
  .search-box {
    height: 32px;
  }
  .app-search-input {
    font-size: 16px;
    padding: 0 8px;
  }
  .app-logo img {
    height: 35px;
  }
  .menu-button,
  .header-icon {
    padding: 4px;
  }
  .profile-image {
    width: 24px;
    height: 24px;
  }
  .app-sidebar {
    max-width: 260px;
  }
}
.app-layout.modal-blur {
  filter: blur(5px);
  pointer-events: none;
  transition: filter 0.3s ease-in-out;
}

/* Routed auth page sits under the overlay — hide it so it is not visible behind the modal. */
.app-main-content.hide-behind-auth-modal {
  visibility: hidden;
  pointer-events: none;
}

.auth-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  /* Above cdk-overlay-container (1100) and body:has(.auth-modal-overlay) bump (10050) */
  z-index: 10100;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-in-out;
}

.auth-modal-container {
  position: relative;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  border-radius: 10px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-in-out;
  z-index: 10000;
  margin-top: 0;
}
.auth-modal-container::-webkit-scrollbar {
  width: 8px;
}
.auth-modal-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.auth-modal-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
.auth-modal-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.auth-modal-close {
  position: fixed;
  top: 8px;
  right: 16px;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  cursor: pointer;
  z-index: 10001;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  width: 40px;
  height: 40px;
}
.auth-modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.auth-modal-close mat-icon {
  color: #606060;
  font-size: 24px;
  width: 24px;
  height: 24px;
  transition: color 0.2s ease;
}
.auth-modal-close:hover mat-icon {
  color: #333;
}
@media screen and (max-width: 768px) {
  .auth-modal-close {
    top: 8px;
    right: 12px;
    width: 40px;
    height: 40px;
  }
  .auth-modal-close mat-icon {
    font-size: 24px;
    width: 24px;
    height: 24px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.auth-modal-container {
  padding: 0;
  margin: 0;
  position: relative;
  background: white;
  z-index: 10101;
}
.auth-modal-container app-login,
.auth-modal-container app-registration,
.auth-modal-container app-activateaccount,
.auth-modal-container app-forget-password-modal,
.auth-modal-container app-change-password {
  display: block;
  width: 100%;
  position: relative;
  z-index: 10001;
}
.auth-modal-container app-login .Login,
.auth-modal-container app-registration .Login,
.auth-modal-container app-activateaccount .Login,
.auth-modal-container app-forget-password-modal .Login,
.auth-modal-container app-change-password .Login {
  background-color: white;
  padding: 20px;
  margin: 0;
  width: 100%;
  position: relative;
  z-index: 10001;
}
.auth-modal-container app-login #formContent,
.auth-modal-container app-login .formContent,
.auth-modal-container app-registration #formContent,
.auth-modal-container app-registration .formContent,
.auth-modal-container app-activateaccount #formContent,
.auth-modal-container app-activateaccount .formContent,
.auth-modal-container app-forget-password-modal #formContent,
.auth-modal-container app-forget-password-modal .formContent,
.auth-modal-container app-change-password #formContent,
.auth-modal-container app-change-password .formContent {
  box-shadow: none;
  border: none;
  max-width: 100%;
  padding: 20px;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  background: white;
  position: relative;
  z-index: 10001;
}
.auth-modal-container app-login .fadeIn.first,
.auth-modal-container app-registration .fadeIn.first,
.auth-modal-container app-activateaccount .fadeIn.first,
.auth-modal-container app-forget-password-modal .fadeIn.first,
.auth-modal-container app-change-password .fadeIn.first {
  margin-top: 0;
  padding-top: 0;
}
.auth-modal-container app-login #formFooter,
.auth-modal-container app-registration #formFooter,
.auth-modal-container app-activateaccount #formFooter,
.auth-modal-container app-forget-password-modal #formFooter,
.auth-modal-container app-change-password #formFooter {
  background: transparent !important;
  border-top: none !important;
  padding: 15px 0 0 0;
  margin-top: 15px;
  text-align: center;
}
.auth-modal-container app-login .img-div-left,
.auth-modal-container app-registration .img-div-left,
.auth-modal-container app-activateaccount .img-div-left,
.auth-modal-container app-forget-password-modal .img-div-left,
.auth-modal-container app-change-password .img-div-left {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
}

/* Dark mode: auth modals (Sign In / Sign Up) — readable text + fields */
body.theme-dark .auth-modal-container {
  background: #1f2937 !important;
}
body.theme-dark .auth-modal-container app-login,
body.theme-dark .auth-modal-container app-registration,
body.theme-dark .auth-modal-container app-activateaccount,
body.theme-dark .auth-modal-container app-forget-password-modal,
body.theme-dark .auth-modal-container app-change-password {
  /* “I agree…” checkbox label + trademark copy */
  /* User Type dropdown (mat-form-field / mat-select) */
}
body.theme-dark .auth-modal-container app-login .Login,
body.theme-dark .auth-modal-container app-registration .Login,
body.theme-dark .auth-modal-container app-activateaccount .Login,
body.theme-dark .auth-modal-container app-forget-password-modal .Login,
body.theme-dark .auth-modal-container app-change-password .Login {
  background-color: #1f2937 !important;
  color: #e5e7eb !important;
}
body.theme-dark .auth-modal-container app-login #formContent,
body.theme-dark .auth-modal-container app-login .formContent,
body.theme-dark .auth-modal-container app-registration #formContent,
body.theme-dark .auth-modal-container app-registration .formContent,
body.theme-dark .auth-modal-container app-activateaccount #formContent,
body.theme-dark .auth-modal-container app-activateaccount .formContent,
body.theme-dark .auth-modal-container app-forget-password-modal #formContent,
body.theme-dark .auth-modal-container app-forget-password-modal .formContent,
body.theme-dark .auth-modal-container app-change-password #formContent,
body.theme-dark .auth-modal-container app-change-password .formContent {
  background: #1f2937 !important;
  color: #e5e7eb !important;
  border-color: transparent !important;
}
body.theme-dark .auth-modal-container app-login #formFooter,
body.theme-dark .auth-modal-container app-registration #formFooter,
body.theme-dark .auth-modal-container app-activateaccount #formFooter,
body.theme-dark .auth-modal-container app-forget-password-modal #formFooter,
body.theme-dark .auth-modal-container app-change-password #formFooter {
  background: transparent !important;
  border-top: none !important;
}
body.theme-dark .auth-modal-container app-login p,
body.theme-dark .auth-modal-container app-login .example-margin,
body.theme-dark .auth-modal-container app-login .checkbox-section,
body.theme-dark .auth-modal-container app-login .example-section,
body.theme-dark .auth-modal-container app-registration p,
body.theme-dark .auth-modal-container app-registration .example-margin,
body.theme-dark .auth-modal-container app-registration .checkbox-section,
body.theme-dark .auth-modal-container app-registration .example-section,
body.theme-dark .auth-modal-container app-activateaccount p,
body.theme-dark .auth-modal-container app-activateaccount .example-margin,
body.theme-dark .auth-modal-container app-activateaccount .checkbox-section,
body.theme-dark .auth-modal-container app-activateaccount .example-section,
body.theme-dark .auth-modal-container app-forget-password-modal p,
body.theme-dark .auth-modal-container app-forget-password-modal .example-margin,
body.theme-dark .auth-modal-container app-forget-password-modal .checkbox-section,
body.theme-dark .auth-modal-container app-forget-password-modal .example-section,
body.theme-dark .auth-modal-container app-change-password p,
body.theme-dark .auth-modal-container app-change-password .example-margin,
body.theme-dark .auth-modal-container app-change-password .checkbox-section,
body.theme-dark .auth-modal-container app-change-password .example-section {
  color: #e5e7eb !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-checkbox,
body.theme-dark .auth-modal-container app-login .mat-checkbox,
body.theme-dark .auth-modal-container app-login .mat-mdc-checkbox .mdc-label,
body.theme-dark .auth-modal-container app-login .mat-mdc-checkbox label,
body.theme-dark .auth-modal-container app-login .mat-checkbox-label,
body.theme-dark .auth-modal-container app-login .mat-mdc-checkbox .mdc-form-field > label,
body.theme-dark .auth-modal-container app-registration .mat-mdc-checkbox,
body.theme-dark .auth-modal-container app-registration .mat-checkbox,
body.theme-dark .auth-modal-container app-registration .mat-mdc-checkbox .mdc-label,
body.theme-dark .auth-modal-container app-registration .mat-mdc-checkbox label,
body.theme-dark .auth-modal-container app-registration .mat-checkbox-label,
body.theme-dark .auth-modal-container app-registration .mat-mdc-checkbox .mdc-form-field > label,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-checkbox,
body.theme-dark .auth-modal-container app-activateaccount .mat-checkbox,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-checkbox .mdc-label,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-checkbox label,
body.theme-dark .auth-modal-container app-activateaccount .mat-checkbox-label,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-checkbox .mdc-form-field > label,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-checkbox,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-checkbox,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-checkbox .mdc-label,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-checkbox label,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-checkbox-label,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-checkbox .mdc-form-field > label,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-checkbox,
body.theme-dark .auth-modal-container app-change-password .mat-checkbox,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-checkbox .mdc-label,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-checkbox label,
body.theme-dark .auth-modal-container app-change-password .mat-checkbox-label,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-checkbox .mdc-form-field > label {
  color: #e5e7eb !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-checkbox a,
body.theme-dark .auth-modal-container app-login .mat-checkbox a,
body.theme-dark .auth-modal-container app-login .checkbox-section a,
body.theme-dark .auth-modal-container app-registration .mat-mdc-checkbox a,
body.theme-dark .auth-modal-container app-registration .mat-checkbox a,
body.theme-dark .auth-modal-container app-registration .checkbox-section a,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-checkbox a,
body.theme-dark .auth-modal-container app-activateaccount .mat-checkbox a,
body.theme-dark .auth-modal-container app-activateaccount .checkbox-section a,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-checkbox a,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-checkbox a,
body.theme-dark .auth-modal-container app-forget-password-modal .checkbox-section a,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-checkbox a,
body.theme-dark .auth-modal-container app-change-password .mat-checkbox a,
body.theme-dark .auth-modal-container app-change-password .checkbox-section a {
  color: #93c5fd !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-checkbox .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-login .mat-checkbox-frame,
body.theme-dark .auth-modal-container app-registration .mat-mdc-checkbox .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-registration .mat-checkbox-frame,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-checkbox .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-activateaccount .mat-checkbox-frame,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-checkbox .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-checkbox-frame,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-checkbox .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-change-password .mat-checkbox-frame {
  border-color: #94a3b8 !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-login .mat-checkbox-checked .mat-checkbox-background,
body.theme-dark .auth-modal-container app-registration .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-registration .mat-checkbox-checked .mat-checkbox-background,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-activateaccount .mat-checkbox-checked .mat-checkbox-background,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-checkbox-checked .mat-checkbox-background,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,
body.theme-dark .auth-modal-container app-change-password .mat-checkbox-checked .mat-checkbox-background {
  background-color: var(--fc-brand, #5ea1d8) !important;
  border-color: var(--fc-brand, #5ea1d8) !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-form-field,
body.theme-dark .auth-modal-container app-login .mat-form-field,
body.theme-dark .auth-modal-container app-registration .mat-mdc-form-field,
body.theme-dark .auth-modal-container app-registration .mat-form-field,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-form-field,
body.theme-dark .auth-modal-container app-activateaccount .mat-form-field,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-form-field,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-form-field,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-form-field,
body.theme-dark .auth-modal-container app-change-password .mat-form-field {
  color: #e5e7eb !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled),
body.theme-dark .auth-modal-container app-login .mat-mdc-text-field-wrapper,
body.theme-dark .auth-modal-container app-login .mat-mdc-form-field-focus-overlay,
body.theme-dark .auth-modal-container app-registration .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled),
body.theme-dark .auth-modal-container app-registration .mat-mdc-text-field-wrapper,
body.theme-dark .auth-modal-container app-registration .mat-mdc-form-field-focus-overlay,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled),
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-text-field-wrapper,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-form-field-focus-overlay,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled),
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-text-field-wrapper,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-form-field-focus-overlay,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled),
body.theme-dark .auth-modal-container app-change-password .mat-mdc-text-field-wrapper,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-form-field-focus-overlay {
  background-color: #111827 !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-form-field .mdc-floating-label,
body.theme-dark .auth-modal-container app-login .mat-mdc-form-field .mat-mdc-floating-label,
body.theme-dark .auth-modal-container app-login .mat-mdc-form-field mat-label,
body.theme-dark .auth-modal-container app-login .mat-form-field-label,
body.theme-dark .auth-modal-container app-registration .mat-mdc-form-field .mdc-floating-label,
body.theme-dark .auth-modal-container app-registration .mat-mdc-form-field .mat-mdc-floating-label,
body.theme-dark .auth-modal-container app-registration .mat-mdc-form-field mat-label,
body.theme-dark .auth-modal-container app-registration .mat-form-field-label,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-form-field .mdc-floating-label,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-form-field .mat-mdc-floating-label,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-form-field mat-label,
body.theme-dark .auth-modal-container app-activateaccount .mat-form-field-label,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-form-field .mdc-floating-label,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-form-field .mat-mdc-floating-label,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-form-field mat-label,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-form-field-label,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-form-field .mdc-floating-label,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-form-field .mat-mdc-floating-label,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-form-field mat-label,
body.theme-dark .auth-modal-container app-change-password .mat-form-field-label {
  color: #94a3b8 !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-select-value,
body.theme-dark .auth-modal-container app-login .mat-mdc-select-min-line,
body.theme-dark .auth-modal-container app-login .mat-select-value,
body.theme-dark .auth-modal-container app-login .mat-select-value-text,
body.theme-dark .auth-modal-container app-login .mat-mdc-select-placeholder,
body.theme-dark .auth-modal-container app-registration .mat-mdc-select-value,
body.theme-dark .auth-modal-container app-registration .mat-mdc-select-min-line,
body.theme-dark .auth-modal-container app-registration .mat-select-value,
body.theme-dark .auth-modal-container app-registration .mat-select-value-text,
body.theme-dark .auth-modal-container app-registration .mat-mdc-select-placeholder,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-select-value,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-select-min-line,
body.theme-dark .auth-modal-container app-activateaccount .mat-select-value,
body.theme-dark .auth-modal-container app-activateaccount .mat-select-value-text,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-select-placeholder,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-select-value,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-select-min-line,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-select-value,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-select-value-text,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-select-placeholder,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-select-value,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-select-min-line,
body.theme-dark .auth-modal-container app-change-password .mat-select-value,
body.theme-dark .auth-modal-container app-change-password .mat-select-value-text,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-select-placeholder {
  color: #e5e7eb !important;
}
body.theme-dark .auth-modal-container app-login .mat-mdc-select-arrow,
body.theme-dark .auth-modal-container app-login .mat-select-arrow,
body.theme-dark .auth-modal-container app-registration .mat-mdc-select-arrow,
body.theme-dark .auth-modal-container app-registration .mat-select-arrow,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-select-arrow,
body.theme-dark .auth-modal-container app-activateaccount .mat-select-arrow,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-select-arrow,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-select-arrow,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-select-arrow,
body.theme-dark .auth-modal-container app-change-password .mat-select-arrow {
  color: #94a3b8 !important;
}
body.theme-dark .auth-modal-container app-login .mdc-line-ripple::before,
body.theme-dark .auth-modal-container app-login .mdc-line-ripple::after,
body.theme-dark .auth-modal-container app-login .mat-mdc-form-field-underline,
body.theme-dark .auth-modal-container app-login .mat-form-field-underline,
body.theme-dark .auth-modal-container app-registration .mdc-line-ripple::before,
body.theme-dark .auth-modal-container app-registration .mdc-line-ripple::after,
body.theme-dark .auth-modal-container app-registration .mat-mdc-form-field-underline,
body.theme-dark .auth-modal-container app-registration .mat-form-field-underline,
body.theme-dark .auth-modal-container app-activateaccount .mdc-line-ripple::before,
body.theme-dark .auth-modal-container app-activateaccount .mdc-line-ripple::after,
body.theme-dark .auth-modal-container app-activateaccount .mat-mdc-form-field-underline,
body.theme-dark .auth-modal-container app-activateaccount .mat-form-field-underline,
body.theme-dark .auth-modal-container app-forget-password-modal .mdc-line-ripple::before,
body.theme-dark .auth-modal-container app-forget-password-modal .mdc-line-ripple::after,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-mdc-form-field-underline,
body.theme-dark .auth-modal-container app-forget-password-modal .mat-form-field-underline,
body.theme-dark .auth-modal-container app-change-password .mdc-line-ripple::before,
body.theme-dark .auth-modal-container app-change-password .mdc-line-ripple::after,
body.theme-dark .auth-modal-container app-change-password .mat-mdc-form-field-underline,
body.theme-dark .auth-modal-container app-change-password .mat-form-field-underline {
  background-color: rgba(148, 163, 184, 0.35) !important;
  border-bottom-color: rgba(148, 163, 184, 0.35) !important;
}
body.theme-dark .auth-modal-container app-login .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,
body.theme-dark .auth-modal-container app-login .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,
body.theme-dark .auth-modal-container app-login .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing,
body.theme-dark .auth-modal-container app-registration .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,
body.theme-dark .auth-modal-container app-registration .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,
body.theme-dark .auth-modal-container app-registration .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing,
body.theme-dark .auth-modal-container app-activateaccount .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,
body.theme-dark .auth-modal-container app-activateaccount .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,
body.theme-dark .auth-modal-container app-activateaccount .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing,
body.theme-dark .auth-modal-container app-forget-password-modal .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,
body.theme-dark .auth-modal-container app-forget-password-modal .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,
body.theme-dark .auth-modal-container app-forget-password-modal .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing,
body.theme-dark .auth-modal-container app-change-password .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,
body.theme-dark .auth-modal-container app-change-password .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,
body.theme-dark .auth-modal-container app-change-password .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing {
  border-color: rgba(148, 163, 184, 0.35) !important;
}

body:has(.legal-page) .app-main-content,
body:has(app-legal-center-layout) .app-main-content,
.app-main-content:has(.legal-page),
.app-main-content:has(app-legal-center-layout),
.app-layout:has(.legal-page) .app-main-content,
.app-layout:has(app-legal-center-layout) .app-main-content,
.app-main-content app-legal-center-layout,
.app-main-content .legal-page,
.app-main-content .legal-center-wrapper {
  padding-top: 0 !important;
}

.app-main-content:has(app-legal-center-layout),
.app-main-content:has(.legal-page),
.app-main-content.has-legal-page,
body.has-legal-page .app-main-content {
  padding-top: 0 !important;
}

.trial-strip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.6rem 1rem;
  margin: 0.75rem 1rem 0;
  padding: 0.6rem 0.9rem;
  border-radius: 10px;
  border: 1px solid rgba(94, 161, 216, 0.35);
  background: rgba(94, 161, 216, 0.1);
  color: #0f172a;
  font-size: 0.875rem;
}
.trial-strip .trial-strip-icon {
  color: #4a92c8;
  font-size: 1.2rem;
}
.trial-strip .trial-strip-text {
  flex: 1;
  min-width: 12rem;
}
.trial-strip.trial-strip--error {
  border-color: rgba(220, 38, 38, 0.35);
  background: rgba(254, 226, 226, 0.7);
}
.trial-strip.trial-strip--error .trial-strip-icon {
  color: #b91c1c;
}
.trial-strip .trial-strip-link {
  border: none;
  background: none;
  padding: 0;
  color: #2f74b0;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}
.trial-strip .trial-strip-link.muted {
  color: #475569;
  font-weight: 600;
}
.trial-strip .trial-strip-close {
  border: none;
  background: none;
  padding: 0;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
}
.trial-strip .trial-strip-close .material-icons {
  font-size: 1.1rem;
}

:host-context(body.dark-mode) .trial-strip,
:host-context(.dark-theme) .trial-strip {
  color: #e2e8f0;
  background: rgba(94, 161, 216, 0.16);
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,0JAAA;EAEA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,mCAAA;EACA,kCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA;sEAAA;EAEA,eAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;AACF;AACE;EAEE,OAAA;AAAJ;;AAIA;EACE;IACE,WAAA;EADF;AACF;AAIA;EACE;IACE,OAAA;IACA,eAAA;EAFF;AACF;AAKA;EACE,YAAA;EACA,WAAA;AAHF;;AAMA;;EAEE,mBAAA;EACA,sBAAA;EACA,WAAA;AAHF;;AAMA;;EAEE,mBAAA;EACA,yBAAA;AAHF;;AAMA;;EAEE,mBAAA;EACA,kBAAA;EACA,WAAA;AAHF;;AAMA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,oBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,sBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAHF;;AAMA;EACE;IACE,aAAA;IACA,gBAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;IACA,sBAAA;IACA,iBAAA;IACA,QAAA;IACA,gBAAA;IACA,gCAAA;EAHF;EAMA;IACE,OAAA;IACA,eAAA;IACA,YAAA;IACA,iBAAA;IACA,sBAAA;EAJF;AACF;AAOA;;;;;;EAME,aAAA;AALF;;AAQA;EACE,SAAA;AALF;;AAQA;EACE,OAAA;AALF;;AAQA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,YAAA;EACA,cAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,aAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AALF;;AAQA;EACE,YAAA;EACA,WAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,YAAA;EACA,YAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,2BAAA;EACA,0CAAA;AALF;;AAQA;EACE,wBAAA;AALF;;AAQA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EAEA,cAAA;EACA,kBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AANF;;AASA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AANF;;AASA;;;EAGE,cAAA;EACA,qBAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AANF;;AASA;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANF;;AASA;EACE,wEAAA;EACA,YAAA;EACA,oBAAA;EACA,SAAA;AANF;;AASA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,wEAAA;EACA,uBAAA;AANF;;AASA;EACE,+BAAA;EACA,2CAAA;AANF;;AASA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;AANF;;AASA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gEAAA;EACA,gBAAA;EACA,gBAAA;EACA,0IAAA;AANF;;AAUA;EACE,gEAAA;EACA,oCAAA;EACA,2BAAA;AAPF;;AAUA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AAPF;;AAUA,sBAAA;AACA;EACE,gBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AAPF;AAQE;EACE,gBAAA;EACA,cAAA;EACA,YAAA;AANJ;AAOI;EACE,uBAAA;AALN;AAQE;EACE,OAAA;AANJ;AAQE;EACE,WAAA;EACA,4BAAA;EACA,0BAAA;AANJ;AAQI;EACE,4BAAA;AANN;AAQI;EACE,4BAAA;EACA,WAAA;EACA,YAAA;AANN;;AAcA,sBAAA;AACA;EACE;;IAEE,WAAA;EAXF;EAcA;IACE,YAAA;IACA,aAAA;EAZF;EAeA;IACE,iBAAA;EAbF;EAgBA;IACE,YAAA;IACA,wBAAA;EAdF;AACF;AAiBA;EACE;IACE,aAAA;IACA,kBAAA;EAfF;AACF;AAkBA;EACE,cAAA;AAhBF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,0BAAA;AAfF;;AAiBA;EACE,gBAAA;EACA,wBAAA,EAAA,yBAAA;EACA,MAAA,EAAA,yCAAA;EACA,aAAA,EAAA,+DAAA;AAdF;;AAiBA;EACE,eAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAdF;;AAgBA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AAbF;;AAeA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAZF;;AAcA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;AAXF;;AAaA;EACE,YAAA;AAVF;;AAaA;EACE,OAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AAVF;;AAaA;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,4EAAA;EACA,UAAA;AAVF;;AAYA;EACE,eAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;AATF;;AAWA;EACE,WAAA;AARF;;AAUA;EACE,aAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAPF;;AAYA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AATF;;AAWA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AARF;;AAUA;EACE,WAAA;EACA,eAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAPF;;AAUA;EACE,WAAA;AAPF;;AAeA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EAEA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAbF;AAeE;EACE,aAAA;AAbJ;AAeE;EACE,+BAAA;EACA,YAAA;AAbJ;AAgBI;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAdN;AAiBE;EAEE,eAAA;EAEA,kBAAA;EACA,uBAAA;EACA,UAAA;AAjBJ;AAkBI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;AAhBN;AAkBI;EACE,YAAA;AAhBN;AAmBI;EACE,WAAA;EACA,gBAAA;AAjBN;AAkBM;EACE,WAAA;AAhBR;;AAsBA;EACE,qBAAA;AAnBF;;AAsBA,sBAAA;AACA;EACE,YAAA;AAnBF;;AAqBA;EACE,gBAAA;EACA,QAAA;EACA,YAAA;AAlBF;AAmBE;EACE,yBAAA;AAjBJ;;AAoBA;EACE,gBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,+BAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;AAjBF;AAkBE;EACE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAhBJ;AAiBI;EACE,wBAAA;AAfN;AAkBM;EACE,wBAAA;AAhBR;AAmBI;EACE,uBAAA;AAjBN;AAoBE;EACE,OAAA;EACA,mBAAA;EACA,kBAAA;AAlBJ;;AAqBA;EACE;IACE,aAAA;EAlBF;EAoBA;IACE,aAAA;EAlBF;AACF;AAwCA;EACE;IACE,2BAAA;EAtCF;AACF;AAyCA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAvCF;;AA0CA;EACE,kBAAA;EACA,qBAAA;EACA,+BAAA;AAvCF;;AA0CA;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EAEA,yBAAA;EACA,kBAAA;EACA,UAAA;AAxCF;;AA2CA;EACE,mBAAA;AAxCF;;AA2CA;EACE;IACE,aAAA;EAxCF;AACF;AA0CA;EACE,wBAAA;AAxCF;;AA0CA;EACE;IACE,wBAAA;IACA,sBAAA;EAvCF;EAyCA;IACE,aAAA;EAvCF;EAyCA;IACE,kBAAA;IACA,SAAA;EAvCF;AACF;AA2CA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,0CAAA;AAzCF;;AA4CA;EACE,yBAAA;EACA,cAAA;AAzCF;;AA4CA;EACE,yBAAA;EACA,cAAA;AAzCF;;AA4CA;EA4EE,6DAAA;EAqOA,kEAAA;AAxVF;AAwCE;EACE,yBAAA;EACA,cAAA;AAtCJ;AAyCE;EACE,wCAAA;EACA,iDAAA;AAvCJ;AA0CE;;;EAGE,cAAA;AAxCJ;AA2CE;EACE,mCAAA;EACA,sCAAA;EACA,cAAA;AAzCJ;AA4CE;EACE,cAAA;AA1CJ;AA6CE;EACE,cAAA;AA3CJ;AA8CE;;;;EAIE,2CAAA;EACA,cAAA;AA5CJ;AA+CE;EACE,oCAAA;EACA,gCAAA;AA7CJ;AAgDE;EACE,yBAAA;EACA,2CAAA;EACA,+BAAA;EACA,qBAAA;AA9CJ;AAiDE;EACE,yBAAA;EACA,2CAAA;EACA,qBAAA;AA/CJ;AAkDE;EACE,yBAAA;EACA,gDAAA;AAhDJ;AAmDE;EACE,cAAA;AAjDJ;AAoDE;;EAEE,cAAA;AAlDJ;AAqDE;;EAEE,2CAAA;AAnDJ;AAuDE;EACE,cAAA;AArDJ;AAuDI;EACE,cAAA;AArDN;AAwDI;EACE,oCAAA;AAtDN;AAwDM;EACE,cAAA;AAtDR;AAyDM;EACE,cAAA;AAvDR;AA2DI;EACE,oCAAA;EACA,sCAAA;AAzDN;AA2DM;;EAEE,yBAAA;AAzDR;AA4DM;EACE,cAAA;AA1DR;AA+DE;EACE,cAAA;AA7DJ;AAgEE;EACE,yBAAA;AA9DJ;AAiEE;EACE,wBAAA;AA/DJ;AAkEE;;;EAGE,cAAA;AAhEJ;AAmEE;;EAEE,yBAAA;EACA,uCAAA;AAjEJ;AAoEE;EACE,yBAAA;EACA,iDAAA;AAlEJ;AAsEE;;;EAGE,yBAAA;AApEJ;AAwEE;;EAEE,yBAAA;AAtEJ;AA0EE;EACE,yBAAA;AAxEJ;AA2EE;;EAEE,yBAAA;AAzEJ;AA6EE;EACE,yBAAA;AA3EJ;AA+EI;EAEE,0CAAA;AA9EN;AAkFE;EACE,yBAAA;AAhFJ;AAoFE;EACE,yBAAA;AAlFJ;AAqFE;EACE,yBAAA;AAnFJ;AAsFE;EACE,4CAAA;EACA,wBAAA;AApFJ;AAuFE;EACE,yBAAA;AArFJ;AAwFE;EACE,oCAAA;AAtFJ;AA0FE;;EAEE,oCAAA;EACA,kDAAA;EACA,oDAAA;AAxFJ;AA4FE;EACE,yBAAA;EACA,wCAAA;AA1FJ;AA4FI;EACE,yBAAA;AA1FN;AA6FI;EACE,gCAAA;EACA,wBAAA;AA3FN;AA8FI;EACE,qDAAA;EACA,yBAAA;AA5FN;AA8FM;EACE,yBAAA;AA5FR;AAgGI;EACE,wCAAA;EACA,yBAAA;EACA,gBAAA;AA9FN;AAgGM;EACE,yBAAA;AA9FR;AAiGM;EACE,qDAAA;EACA,yBAAA;AA/FR;AAiGQ;EACE,yBAAA;AA/FV;AAqGE;EACE,8BAAA;EACA,gCAAA;AAnGJ;AAsGE;EACE,qDAAA;AApGJ;AAuGE;;EAEE,2CAAA;AArGJ;AAwGE;EACE,cAAA;AAtGJ;AAyGE;EACE,2CAAA;AAvGJ;AA0GE;EACE,uBAAA;AAxGJ;AA2GE;EACE,qCAAA;AAzGJ;AA4GE;EACE,yBAAA;AA1GJ;AA6GE;EACE,2CAAA;AA3GJ;AA8GE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;EACA,2CAAA;EACA,+BAAA;EACA,qBAAA;AA5GJ;AA+GE;EACE,yBAAA;EACA,2CAAA;EACA,qBAAA;AA7GJ;AAiHE;;EAEE,yBAAA;AA/GJ;AAkHE;;EAEE,yBAAA;AAhHJ;AAmHE;EACE;IACE,wCAAA;IACA,oCAAA;EAjHJ;EAoHE;IACE,kCAAA;EAlHJ;AACF;;AAsHA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA,EAAA,iDAAA;EAEA,6DAAA;AApHF;AAqHE;EACE,iBAAA;AAnHJ;AAuHE;EArBF;IAuBI,oBAAA;EArHF;AACF;;AA2HA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxHF;;AA2HA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AAxHF;;AA2HA;EACE,yBAAA;AAxHF;;AA2HA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AAxHF;;AA2HA;EACE,YAAA;EACA,WAAA;AAxHF;;AA2HA;EACE,OAAA;EACA,gBAAA;EACA,cAAA;AAxHF;;AA2HA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAxHF;AA0HE;EACE,qBAAA;EACA,wCAAA;AAxHJ;;AA8HA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;AA3HF;AA6HE;EAEE,yBAAA;AA5HJ;;AAgIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AA7HF;;AAgIA;;EAEE,yBAAA;AA7HF;;AAgIA;EACE,yBAAA;AA7HF;;AAgIA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;AA7HF;AA+HE;EACE,yBAAA;AA7HJ;;AAkIA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;AA/HF;;AAmIA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AAhIF;;AAoIA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AAjIF;;AAoIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;AAjIF;AAmIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;AAjIJ;AAoIE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAlIJ;AAqIE;EACE,OAAA;EACA,gBAAA;AAnIJ;AAsIE;EACE,0CAAA;EACA,cAAA;AApIJ;AAsII;;EAEE,yBAAA;EACA,UAAA;AApIN;AAwIE;EACE,6BAAA;EACA,+BAAA;EACA,gBAAA;AAtIJ;AAwII;;EAEE,0CAAA;EACA,UAAA;AAtIN;AAyII;EACE,0CAAA;EACA,cAAA;AAvIN;AAyIM;;EAEE,yBAAA;AAvIR;;AA8IA;EACE,qBAAA;EACA,gBAAA;EACA,QAAA;AA3IF;AA8IE;EACE,aAAA;AA5IJ;AA+IE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA7IJ;AAgJE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AA9IJ;AAiJE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,0BAAA;AAhJJ;;AAqJA;EACE,eAAA;EACA,oBAAA;AAlJF;AAoJE;EAEE,6BAAA;AAnJJ;;AAwJA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,wCAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AArJF;AAuJE;EACE,kBAAA;EACA,eAAA;EACA,SAAA;AArJJ;AAuJI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArJN;AA0JM;EAAW,cAAA;AAvJjB;AAwJM;EAA0B,UAAA;EAAY,YAAA;AApJ5C;;AA2JA;EACE,OAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AAxJF;;AA2JA;EACE,cAAA;AAxJF;;AA2JA;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;EACA,UAAA;EACA,kBAAA;AAxJF;;AA2JA;EACE,cAAA;EACA,yBAAA;AAxJF;;AA2JA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxJF;;AA2JA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;EACA,UAAA;EACA,kBAAA;AAxJF;;AA2JA;EACE,cAAA;EACA,yBAAA;AAxJF;;AA2JA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxJF;;AA4JA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AAzJF;AA4JE;EACE,UAAA;AA1JJ;AA6JE;EACE,mBAAA;EACA,kBAAA;AA3JJ;AA8JE;EACE,mBAAA;EACA,kBAAA;AA5JJ;AA8JI;EACE,mBAAA;AA5JN;;AAkKA;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;AA/JF;;AAoKE;EACE,yBAAA;AAjKJ;AAoKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;AAlKJ;AAqKE;EACE,UAAA;AAnKJ;;AAwKE;EACE,yBAAA;AArKJ;;AAyKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAtKF;;AAyKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AAtKF;;AAyKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtKF;;AAyKA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtKF;;AAyKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;AAtKF;;AAyKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AAtKF;;AAyKA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AAtKF;AAwKE;EACE,yCAAA;AAtKJ;;AA0KA;EACE,cAAA;AAvKF;;AA0KA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,kBAAA;AAvKF;AAyKE;EAEE,yBAAA;AAxKJ;AA2KE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AAzKJ;AA4KE;EACE,OAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1KJ;AA6KE;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA3KJ;AA6KI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3KN;AA8KI;EACE,cAAA;EACA,qCAAA;AA5KN;AAgLE;EACE,UAAA;AA9KJ;;AAkLA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AA/KF;AAiLE;EACE,SAAA;EACA,eAAA;AA/KJ;;AAoLA;EACE,0BAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,SAAA;EACA,+BAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AAjLF;;AAoLA;EACE,kBAAA;AAjLF;AAoLI;EACE,qBAAA;EACA,wCAAA;AAlLN;;AAuLA;EACE,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AApLF;;AAuLA;EACE,yBAAA;AApLF;;AAuLA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AApLF;;AAwLA;EACE,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AArLF;AAuLE;EACE,cAAA;EACA,2BAAA;AArLJ;AAwLE;EACE,qCAAA;AAtLJ;AAwLI;EACE,+BAAA;AAtLN;AA4LI;EACE,+BAAA;AA1LN;AA+LE;EA9BF;IA+BI,wBAAA;EA5LF;AACF;;AA+LA;EACE,wBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;EACA,wCAAA;EAqDA,iBAAA;EACA,gBAAA;AAhPF;AA6LE;EACE,qDAAA;EACA,0BAAA;EACA,gCAAA;EACA,8BAAA;EACA,qBAAA;AA3LJ;AA8LE;EACE,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,uBAAA;EACA,4CAAA;AA5LJ;AA8LI;EACE,wCAAA;AA5LN;AAgME;EACE,2BAAA;EACA,4BAAA;EACA,gCAAA;AA9LJ;AAkME;EACE,yBAAA;AAhMJ;AAkMI;EACE,yBAAA;AAhMN;AAqME;EACE;IACE,aAAA;EAnMJ;AACF;;AA6MA;EACE,wBAAA;EACA,8BAAA;EACA,qBAAA;AA1MF;AA4ME;EACE,8BAAA;EACA,qBAAA;AA1MJ;;AA+MA;EAGE;;;;;;;IAOE,0BAAA;IACA,oBAAA;IACA,qBAAA;IACA,mBAAA;IACA,oBAAA;IACA,sBAAA;IACA,2BAAA;IACA,2BAAA;IACA,4BAAA;IACA,wBAAA;IACA,yBAAA;IACA,8BAAA;IACA,qBAAA;IACA,oCAAA;IACA,wCAAA;IACA,yCAAA;IACA,qDAAA;EA9MF;EAkNA;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;IACA,0BAAA;IACA,oBAAA;IACA,qBAAA;IACA,mBAAA;IACA,sBAAA;IACA,2BAAA;IACA,2BAAA;IACA,4BAAA;IACA,wBAAA;IACA,oCAAA;IACA,wCAAA;IACA,yCAAA;IACA,qDAAA;EAhNF;EAoNA;;;IAGE,iBAAA;IACA,wBAAA;EAlNF;EAsNA;IACE,0BAAA;IACA,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,4CAAA;EApNF;EAuNE;IACE,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,4CAAA;EArNJ;EA0NA;;IAEE,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,4CAAA;EAxNF;EA4NA;IACE,0BAAA;IACA,oBAAA;IACA,sBAAA;IACA,sBAAA;IACA,uBAAA;IACA,qDAAA;IACA,yBAAA;IACA,uBAAA;IACA,6BAAA;IACA,0BAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,wBAAA;IACA,wDAAA;IACA,oCAAA;IACA,0BAAA;IACA,yBAAA;IACA,qBAAA;EA1NF;EA4NE;IACE,oCAAA;IACA,gCAAA;IACA,yDAAA;EA1NJ;EA6NE;IACE,iCAAA;EA3NJ;EA+NE;IACE,uBAAA;IACA,yBAAA;IACA,0CAAA;EA7NJ;EAiOE;IACE,uBAAA;EA/NJ;EAsOE;;IACE,wBAAA;IACA,oBAAA;EAnOJ;EA0OE;;IACE,wBAAA;IACA,oBAAA;EAvOJ;EA4OA;IACE,0BAAA;IACA,oBAAA;IACA,sBAAA;IACA,sBAAA;IACA,uBAAA;IACA,qDAAA;IACA,yBAAA;IACA,uBAAA;IACA,6BAAA;IACA,0BAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,wBAAA;IACA,wDAAA;IACA,oCAAA;IACA,0BAAA;IACA,yBAAA;IACA,qBAAA;EA1OF;EA4OE;IACE,oCAAA;IACA,gCAAA;IACA,yDAAA;EA1OJ;EA6OE;IACE,iCAAA;EA3OJ;EA+OE;IACE,uBAAA;IACA,yBAAA;IACA,0CAAA;IACA,0BAAA;EA7OJ;EAiPE;IACE,uBAAA;IACA,kCAAA;EA/OJ;EAmPE;IACE,oBAAA;EAjPJ;EAsPA;;IAEE,oBAAA;IACA,wBAAA;IACA,wBAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;IACA,8BAAA;IACA,2BAAA;IACA,oBAAA;IACA,qBAAA;EApPF;EAwPA;;;IAGE,wBAAA;IACA,iBAAA;EAtPF;EA0PA;;;IAGE,yBAAA;EAxPF;EA4PA;;;IAGE,4BAAA;EA1PF;EA8PA;;IAEE,2BAAA;EA5PF;EAgQA;;;IAGE,oBAAA;IACA,qCAAA;EA9PF;EAkQA;IACE,oCAAA;IACA,wCAAA;IACA,qDAAA;IACA,wBAAA;IACA,iEAAA;IACA,2BAAA;IACA,4BAAA;IACA,2BAAA;IACA,6BAAA;IACA,wBAAA;IACA,oCAAA;IACA,8BAAA;IACA,8BAAA;IACA,qBAAA;IACA,4BAAA;EAhQF;EAmQE;IACE,yBAAA;IACA,gEAAA;IACA,0BAAA;IACA,2BAAA;IACA,2BAAA;IACA,4BAAA;EAjQJ;EAqQE;;IAEE,0CAAA;IACA,gCAAA;IACA,sCAAA;IACA,4BAAA;EAnQJ;EAqQI;;IACE,yBAAA;IACA,qCAAA;EAlQN;EA6QA;IACE,6BAAA;IACA,qDAAA;IACA,oCAAA;IACA,2BAAA;EA3QF;EA8QE;IACE,oCAAA;IACA,6BAAA;EA5QJ;EA8QI;IACE,6BAAA;IACA,yBAAA;IACA,uDAAA;IACA,0BAAA;IACA,iDAAA;EA5QN;EA8QM;IACE,oCAAA;IACA,0CAAA;EA5QR;EA+QM;IACE,qDAAA;IACA,yBAAA;IACA,2BAAA;EA7QR;EAsRE;IACE,wEAAA;IACA,yDAAA;EApRJ;EAwRM;IACE,yBAAA;IACA,uDAAA;EAtRR;EAyRQ;IACE,2BAAA;IACA,0CAAA;EAvRV;EA+RA;IAEE,oCAAA;EA9RF;EAmSI;IACE,2DAAA;EAjSN;EAuSA;;;;;;IAME,wBAAA;IACA,iBAAA;EArSF;EAySA;;;;;;IAME,wBAAA;IACA,iBAAA;EAvSF;EA2SA;;;;;IAKE,4BAAA;EAzSF;EA6SA;;;;;IAKE,4BAAA;EA3SF;EA8SA;;;;;;IAME,4BAAA;IACA,4BAAA;EA5SF;EAgTA;;;;;;IAME,4BAAA;IACA,4BAAA;EA9SF;EAkTA;;IAEE,2BAAA;EAhTF;EAmTA;;;;;;IAME,oBAAA;IACA,qCAAA;EAjTF;EAqTA;;;;;;IAME,oBAAA;IACA,qCAAA;EAnTF;EAuTA;;;;;IAKE,2BAAA;IACA,iBAAA;EArTF;EAyTA;;IAEE,yBAAA;EAvTF;EA2TA;IACE,6BAAA;EAzTF;EA8TA;;;;;;;;;;;;IAYE,0BAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,mBAAA;IACA,sBAAA;IACA,2BAAA;IACA,oBAAA;IACA,wBAAA;IACA,2BAAA;IACA,0BAAA;EA5TF;EAkUA;;;;;;;;;;;;IAaE,0BAAA;IACA,oBAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,sBAAA;IACA,0BAAA;IACA,oBAAA;IACA,wBAAA;IACA,2BAAA;IACA,qBAAA;IACA,yBAAA;IACA,0BAAA;IACA,wBAAA;IAEA,mCAAA;EAlUF;AACF;AAsUA;EACE;IACE,0BAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,wBAAA;IACA,oCAAA;IACA,uBAAA;IACA,2CAAA;IACA,mDAAA;EApUF;EAuUE;IACE,sBAAA;EArUJ;EAwUE;IACE,sBAAA;IACA,kCAAA;EAtUJ;EA2UA;IACE,0BAAA;IACA,oBAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,wBAAA;IACA,sBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,4BAAA;IACA,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,oCAAA;IACA,wCAAA;IACA,qDAAA;IACA,8BAAA;IACA,qBAAA;IACA,yBAAA;EAzUF;EA6UA;IACE,0BAAA;IACA,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,4CAAA;EA3UF;EA8UE;IACE,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,4CAAA;EA5UJ;EAiVA;;IAEE,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,4CAAA;EA/UF;EAoVA;IACE,wBAAA;IACA,0BAAA;IACA,oBAAA;IACA,uCAAA;EAlVF;EAsVA;;IAEE,uBAAA;EApVF;EAwVA;IACE,wBAAA;IACA,uCAAA;EAtVF;EA0VA;;IAEE,uBAAA;EAxVF;EA+VE;;;;;;;;;IAGA,wBAAA;EAvVF;EA4VA;;;;IAIE,0BAAA;IACA,oBAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,wBAAA;IACA,sBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,4BAAA;IACA,2BAAA;IACA,8BAAA;IACA,qBAAA;IACA,yBAAA;IACA,2BAAA;IACA,6BAAA;IACA,oCAAA;IACA,wCAAA;IACA,qDAAA;EA1VF;EA8VA;IACE,oCAAA;IACA,wCAAA;IACA,qDAAA;IACA,wBAAA;IACA,iEAAA;IACA,2BAAA;IACA,4BAAA;IACA,2BAAA;IACA,6BAAA;IACA,yBAAA;IACA,8BAAA;IACA,qBAAA;EA5VF;EAiWE;IACE,2BAAA;IACA,2BAAA;EA/VJ;EAwWE;;;;IACE,gCAAA;EAnWJ;EAyWE;IACE,yBAAA;IACA,gCAAA;EAvWJ;EA4WA;IACE,0BAAA;IACA,uBAAA;IACA,sBAAA;IACA,sBAAA;IACA,uBAAA;IACA,6BAAA;IACA,qDAAA;IACA,yBAAA;IACA,uBAAA;IACA,wBAAA;IACA,qDAAA;IACA,0BAAA;IACA,uBAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,oCAAA;IACA,8BAAA;IACA,qBAAA;IACA,qBAAA;IACA,iEAAA;IACA,oBAAA;IACA,0BAAA;IACA,0BAAA;IACA,2BAAA;IACA,2BAAA;IACA,iCAAA;EA1WF;EA4WE;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,yBAAA;IACA,qBAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,yBAAA;IACA,yBAAA;IACA,uBAAA;IACA,wBAAA;EA1WJ;EA8WE;IACE,wBAAA;EA5WJ;EA+WE;IACE,oCAAA;IACA,iCAAA;IACA,oDAAA;EA7WJ;EAgXE;IACE,iCAAA;EA9WJ;EAoXA;IACE,wBAAA;EAlXF;EAsXA;IACE,eAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,6BAAA;IACA,gBAAA;IACA,WAAA;IACA,aAAA;IACA,aAAA;IACA,gBAAA;IACA,UAAA;IACA,kBAAA;IACA,yBAAA;IACA,oBAAA;EApXF;EAsXE;IACE,gBAAA;IACA,iBAAA;IACA,qBAAA;IACA,8BAAA;IACA,oBAAA;IACA,aAAA;IACA,oBAAA;IAGA,yBAAA;IACA,mCAAA;YAAA,2BAAA;IACA,2CAAA;IACA,wCAAA;IACA,yBAAA;EAtXJ;EAyXI;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;EAvXN;EA0XI;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;EAxXN;EA2XI;IACE,wBAAA;IACA,8BAAA;IACA,qBAAA;EAzXN;EA4XI;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;EA1XN;EA6XI;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;IACA,gBAAA;EA3XN;EAgYE;IACE,qDAAA;IACA,0BAAA;IACA,yBAAA;IACA,sBAAA;IACA,oBAAA;EA9XJ;EAiYE;IACE,wCAAA;IACA,+CAAA;IACA,6BAAA;IACA,4BAAA;IACA,0BAAA;IACA,yBAAA;IACA,sBAAA;IACA,wBAAA;IACA,8BAAA;IACA,oBAAA;EA/XJ;EAkYE;IACE,yBAAA;EAhYJ;EAoYE;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;EAlYJ;EAoYI;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;EAlYN;EAqYI;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;IACA,sBAAA;EAnYN;EAsYI;IACE,wBAAA;IACA,8BAAA;IACA,qBAAA;IACA,sBAAA;EApYN;EAuYI;IACE,gCAAA;IACA,8BAAA;IACA,qBAAA;EArYN;EA0YE;IACE,0BAAA;IACA,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,4CAAA;EAxYJ;EA2YI;IACE,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,4CAAA;EAzYN;AACF;AA+YA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AA7YF;;AAgZA;EACE,yBAAA;AA7YF;;AAgZA;EACE,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;AA7YF;;AAgZA;;;EAGE,uBAAA;EACA,wBAAA;EACA,2BAAA;AA7YF;;AAgZA;EACE,uBAAA;AA7YF;;AAgZA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,8DAAA;AA7YF;;AAgZA;EACE,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;AA7YF;;AAgZA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gDAAA;AA7YF;;AAgZA;EACE,2BAAA;EACA,cAAA;EACA,mBAAA;AA7YF;;AAgZA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7YF;;AAgZA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7YF;;AAgZA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AA7YF;AA+YE;EAGE,aAAA;EACA,YAAA;AA/YJ;AAkZE;EACE,aAAA;EACA,gCAAA;EACA,kBAAA;AAhZJ;AAkZI;EAGE,aAAA;EACA,YAAA;AAlZN;;AAuZA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;AApZF;;AAwZA;;;;;;EAME,8CAAA;AArZF;;AAwZA;;;;;;EAME,8CAAA;EACA,kBAAA;AArZF;;AAyZA;EAEI;IAME,8CAAA;EA5ZJ;EA+ZE;IAME,8CAAA;IACA,kBAAA;EAlaJ;AACF;AAsaA;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,+BAAA;EACA,YAAA;AApaF;;AAwaA;;;;;;EAME,iBAAA;EACA,wBAAA;EACA,wBAAA;AAraF;;AAyaA;EACE,4BAAA;AAtaF;;AAyaA;EACE,aAAA;EACA,aAAA;EACA,UAAA;EACA,6BAAA;EACA,oBAAA;AAtaF;AAwaE;EAPF;IAQI,cAAA;IACA,eAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;EAraF;AACF;AAuaE;EACE,UAAA;EACA,oBAAA;AAraJ;;AA6aE;EAHF;;;IAII,iBAAA;EAvaF;AACF;;AA0aA;EACE,eAAA;AAvaF;;AA0aA;EACE,mBAAA;AAvaF;AAyaE;EACE,qBAAA;EACA,kBAAA;AAvaJ;AAyaI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;AAvaN;;AA4aA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAzaF;;AA4aA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAzaF;AA2aE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;AAzaJ;AA4aE;EACE,oCAAA;AA1aJ;AA4aI;EACE,+BAAA;AA1aN;AA6aI;EACE,cAAA;AA3aN;AA+aE;EACE,oCAAA;EACA,sCAAA;AA7aJ;AA+aI;EACE,+BAAA;AA7aN;AAgbI;EACE,gBAAA;AA9aN;AAibI;EACE,+BAAA;AA/aN;;AAobA;EACE,OAAA;EACA,YAAA;AAjbF;;AAobA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjbF;;AAobA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjbF;;AAobA;EACE,cAAA;EACA,gBAAA;AAjbF;;AAobA;EACE,0CAAA;EACA,cAAA;AAjbF;;AAobA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAjbF;AAmbE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAjbJ;;AAqbA;EACE,gBAAA;EACA,uBAAA;AAlbF;;AAqbA;EACE,gBAAA;AAlbF;;AAqbA;;;;EAIE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlbF;;AAqbA;;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AAlbF;AAobE;;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAjbJ;AAobE;;EACE,cAAA;EACA,gBAAA;AAjbJ;;AAqbA;;EAEE,gBAAA;EACA,gBAAA;AAlbF;;AAqbA;;;EAGE,wBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,uCAAA;EACA,kBAAA;EAEA,8EAAA;AAnbF;AAobE;;;;;;;;;EAGE,cAAA;EACA,0BAAA;EACA,cAAA;EACA,4BAAA;AA5aJ;AA+aE;;;EACE,8CAAA;AA3aJ;AA6aI;;;;;;;;;EAGE,cAAA;AAraN;AAwaI;;;EACE,cAAA;AApaN;AAwaE;;;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AApaJ;AAuaE;;;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnaJ;AAsaE;;;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlaJ;AAqaE;;;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,oCAAA;EACA,0CAAA;EACA,gBAAA;EACA,mBAAA;AAjaJ;AAoaE;;;EACE,mCAAA;AAhaJ;AAkaI;;;EACE,gBAAA;AA9ZN;AAiaI;;;;;;;;;EAGE,cAAA;AAzZN;AA4ZI;;;EACE,+CAAA;AAxZN;;AA6ZA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EASA,gBAAA;EAOA,gBAAA;EACA,sCAAA;EACA,gBAAA;AAxaF;AAwZE;EAGE,aAAA;EACA,YAAA;EACA,gBAAA;AAxZJ;AA4ZE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AA1ZJ;AAgaE;EACE,yBAAA;AA9ZJ;AAiaE;EACE,yBAAA;EACA,gBAAA;AA/ZJ;AAkaE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhaJ;AAmaE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAjaJ;AAoaE;EACE,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAlaJ;;AAsaA;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iCAAA;EACA,iBAAA,EAAA,iDAAA;AAnaF;;AAsaA,0EAAA;AACA;EACE,oBAAA;AAnaF;;AAuaA;;;;;;;EAOE,2BAAA;EACA,yBAAA;EACA,wCAAA;EACA,kCAAA;AApaF;;AAwaA;;;EAGE,wBAAA;AAraF;;AAyaA;;;EAGE,wBAAA;EACA,yBAAA;AAtaF;;AAyaA,wFAAA;AACA;EACE,cAAA;EACA,iBAAA,EAAA,oDAAA;AAtaF;;AA0aA;;EAEE,2BAAA;AAvaF;;AA0aA,4CAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;AAvaF;;AA2aA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,iBAAA;EACA,QAAA;EACA,YAAA;AAxaF;;AA2aA;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;AAxaF;;AA2aA;EACE,aAAA;AAxaF;;AA2aA;EACE,oBAAA;AAxaF;;AA2aA;EACE,OAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AAxaF;;AA2aA;;EAEE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAxaF;;AA2aA;;EAEE,uBAAA;AAxaF;;AA2aA;;EAEE,eAAA;EACA,WAAA;EACA,YAAA;AAxaF;;AA2aA,wCAAA;AACA;EACE,OAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA,EAAA,2BAAA;EACA,aAAA,EAAA,6BAAA;AAxaF;;AA2aA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,6CAAA;EACA,cAAA;AAxaF;AA0aE;EACE,cAAA;EACA,yBAAA;AAxaJ;;AA4aA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzaF;;AA4aA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,6CAAA;EACA,cAAA;AAzaF;AA2aE;EACE,cAAA;EACA,yBAAA;AAzaJ;AA4aE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1aJ;;AA8aA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA3aF;;AA8aA;EACE,cAAA;AA3aF;;AA+aA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AA5aF;;AA+aA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;EACA,SAAA;AA5aF;;AAgbA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,4BAAA;EACA,gCAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;AA7aF;AA+aE;EACE,qCAAA;AA7aJ;AAibE;EACE,wCAAA;AA/aJ;AAkbI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,0BAAA;AAhbN;AAmbI;EACE,uCAAA;AAjbN;;AAubA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;AApbF;;AAubA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AApbF;;AAubA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AApbF;;AAubA;EACE,OAAA;EACA,YAAA;EACA,eAAA;AApbF;;AAubA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iEAAA;EACA,qBAAA;AApbF;AAubE;EACE,gBAAA;EACA,WAAA;AArbJ;;AAybA;EACE,eAAA;EACA,WAAA;AAtbF;;AAybA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAtbF;AAwbE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAtbJ;;AA0bA;EACE,eAAA;AAvbF;;AA4bE;EACE,cAAA;AAzbJ;AA4bE;EACE,8CAAA;AA1bJ;AA4bI;EACE,2CAAA;AA1bN;AA6bI;EACE,0CAAA;AA3bN;AA6bM;EACE,yBAAA;AA3bR;AA8bM;EACE,yCAAA;AA5bR;AAicE;EACE,yBAAA;AA/bJ;AAkcE;EACE,cAAA;AAhcJ;AAkcI;EACE,gBAAA;EACA,cAAA;AAhcN;AAocE;EACE,cAAA;AAlcJ;AAqcE;EACE,cAAA;AAncJ;AAscE;EACE,yBAAA;AApcJ;;AA0cE;EACE,cAAA;EACA,gBAAA;AAvcJ;AA0cE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAxcJ;AA0cI;EACE,+BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAxcN;AA2cI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AAzcN;AA2cM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAzcR;AA4cM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA1cR;AA8cI;EACE,mBAAA;AA5cN;;AAidA,gBAAA;AACA;EACE,kBAAA;AA9cF;;AAidA;EACE;IACE,YAAA;EA9cF;EAidA;IACE,kBAAA;EA/cF;EAkdA;IACE,gBAAA;IACA,cAAA;EAhdF;AACF;AAmdA,4BAAA;AACA,wDAAA;AACA;EACE;IACE,0BAAA;IACA,uBAAA;IACA,sBAAA;IACA,sBAAA;IACA,uBAAA;IACA,6BAAA;IACA,qDAAA;IACA,yBAAA;IACA,uBAAA;IACA,wBAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,8BAAA;IACA,qBAAA;IACA,qBAAA;IACA,qDAAA;IACA,0BAAA;IACA,wBAAA;IACA,oBAAA;IACA,0BAAA;IACA,0BAAA;IACA,2BAAA;IACA,2BAAA;IACA,iCAAA;EAjdF;EAmdE;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,yBAAA;IACA,oBAAA;IACA,qBAAA;IACA,uBAAA;IACA,wBAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,yBAAA;EAjdJ;AACF;AAqdA,gFAAA;AACA;EACE;IACE,0BAAA;IACA,uBAAA;IACA,sBAAA;IACA,sBAAA;IACA,uBAAA;IACA,6BAAA;IACA,qDAAA;IACA,yBAAA;IACA,uBAAA;IACA,wBAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,8BAAA;IACA,qBAAA;IACA,wBAAA;EAndF;EAqdE;IACE,yBAAA;IACA,yBAAA;IACA,qBAAA;IACA,uBAAA;IACA,wBAAA;EAndJ;EAwdA;IACE,0BAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,wBAAA;EAtdF;EAwdE;IACE,yBAAA;IACA,8BAAA;IACA,qBAAA;EAtdJ;EA2dA;;IAEE,0BAAA;IACA,uBAAA;IACA,sBAAA;IACA,sBAAA;IACA,uBAAA;IACA,6BAAA;IACA,qDAAA;IACA,yBAAA;IACA,uBAAA;IACA,wBAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,8BAAA;IACA,qBAAA;EAzdF;EA2dE;;IACE,yBAAA;IACA,yBAAA;IACA,qBAAA;IACA,uBAAA;IACA,wBAAA;EAxdJ;AACF;AA4dA,4BAAA;AACA;EACE;IACE,cAAA;IACA,YAAA;IACA,oBAAA;SAAA,eAAA,EAAA,mCAAA;IACA,sBAAA;EA1dF;EA6dA;IACE,YAAA;IACA,cAAA,EAAA,kCAAA;EA3dF;EA8dA;IACE,eAAA;IACA,aAAA,EAAA,wCAAA;IACA,cAAA;IACA,YAAA,EAAA,yBAAA;IACA,gBAAA,EAAA,qCAAA;EA5dF;EA+dA;IACE,QAAA;IACA,cAAA,EAAA,wCAAA;EA7dF;EAgeA;IACE,QAAA;IACA,mBAAA;IACA,cAAA,EAAA,yCAAA;EA9dF;EAieA,8DAAA;EACA;IACE,eAAA;IACA,gBAAA;IACA,uBAAA;EA/dF;EAieE;IACE,aAAA;EA/dJ;EAqeA;IACE,YAAA;IACA,WAAA;IACA,uBAAA,EAAA,cAAA;IACA,YAAA;IACA,gBAAA;EAneF;EAueA;IACE,mBAAA;IACA,yBAAA;IACA,mBAAA;IACA,yCAAA;IACA,iBAAA;EAreF;EAweE;IACE,qBAAA;EAteJ;EA0eA;IACE,uBAAA;IACA,wBAAA;IACA,gBAAA;EAxeF;EA2eA;IACE,eAAA;IACA,eAAA;EAzeF;EA4eA;IACE,iBAAA;IACA,uBAAA;IACA,wBAAA;IACA,gBAAA;EA1eF;EA6eA;IACE,YAAA;EA3eF;EA8eA;IACE,WAAA;IACA,YAAA;EA5eF;EA+eA;IACE,YAAA;EA7eF;EAgfA,0CAAA;EACA;IACE,WAAA;IACA,gBAAA;IACA,eAAA;IACA,QAAA;IACA,OAAA;IACA,yBAAA;IACA,4BAAA;IACA,aAAA;IACA,wCAAA;EA9eF;EAifA;IACE,wBAAA;EA/eF;EAkfA,wCAAA;EACA;IACE,yBAAA;IACA,WAAA;IACA,gCAAA;EAhfF;EAmfE;IAIE,gCAAA;EApfJ;EAwfA,gCAAA;EACA;IACE,OAAA;IACA,aAAA;IACA,YAAA;EAtfF;EAyfA;IACE,YAAA;EAvfF;EA0fA;IACE,YAAA;EAxfF;EA2fA;IACE,eAAA;EAzfF;EA4fA;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EA1fF;EA6fA;IACE,+BAAA,EAAA,0CAAA;EA3fF;EA8fA,wCAAA;EACA;IACE,kBAAA;IACA,SAAA;IACA,eAAA;EA5fF;EA+fA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA7fF;AACF;AAggBA,uBAAA;AACA;EACE;IACE,cAAA;EA9fF;EAigBA;IACE,aAAA;EA/fF;EAkgBA;IACE,YAAA;EAhgBF;EAmgBA;IACE,eAAA;IACA,cAAA;EAjgBF;EAogBA;IACE,YAAA;EAlgBF;EAqgBA;;IAEE,YAAA;EAngBF;EAsgBA;IACE,WAAA;IACA,YAAA;EApgBF;EAugBA;IACE,gBAAA;EArgBF;AACF;AAygBA;EACE,iBAAA;EACA,oBAAA;EACA,mCAAA;AAvgBF;;AA0gBA,6FAAA;AACA;EACE,kBAAA;EACA,oBAAA;AAvgBF;;AA0gBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EACA,sFAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;AAvgBF;;AA0gBA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,mCAAA;EACA,cAAA;EACA,aAAA;AAvgBF;AA0gBE;EACE,UAAA;AAxgBJ;AA2gBE;EACE,mBAAA;EACA,mBAAA;AAzgBJ;AA4gBE;EACE,gBAAA;EACA,mBAAA;AA1gBJ;AA4gBI;EACE,gBAAA;AA1gBN;;AA+gBA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,qCAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;AA5gBF;AA8gBE;EACE,qCAAA;EACA,wCAAA;AA5gBJ;AA+gBE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AA7gBJ;AAghBE;EACE,WAAA;AA9gBJ;AAkhBE;EApCF;IAqCI,QAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EA/gBF;EAihBE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA/gBJ;AACF;;AAmhBA;EACE;IACE,UAAA;EAhhBF;EAkhBA;IACE,UAAA;EAhhBF;AACF;AAmhBA;EACE;IACE,4BAAA;IACA,UAAA;EAjhBF;EAmhBA;IACE,wBAAA;IACA,UAAA;EAjhBF;AACF;AAqhBA;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAnhBF;AAqhBE;;;;;EAKE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAnhBJ;AAqhBI;;;;;EACE,uBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AA/gBN;AAkhBI;;;;;;;;;;EAEE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAxgBN;AA4gBI;;;;;EACE,aAAA;EACA,cAAA;AAtgBN;AA0gBI;;;;;EACE,kCAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AApgBN;AAwgBI;;;;;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;AAlgBN;;AAugBA,wEAAA;AACA;EACE,8BAAA;AApgBF;AAsgBE;;;;;EA6BE,+CAAA;EA2BA,qDAAA;AAtjBJ;AAmgBI;;;;;EACE,oCAAA;EACA,yBAAA;AA7fN;AAggBI;;;;;;;;;;EAEE,8BAAA;EACA,yBAAA;EACA,oCAAA;AAtfN;AAyfI;;;;;EACE,kCAAA;EACA,2BAAA;AAnfN;AAsfI;;;;;;;;;;;;;;;;;;;;EAIE,yBAAA;AApeN;AAweI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAME,yBAAA;AA9cN;AAidI;;;;;;;;;;;;;;;EAGE,yBAAA;AAncN;AAscI;;;;;;;;;;EAEE,gCAAA;AA5bN;AA+bI;;;;;;;;;;EAEE,qDAAA;EACA,iDAAA;AArbN;AAybI;;;;;;;;;;EAEE,yBAAA;AA/aN;AAkbI;;;;;;;;;;;;;;;EAGE,oCAAA;AApaN;AAuaI;;;;;;;;;;;;;;;;;;;;EAIE,yBAAA;AArZN;AAwZI;;;;;;;;;;;;;;;;;;;;;;;;;EAKE,yBAAA;AAlYN;AAqYI;;;;;;;;;;EAEE,yBAAA;AA3XN;AA8XI;;;;;;;;;;;;;;;;;;;;EAIE,sDAAA;EACA,yDAAA;AA5WN;AA+WI;;;;;;;;;;;;;;;EAGE,kDAAA;AAjWN;;AAwWA;;;;;;;;;EASE,yBAAA;AArWF;;AAyWA;;;;EAIE,yBAAA;AAtWF;;AA0WA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mCAAA;EACA,cAAA;EACA,mBAAA;AAvWF;AAyWE;EACE,cAAA;EACA,iBAAA;AAvWJ;AA0WE;EACE,OAAA;EACA,gBAAA;AAxWJ;AA2WE;EACE,qCAAA;EACA,oCAAA;AAzWJ;AA2WI;EACE,cAAA;AAzWN;AA6WE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AA3WJ;AA6WI;EACE,cAAA;EACA,gBAAA;AA3WN;AA+WE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AA7WJ;AA+WI;EACE,iBAAA;AA7WN;;AAkXA;;EAEE,cAAA;EACA,oCAAA;AA/WF","sourcesContent":[":host {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica,\n    Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 14px;\n  color: #333;\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.flowchest-platform-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  border-top: 1px solid #e8e8e8;\n  color: #666;\n  font-size: 0.8rem;\n  background: #fff;\n  /* Pinned to the viewport: dashboard pages position content absolutely, so a\n     sticky/in-flow footer ends up mid-screen once the page scrolls. */\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 240px;\n  z-index: 20;\n  transition: left 0.3s ease;\n\n  &.sidebar-collapsed,\n  &.sidebar-overlay {\n    left: 0;\n  }\n}\n\n@media (max-width: 1024px) {\n  .flowchest-platform-footer {\n    left: 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .flowchest-platform-footer {\n    left: 0;\n    padding: 0.5rem;\n  }\n}\n\n.flowchest-platform-footer img {\n  height: 18px;\n  width: auto;\n}\n\n.app-layout.theme-dark-layout .flowchest-platform-footer,\nbody.theme-dark .flowchest-platform-footer {\n  background: #1e1e1e;\n  border-top-color: #333;\n  color: #aaa;\n}\n\n.app-layout.theme-dark-layout .org-scope-switcher--mobile,\nbody.theme-dark .org-scope-switcher--mobile {\n  background: #1e1e1e;\n  border-bottom-color: #333;\n}\n\n.app-layout.theme-dark-layout .org-scope-switcher select,\nbody.theme-dark .org-scope-switcher select {\n  background: #2a2a2a;\n  border-color: #444;\n  color: #eee;\n}\n\n.org-brand-logo {\n  max-height: 36px;\n  width: auto;\n  object-fit: contain;\n}\n\n.org-scope-switcher {\n  display: flex;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.org-scope-switcher--desktop {\n  margin-left: 0.75rem;\n}\n\n.org-scope-switcher select {\n  max-width: 160px;\n  font: inherit;\n  font-size: 0.8rem;\n  padding: 0.25rem 0.4rem;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.org-scope-switcher--mobile {\n  display: none;\n}\n\n.org-scope-switcher--sidebar {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.35rem;\n  padding: 0 12px 8px;\n}\n\n.org-scope-switcher--sidebar select {\n  max-width: none;\n  width: 100%;\n  font-size: 0.85rem;\n  padding: 0.45rem 0.5rem;\n}\n\n.org-scope-label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #888;\n  margin-top: 4px;\n}\n\n@media (max-width: 768px) {\n  .org-scope-switcher--mobile {\n    display: flex;\n    position: sticky;\n    top: 56px;\n    z-index: 90;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 8px 12px;\n    gap: 8px;\n    background: #fff;\n    border-bottom: 1px solid #e8e8e8;\n  }\n\n  .org-scope-switcher--mobile select {\n    flex: 1;\n    max-width: none;\n    min-width: 0;\n    font-size: 0.8rem;\n    padding: 0.4rem 0.5rem;\n  }\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 8px 0;\n}\n\np {\n  margin: 0;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.toolbar {\n  height: 60px;\n  margin: -8px;\n  display: flex;\n  align-items: center;\n  background-color: #1976d2;\n  color: white;\n  font-weight: 600;\n}\n\n.toolbar img {\n  margin: 0 16px;\n}\n\n.toolbar #twitter-logo {\n  height: 40px;\n  margin: 0 16px;\n}\n\n.toolbar #twitter-logo:hover {\n  opacity: 0.8;\n}\n\n.content {\n  display: flex;\n  margin: 32px auto;\n  padding: 0 16px;\n  max-width: 960px;\n  flex-direction: column;\n  align-items: center;\n}\n\nsvg.material-icons {\n  height: 24px;\n  width: auto;\n}\n\nsvg.material-icons:not(:last-child) {\n  margin-right: 8px;\n}\n\n.card svg.material-icons path {\n  fill: #888;\n}\n\n.card-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 16px;\n}\n\n.card {\n  border-radius: 4px;\n  border: 1px solid #eee;\n  background-color: #fafafa;\n  height: 40px;\n  width: 200px;\n  margin: 0 8px 16px;\n  padding: 16px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.2s ease-in-out;\n  line-height: 24px;\n}\n\n.card-container .card:not(:last-child) {\n  margin-right: 0;\n}\n\n.card.card-small {\n  height: 16px;\n  width: 168px;\n}\n\n.card-container .card:not(.highlight-card) {\n  cursor: pointer;\n}\n\n.card-container .card:not(.highlight-card):hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 17px rgba(black, 0.35);\n}\n\n.card-container .card:not(.highlight-card):hover .material-icons path {\n  fill: rgb(105, 103, 103);\n}\n\n.card.highlight-card {\n  background-color: #1976d2;\n  color: white;\n  font-weight: 600;\n  border: none;\n  //width: auto;\n  min-width: 30%;\n  position: relative;\n}\n\n.card.card.highlight-card span {\n  margin-left: 60px;\n}\n\nsvg#rocket {\n  width: 80px;\n  position: absolute;\n  left: -10px;\n  top: -24px;\n}\n\nsvg#rocket-smoke {\n  height: 100vh;\n  position: absolute;\n  top: 10px;\n  right: 180px;\n  z-index: -10;\n}\n\na,\na:visited,\na:hover {\n  color: #1976d2;\n  text-decoration: none;\n}\n\na:hover {\n  color: #125699;\n}\n\n.terminal {\n  position: relative;\n  width: 80%;\n  max-width: 600px;\n  border-radius: 6px;\n  padding-top: 45px;\n  margin-top: 8px;\n  overflow: hidden;\n  background-color: rgb(15, 15, 16);\n}\n\n.terminal::before {\n  content: \"\\2022 \\2022 \\2022\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 4px;\n  background: rgb(58, 58, 58);\n  color: #c2c3c4;\n  width: 100%;\n  font-size: 2rem;\n  line-height: 0;\n  padding: 14px 0;\n  text-indent: 4px;\n}\n\n.terminal pre {\n  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;\n  color: white;\n  padding: 0 1rem 1rem;\n  margin: 0;\n}\n\n.circle-link {\n  height: 40px;\n  width: 40px;\n  border-radius: 40px;\n  margin: 8px;\n  background-color: white;\n  border: 1px solid #eeeeee;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  transition: 1s ease-out;\n}\n\n.circle-link:hover {\n  transform: translateY(-0.25rem);\n  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);\n}\n\nfooter {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  line-height: 20px;\n}\n\nfooter a {\n  display: flex;\n  align-items: center;\n}\n\n.github-star-badge {\n  color: #24292e;\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  padding: 3px 10px;\n  border: 1px solid rgba(27, 31, 35, 0.2);\n  border-radius: 3px;\n  background-image: linear-gradient(-180deg, #fafbfc, #eff3f6 90%);\n  margin-left: 4px;\n  font-weight: 600;\n  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial,\n    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;\n}\n\n.github-star-badge:hover {\n  background-image: linear-gradient(-180deg, #f0f3f6, #e6ebf1 90%);\n  border-color: rgba(27, 31, 35, 0.35);\n  background-position: -0.5em;\n}\n\n.github-star-badge .material-icons {\n  height: 16px;\n  width: 16px;\n  margin-right: 4px;\n}\n\nsvg#clouds {\n  position: fixed;\n  bottom: -160px;\n  left: -230px;\n  z-index: -10;\n  width: 1920px;\n}\n\n/*my code starts here*/\n.fixed-header {\n  position: sticky;\n  top: 0px;\n  z-index: 10;\n  display: flex;\n  padding: 0px 3rem;\n  a {\n    min-width: unset;\n    display: block;\n    padding: 0px;\n    &:hover {\n      background: transparent;\n    }\n  }\n  div {\n    flex: 1;\n  }\n  .mat-icon {\n    width: 30px;\n    margin-right: 0px !important;\n    font-size: 28px !important;\n\n    &:last-of-type {\n      margin-right: 0px !important;\n    }\n    & ~ span {\n      margin-right: 0px !important;\n      width: 25px;\n      height: auto;\n    }\n  }\n}\n// .zoom:hover{\n//   transform: scale(0);\n// }\n\n/* Responsive Styles */\n@media screen and (max-width: 767px) {\n  .card-container > *:not(.circle-link),\n  .terminal {\n    width: 100%;\n  }\n\n  .card:not(.highlight-card) {\n    height: 16px;\n    margin: 8px 0;\n  }\n\n  .card.highlight-card span {\n    margin-left: 72px;\n  }\n\n  svg#rocket-smoke {\n    right: 120px;\n    transform: rotate(-5deg);\n  }\n}\n\n@media screen and (max-width: 575px) {\n  svg#rocket-smoke {\n    display: none;\n    visibility: hidden;\n  }\n}\n\n.filler {\n  flex: 1 1 auto;\n}\n.gap {\n  margin-right: 10px;\n}\n\n.mat-option-text {\n  font-size: 15px !important;\n}\n.toolbar {\n  position: sticky;\n  position: -webkit-sticky; /* For macOS/iOS Safari */\n  top: 0; /* Sets the sticky toolbar to be on top */\n  z-index: 1000; /* Ensure that your app's content doesn't overlap the toolbar */\n}\n\n.mat-badge-content {\n  background: red;\n}\n\nnav {\n  display: flex;\n  align-items: center;\n  background: #00a9d4;\n  height: 60px;\n  position: relative;\n}\n.icon {\n  cursor: pointer;\n  margin-right: 50px;\n  line-height: 60px;\n}\n.icon span {\n  background: #f00;\n  padding: 7px;\n  border-radius: 50%;\n  color: #fff;\n  vertical-align: top;\n  margin-left: -25px;\n}\n.icon img {\n  display: inline-block;\n  width: 40px;\n  margin-top: 20px;\n}\n.icon:hover {\n  opacity: 0.7;\n}\n\n.logo {\n  flex: 1;\n  margin-left: 50px;\n  color: #eee;\n  font-size: 20px;\n  font-family: monospace;\n}\n\n.notifi-box {\n  width: 300px;\n  height: 0px;\n  opacity: 0;\n  position: absolute;\n  top: 63px;\n  right: 35px;\n  transition: 1s opacity, 250ms height;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  z-index: 1;\n}\n.notifi-box h2 {\n  font-size: 14px;\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n  color: #999;\n}\n.notifi-box h2 span {\n  color: #f00;\n}\n.notifi-item {\n  display: flex;\n  border-bottom: 1px solid #eee;\n  padding: 15px 5px;\n  margin-bottom: 15px;\n  cursor: pointer;\n}\n// .notifi-item:hover {\n// \tbackground-color: #eee;\n// }\n.notifi-item img {\n  display: block;\n  width: 50px;\n  margin-right: 10px;\n  border-radius: 50%;\n}\n.notifi-item .text h4 {\n  color: #777;\n  font-size: 16px;\n  margin-top: 10px;\n}\n.notifi-item .text p {\n  color: #aaa;\n  font-size: 12px;\n}\n\n.mat-badge.hide-text .mat-badge-content {\n  color: transparent;\n}\n\n.example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n  margin-left: 420px;\n}\n\n.example-full-width {\n  width: 100%;\n}\n// .cdk-overlay-pane .mat-menu-panel{\n//   left:auto !important;\n//   top:34px !important;\n\n// }\n\n::ng-deep .cdk-overlay-pane .mat-menu-panel {\n  max-width: 536px;\n  max-width: 536px;\n  max-width: 536px;\n  max-width: unset;\n  min-width: 261px;\n  width: auto;\n  position: relative;\n  transform-origin: 50% 100%;\n  transition: all 0.5s linear;\n  // padding: 10px 20px;\n  text-align: left;\n  top: 34px !important;\n  overflow: hidden;\n  position: relative;\n  z-index: 3;\n\n  &:empty {\n    display: none;\n  }\n  &:focus {\n    background: rgba(0, 0, 0, 0.04);\n    outline: 0px;\n  }\n  .mat-menu-content {\n    .mat-menu-item {\n      font-family: \"Raleway\";\n      font-weight: 500;\n      font-style: normal;\n      font-display: swap;\n    }\n  }\n  button {\n    // background:#70bfe2;\n    margin: 5px 0px;\n    // border-left:4px solid #70bfe2;\n    position: relative;\n    font-family: \"Raileway\";\n    z-index: 2;\n    &:before {\n      content: \"\";\n      width: 2px;\n      height: 100%;\n      top: 0px;\n      left: 0px;\n      background: var(--fc-brand, #5ea1d8);\n      position: absolute;\n      transition: width 0.5s ease-in-out;\n      z-index: -1;\n    }\n    &:focus {\n      outline: 0px;\n    }\n\n    &:hover {\n      color: #fff;\n      background: #fff;\n      &:before {\n        width: 100%;\n      }\n    }\n  }\n}\n\nngx-avatar {\n  display: inline-block;\n}\n\n/*my code starts here*/\n.flowbycat {\n  height: auto;\n}\n.fix-head {\n  position: sticky;\n  top: 0px;\n  z-index: 100;\n  .material-icons {\n    color: #212427 !important;\n  }\n}\n.fixed-header {\n  position: sticky;\n  top: 0px;\n  z-index: 10;\n  display: flex;\n  padding: 0px 3rem;\n  padding-right: calc(3rem + 0px);\n  padding-left: calc(3rem + 0px);\n  height: 80px;\n  display: flex;\n  align-items: center;\n  border-bottom: 2px solid lightgrey;\n  a {\n    min-width: unset;\n    display: block;\n    padding: 0px;\n    text-align: left;\n    &:focus {\n      outline: none !important;\n    }\n    span {\n      &:focus {\n        outline: none !important;\n      }\n    }\n    &:hover {\n      background: transparent;\n    }\n  }\n  div {\n    flex: 1;\n    align-items: center;\n    text-align: center;\n  }\n}\n@media screen and (min-width: 993px) {\n  .mobileonly {\n    display: none;\n  }\n  .analyticmobile {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  // ::ng-deep .cdk-overlay-pane .mat-menu-panel {\n  //    button{\n  //       // background:#70bfe2;\n  //       margin:5px 0px;\n  //       // border-left:4px solid #70bfe2;\n  //       position:relative;\n  //       font-family: \"Raileway\";\n  //       z-index: 2;\n  //       &:active, &:link, &:focus, &:target, &:visited{\n  //         background:#70bfe2;\n  //         color:#fff;\n  //       }\n\n  //     }\n\n  // }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .flowbycat {\n    min-height: 92vh !important;\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.tooltip {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 120px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\n@media only screen and (max-width: 1000px) and (min-width: 760px) {\n  .mobileonly {\n    display: none;\n  }\n}\n.desktopmob {\n  display: none !important;\n}\n@media (max-width: 767px) {\n  .desktopmob {\n    display: flex !important;\n    flex-direction: column;\n  }\n  .right-nav {\n    display: none;\n  }\n  .mobileonly {\n    position: relative;\n    top: 10px;\n  }\n}\n\n// App layout styles\n.app-layout {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: #ffffff;\n  color: #000000;\n  font-family: \"Roboto\", \"Arial\", sans-serif;\n}\n\n.app-layout.theme-light-layout {\n  background-color: #ffffff;\n  color: #000000;\n}\n\n.app-layout.theme-dark-layout {\n  background-color: #0a0c10;\n  color: #ffffff;\n}\n\nbody.theme-dark {\n  .app-layout {\n    background-color: #0a0c10;\n    color: #e2e8f0;\n  }\n\n  .app-header {\n    background-color: rgba(10, 12, 16, 0.95);\n    border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n  }\n\n  .menu-button,\n  .header-icon,\n  .profile-button mat-icon {\n    color: #f8fafc;\n  }\n\n  .header-org-role {\n    background: rgba(94, 161, 216, 0.2);\n    border-color: rgba(94, 161, 216, 0.45);\n    color: #93c5e8;\n  }\n\n  .sidebar-account-option-role {\n    color: #94a3b8;\n  }\n\n  .sidebar-account-option--active .sidebar-account-option-role {\n    color: #93c5e8;\n  }\n\n  .menu-button:hover,\n  .header-icon:hover,\n  .search-icon-button:hover,\n  .cancel-icon-button:hover {\n    background-color: rgba(255, 255, 255, 0.12);\n    color: #ffffff;\n  }\n\n  .search-box {\n    background-color: #111827 !important;\n    border-color: #475569 !important; // solid, clearly visible slate border\n  }\n\n  .app-search-input {\n    color: #e2e8f0 !important;\n    -webkit-text-fill-color: #e2e8f0 !important;\n    caret-color: #e2e8f0 !important;\n    opacity: 1 !important;\n  }\n\n  .app-search-input::placeholder {\n    color: #94a3b8 !important;\n    -webkit-text-fill-color: #94a3b8 !important;\n    opacity: 1 !important;\n  }\n\n  .app-sidebar {\n    background-color: #0f172a;\n    border-right: 1px solid rgba(148, 163, 184, 0.2);\n  }\n\n  .sidebar-section .sidebar-section-header h3 {\n    color: #94a3b8;\n  }\n\n  .sidebar-item,\n  .sidebar-item mat-icon {\n    color: #e2e8f0;\n  }\n\n  .sidebar-item:hover,\n  .sidebar-item.active {\n    background-color: rgba(148, 163, 184, 0.15);\n  }\n\n  /* Account type switcher must stay readable on dark sidebar */\n  .sidebar-account-option {\n    color: #e2e8f0;\n\n    mat-icon {\n      color: #94a3b8;\n    }\n\n    &:hover:not(.sidebar-account-option--active) {\n      background: rgba(94, 161, 216, 0.16);\n\n      mat-icon {\n        color: #93c5e8;\n      }\n\n      .sidebar-account-option-name {\n        color: #f8fafc;\n      }\n    }\n\n    &--active {\n      background: rgba(94, 161, 216, 0.18);\n      border-color: rgba(94, 161, 216, 0.45);\n\n      mat-icon,\n      .sidebar-account-option-check {\n        color: #93c5e8 !important;\n      }\n\n      .sidebar-account-option-name {\n        color: #f8fafc;\n      }\n    }\n  }\n\n  .sidebar-account-option-name {\n    color: #e2e8f0;\n  }\n\n  .app-main-content {\n    background-color: #0a0c10;\n  }\n\n  .app-logo img {\n    filter: brightness(1.05);\n  }\n\n  .search-icon-button,\n  .cancel-icon-button,\n  .search-button {\n    color: #e2e8f0;\n  }\n\n  .search-history-dropdown,\n  .mobile-search-history {\n    background-color: #0f172a;\n    border-color: rgba(148, 163, 184, 0.25);\n  }\n\n  .search-history-header {\n    background-color: #111827;\n    border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n  }\n\n  // All text and icons inside the suggestions / history dropdown\n  .search-history-title,\n  .history-text,\n  .no-history-message {\n    color: #e2e8f0 !important;\n  }\n\n  // History & item icons (mat-icon with .history-icon)\n  .search-history-item .history-icon,\n  .search-history-item mat-icon.history-icon {\n    color: #cbd5e1 !important;\n  }\n\n  // \"Tap to add\" hint + add icon\n  .search-history-hint {\n    color: #93c5fd !important;\n  }\n\n  .search-item-suggestion mat-icon.add-item-icon,\n  .add-item-icon {\n    color: #93c5fd !important;\n  }\n\n  // Remove button inside history rows\n  .remove-history-button mat-icon {\n    color: #94a3b8 !important;\n  }\n\n  .search-category-selector {\n    &:hover,\n    &.active {\n      background-color: rgba(255, 255, 255, 0.1);\n    }\n  }\n\n  .search-category-label {\n    color: #ffffff !important;\n  }\n\n  // Also cover chevron in dark mode\n  .search-category-chevron {\n    color: #ffffff !important;\n  }\n\n  .search-cat-icon {\n    color: #cbd5e1 !important;\n  }\n\n  .search-cat-icon-img {\n    filter: brightness(2) invert(0.1) !important;\n    opacity: 0.85 !important;\n  }\n\n  .search-category-chevron {\n    color: #94a3b8 !important;\n  }\n\n  .search-category-divider {\n    background-color: #475569 !important;\n  }\n\n  // Both desktop and mobile dropdowns — dark card\n  .search-category-dropdown,\n  .search-category-dropdown--mobile {\n    background-color: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4) !important;\n  }\n\n  // Options inside the dropdown\n  .search-category-option {\n    color: #e2e8f0 !important;\n    background-color: transparent !important;\n\n    mat-icon {\n      color: #cbd5e1 !important;\n    }\n\n    .category-option-img {\n      filter: brightness(2) !important;\n      opacity: 0.85 !important;\n    }\n\n    &:hover {\n      background-color: var(--fc-brand, #5ea1d8) !important;\n      color: #ffffff !important;\n\n      mat-icon {\n        color: #ffffff !important;\n      }\n    }\n\n    &.selected {\n      background-color: transparent !important;\n      color: #7bbde8 !important;\n      font-weight: 600;\n\n      mat-icon {\n        color: #7bbde8 !important;\n      }\n\n      &:hover {\n        background-color: var(--fc-brand, #5ea1d8) !important;\n        color: #ffffff !important;\n\n        mat-icon {\n          color: #ffffff !important;\n        }\n      }\n    }\n  }\n\n  .mobile-search-box-in-header {\n    background: #111827 !important;\n    border-color: #475569 !important;\n  }\n\n  .search-item-suggestion:hover {\n    background-color: rgba(59, 130, 246, 0.15) !important;\n  }\n\n  .search-history-item:hover,\n  .search-history-item.selected {\n    background-color: rgba(148, 163, 184, 0.15);\n  }\n\n  .clear-history-button {\n    color: #93c5fd;\n  }\n\n  .clear-history-button:hover {\n    background-color: rgba(147, 197, 253, 0.15);\n  }\n\n  .app-sidebar .sidebar-item .bundle-menu-icon {\n    filter: brightness(1.2);\n  }\n\n  .sidebar-backdrop {\n    background-color: rgba(0, 0, 0, 0.65);\n  }\n\n  .notification-badge {\n    background-color: #ef4444;\n  }\n\n  .profile-image {\n    border: 1px solid rgba(148, 163, 184, 0.35);\n  }\n\n  .mobile-search-box-in-header .mobile-search-field .app-search-input {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n    color: #e2e8f0 !important;\n    -webkit-text-fill-color: #e2e8f0 !important;\n    caret-color: #e2e8f0 !important;\n    opacity: 1 !important;\n  }\n\n  .mobile-search-box-in-header .mobile-search-field .app-search-input::placeholder {\n    color: #94a3b8 !important;\n    -webkit-text-fill-color: #94a3b8 !important;\n    opacity: 1 !important;\n  }\n\n  /* Icon colours inside the mobile header search bar in dark mode */\n  .mobile-search-box-in-header .mobile-search-field .cancel-icon-button,\n  .mobile-search-box-in-header .mobile-search-field .search-icon-button {\n    color: #94a3b8 !important;\n  }\n\n  .mobile-search-box-in-header .mobile-search-field .cancel-icon-button mat-icon,\n  .mobile-search-box-in-header .mobile-search-field .search-icon-button mat-icon {\n    color: #94a3b8 !important;\n  }\n\n  @media (max-width: 768px) {\n    .app-header .search-box {\n      background-color: transparent !important;\n      border-color: transparent !important;\n    }\n\n    .mobile-search-box-in-header .mobile-search-field .app-search-input {\n      background: transparent !important;\n    }\n  }\n}\n\n.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  height: 56px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e0e0e0;\n  position: fixed;\n  top: 0;\n  z-index: 1000;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible; /* Changed to visible to allow dropdown to show */\n  \n  /* When mobile search is active, ensure overflow is visible */\n  &:has(.mobile-search-active) {\n    overflow: visible;\n  }\n\n  // On desktop, position translate iframe next to search box\n  @media (min-width: 956px) {\n    // Keep header at top - iframe will be positioned at bottom (not in header)\n    bottom: 0 !important;\n\n    // Note: Translate iframe positioning moved to bottom footer - see desktop media query below\n    // Removed header positioning to allow bottom positioning to take effect\n  }\n}\n\n.app-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.menu-button {\n  background: none;\n  border: none;\n  color: #000000;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.menu-button:hover {\n  background-color: #f0f0f0;\n}\n\n.app-logo {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.app-logo img {\n  height: 45px;\n  width: auto;\n}\n\n.app-search-container {\n  flex: 1;\n  max-width: 640px;\n  margin: 0 40px;\n}\n\n.search-box {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid #d0d0d0;\n  border-radius: 40px;\n  overflow: visible; // Changed from hidden to visible to show dropdown\n  height: 40px;\n  position: relative;\n  \n  &.search-box-focused {\n    border-color: #1a73e8;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n}\n\n// ─── Pexels-style category selector ───────────────────────────────────────────\n\n.search-category-selector {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 12px;\n  height: 100%;\n  cursor: pointer;\n  border-radius: 40px 0 0 40px; // left-rounded to match search-box\n  user-select: none;\n  flex-shrink: 0;\n  position: relative;\n  white-space: nowrap;\n  transition: background-color 0.15s;\n\n  &:hover,\n  &.active {\n    background-color: #f0f0f0;\n  }\n}\n\n.search-category-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111111;\n  line-height: 1;\n}\n\n.theme-dark-layout .search-category-label,\nbody.theme-dark .search-category-label {\n  color: #ffffff !important;\n}\n\n.theme-dark-layout .search-category-chevron {\n  color: #ffffff !important;\n}\n\n.search-category-chevron {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  color: #555;\n  transition: transform 0.2s;\n\n  .search-category-selector.active & {\n    transform: rotate(180deg);\n  }\n}\n\n// Thin vertical divider between selector and input\n.search-category-divider {\n  width: 1px;\n  height: 22px;\n  background-color: #d0d0d0;\n  flex-shrink: 0;\n  margin: 0 2px;\n}\n\n// Category dropdown panel (desktop)\n.search-category-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  min-width: 160px;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);\n  z-index: 1100;\n  overflow: hidden;\n  padding: 6px 0;\n}\n\n// Mobile category dropdown: fixed below header\n.search-category-dropdown--mobile {\n  position: fixed;\n  top: 56px;\n  left: 8px;\n  min-width: 160px;\n  border-radius: 0 0 10px 10px;\n  border-top: none;\n}\n\n.search-category-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #212427;\n  text-align: left;\n  transition: background-color 0.12s;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #606060 !important;\n    flex-shrink: 0;\n  }\n\n  .category-option-img {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n    flex-shrink: 0;\n    opacity: 0.7;\n  }\n\n  span {\n    flex: 1;\n    font-weight: 400;\n  }\n\n  &:hover {\n    background-color: var(--fc-brand, #5ea1d8);\n    color: #ffffff;\n\n    mat-icon,\n    .category-option-img {\n      color: #ffffff !important;\n      opacity: 1;\n    }\n  }\n\n  &.selected {\n    background-color: transparent;\n    color: var(--fc-brand, #5ea1d8);\n    font-weight: 600;\n\n    mat-icon,\n    .category-option-img {\n      color: var(--fc-brand, #5ea1d8) !important;\n      opacity: 1;\n    }\n\n    &:hover {\n      background-color: var(--fc-brand, #5ea1d8);\n      color: #ffffff;\n\n      mat-icon,\n      .category-option-img {\n        color: #ffffff !important;\n      }\n    }\n  }\n}\n\n// ── Mobile selector: icon-only, compact (Pexels mobile style) ─────────────────\n.search-category-selector--mobile {\n  padding: 0 6px 0 10px;\n  border-radius: 0;\n  gap: 1px;\n\n  // Hide the text label on mobile — icon only\n  .search-category-label {\n    display: none;\n  }\n\n  .search-cat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #444;\n  }\n\n  .search-cat-icon-img {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n    opacity: 0.75;\n  }\n\n  .search-category-chevron {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    color: #666;\n    // Reset the rotate so we use the up/down icon swap instead\n    transform: none !important;\n  }\n}\n\n// ── Items-mode static indicator on mobile — same look as the icon selector ─────\n.search-category-selector--indicator {\n  cursor: default;\n  pointer-events: none;\n  // No hover / active state needed\n  &:hover,\n  &.active {\n    background-color: transparent;\n  }\n}\n\n// ── Mobile dropdown card (small, left-aligned, Pexels-like) ───────────────────\n.search-category-dropdown--mobile {\n  position: fixed;\n  top: 56px;\n  left: 8px;\n  min-width: 140px;\n  max-width: 180px;\n  border-radius: 10px !important; // override the 0 0 10px 10px from earlier\n  border-top: 1px solid #e0e0e0 !important; // full border — it's a floating card\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);\n  padding: 4px 0;\n  z-index: 1200;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n\n  .search-category-option {\n    padding: 11px 14px;\n    font-size: 15px;\n    gap: 10px;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n\n    // Pexels uses a colour icon for the active option\n    &.selected {\n      mat-icon { color: #1a73e8; }\n      img.category-option-img { opacity: 1; filter: none; }\n    }\n  }\n}\n\n// ──────────────────────────────────────────────────────────────────────────────\n\n.app-search-input {\n  flex: 1;\n  background: none;\n  border: none;\n  color: #000000;\n  padding: 0 16px;\n  padding-right: 96px; // Space for cancel button (when visible) + search button\n  font-size: 16px;\n  outline: none;\n}\n\n.app-search-input::placeholder {\n  color: #666666;\n}\n\n.search-icon-button {\n  position: absolute;\n  right: 8px;\n  background: transparent;\n  border: none;\n  color: #666666;\n  padding: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s, background-color 0.2s;\n  z-index: 1;\n  border-radius: 50%;\n}\n\n.search-icon-button:hover {\n  color: #000000;\n  background-color: #f0f0f0;\n}\n\n.search-icon-button mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.cancel-icon-button {\n  position: absolute;\n  right: 48px; // Positioned to the left of search button\n  background: transparent;\n  border: none;\n  color: #666666;\n  padding: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s, background-color 0.2s;\n  z-index: 1;\n  border-radius: 50%;\n}\n\n.cancel-icon-button:hover {\n  color: #000000;\n  background-color: #f0f0f0;\n}\n\n.cancel-icon-button mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n// Search History Dropdown Styles\n.search-history-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n  z-index: 1001;\n  max-height: 400px;\n  overflow-y: auto;\n  margin-top: 0;\n  \n  // Custom scrollbar\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n    \n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n// \"Tap to add\" hint label in dropdown header\n.search-history-hint {\n  font-size: 11px;\n  color: var(--fc-brand, #5ea1d8);\n  font-weight: 500;\n  letter-spacing: 0.3px;\n  text-transform: none;\n}\n\n// Item suggestion row styling\n.search-item-suggestion {\n  &:hover {\n    background-color: #f0f7ff;\n  }\n\n  .add-item-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: var(--fc-brand, #5ea1d8);\n    flex-shrink: 0;\n    opacity: 0.8;\n    transition: opacity 0.15s;\n  }\n\n  &:hover .add-item-icon {\n    opacity: 1;\n  }\n}\n\n.user-mention-suggestion {\n  &:hover {\n    background-color: #f0f7ff;\n  }\n}\n\n.mention-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  margin-right: 4px;\n}\n\n.mention-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  flex: 1;\n  min-width: 0;\n}\n\n.mention-username {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mention-fullname {\n  font-size: 12px;\n  color: #606060;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.search-history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #fafafa;\n}\n\n.search-history-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #606060;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.clear-history-button {\n  background: none;\n  border: none;\n  color: #1a73e8;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  \n  &:hover {\n    background-color: rgba(26, 115, 232, 0.1);\n  }\n}\n\n.search-history-list {\n  padding: 4px 0;\n}\n\n.search-history-item {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: background-color 0.15s;\n  position: relative;\n  \n  &:hover,\n  &.selected {\n    background-color: #f5f5f5;\n  }\n  \n  .history-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #606060;\n    margin-right: 16px;\n    flex-shrink: 0;\n  }\n  \n  .history-text {\n    flex: 1;\n    font-size: 14px;\n    color: #030303;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  \n  .remove-history-button {\n    background: none;\n    border: none;\n    padding: 4px;\n    cursor: pointer;\n    color: #606060;\n    opacity: 0;\n    transition: opacity 0.2s, color 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    margin-left: 8px;\n    flex-shrink: 0;\n    \n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n    \n    &:hover {\n      color: #030303;\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n  }\n  \n  &:hover .remove-history-button {\n    opacity: 1;\n  }\n}\n\n.no-history-message {\n  padding: 16px;\n  text-align: center;\n  color: #606060;\n  \n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n}\n\n// Mobile search history styles\n.mobile-search-history {\n  position: fixed !important;\n  top: 62px !important;   // just below the 56px header with a small gap\n  left: 8px !important;\n  right: 8px !important;\n  margin: 0;\n  max-height: calc(100vh - 120px);\n  z-index: 1002 !important;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);\n  border-radius: 12px;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n}\n\n.mobile-search-box {\n  position: relative;\n  \n  &.search-box-focused {\n    .mobile-search-field .app-search-input {\n      border-color: #1a73e8;\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n\n.search-button {\n  background: #f5f5f5;\n  border: none;\n  -webkit-appearance: none;\n  color: #000000;\n  padding: 8px 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.search-button:hover {\n  background-color: #e0e0e0;\n}\n\n.app-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative; // For positioning translate container\n}\n\n// Translate toggle icon in header\n.translate-toggle-icon {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  \n  mat-icon {\n    color: #606060;\n    transition: color 0.2s ease;\n  }\n  \n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    \n    mat-icon {\n      color: var(--fc-brand, #5ea1d8);\n    }\n  }\n  \n  // When collapsed, show active state\n  &.collapsed {\n    mat-icon {\n      color: var(--fc-brand, #5ea1d8);\n    }\n  }\n  \n  // Hide translate icon from header on desktop (show only at footer)\n  @media (min-width: 769px) {\n    display: none !important;\n  }\n}\n\n.google-translate-header {\n  display: flex !important;\n  align-items: center;\n  height: 40px;\n  margin: 0 4px;\n  padding: 4px 8px;\n  background-color: #ffffff !important;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  visibility: visible !important;\n  opacity: 1 !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  // Style the Google Translate widget\n  .goog-te-gadget {\n    font-family: \"Roboto\", \"Arial\", sans-serif !important;\n    font-size: 13px !important;\n    display: inline-block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  .goog-te-gadget-simple {\n    background-color: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    padding: 4px 8px !important;\n    font-size: 13px !important;\n    color: #000000 !important;\n    cursor: pointer !important;\n    display: flex !important;\n    align-items: center !important;\n    white-space: nowrap !important;\n    height: auto !important;\n    transition: background-color 0.2s !important;\n\n    &:hover {\n      background-color: transparent !important;\n    }\n  }\n\n  .goog-te-gadget-icon {\n    margin-left: 4px !important;\n    margin-right: 4px !important;\n    display: inline-block !important;\n  }\n\n  // Style the language selector dropdown\n  .goog-te-menu-value {\n    color: #000000 !important;\n\n    span {\n      color: #000000 !important;\n    }\n  }\n\n  // Hide the \"Select Language\" text on smaller screens if needed\n  @media (max-width: 1200px) {\n    .goog-te-gadget-simple .goog-te-menu-value span {\n      display: none;\n    }\n  }\n\n  // Ensure the translate element doesn't overflow\n  overflow: visible;\n  max-width: 200px;\n}\n \n\n// Ensure translate header element is always visible\n#google_translate_element_header {\n  display: flex !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n\n  * {\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n}\n\n// Desktop translate positioning - hide footer translate, show in header\n@media (min-width: 956px) {\n  // Position Google Translate iframe at footer right on desktop\n  // Target all possible Google Translate iframe variations\n  iframe.skiptranslate,\n  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,\n  iframe[class*=\"skiptranslate\"],\n  iframe[id*=\"container\"],\n  iframe[class*=\"VIpgJd\"],\n  iframe[class*=\"VIpgJd-ZVi9od\"],\n  iframe[class*=\"VIpgJd-ZVi9od-ORHb-OEVmcd\"] {\n    position: fixed !important;\n    bottom: 0 !important;\n    left: auto !important;\n    right: 0 !important;\n    top: auto !important;\n    width: auto !important;\n    max-width: 400px !important;\n    min-height: 60px !important;\n    max-height: 300px !important;\n    z-index: 1001 !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important;\n    border-left: 1px solid #e0e0e0 !important;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;\n  }\n  \n  // Show banner frame on desktop but align content to right\n  .goog-te-banner-frame {\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    position: fixed !important;\n    bottom: 0 !important;\n    left: auto !important;\n    right: 0 !important;\n    width: auto !important;\n    max-width: 400px !important;\n    min-height: 60px !important;\n    max-height: 300px !important;\n    z-index: 1001 !important;\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important;\n    border-left: 1px solid #e0e0e0 !important;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;\n  }\n\n  // Ensure header stays at top - no adjustment needed\n  body:has(iframe[class*=\"VIpgJd\"]) .app-header,\n  body:has(iframe.skiptranslate) .app-header,\n  body:has(.goog-te-banner-frame) .app-header {\n    top: 0 !important;\n    z-index: 1000 !important;\n  }\n\n  // Make language selection dropdown scrollable on desktop (same as mobile)\n  .goog-te-menu-frame {\n    max-width: 100% !important;\n    max-height: 70vh !important; // Limit height to 70% of viewport\n    overflow-y: auto !important; // Enable vertical scrolling\n    overflow-x: hidden !important;\n    -webkit-overflow-scrolling: touch !important; // Smooth scrolling on iOS\n    \n    // Style the menu container inside the iframe\n    .goog-te-menu2 {\n      max-height: 70vh !important;\n      overflow-y: auto !important;\n      overflow-x: hidden !important;\n      -webkit-overflow-scrolling: touch !important;\n    }\n  }\n\n  // Ensure the language selection dropdown is scrollable when opened on desktop\n  #google_translate_element_header .goog-te-menu-frame,\n  .google-translate-header .goog-te-menu-frame {\n    max-height: 60vh !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    -webkit-overflow-scrolling: touch !important;\n  }\n  \n  // Toggle button for translate banner - positioned fixed to stay visible\n  .translate-banner-toggle {\n    position: fixed !important;\n    top: 14px !important;\n    right: 20px !important;\n    width: 32px !important;\n    height: 32px !important;\n    background-color: var(--fc-brand, #5ea1d8) !important;\n    color: #ffffff !important;\n    border: none !important;\n    border-radius: 50% !important;\n    cursor: pointer !important;\n    display: none !important; // Hidden by default, shown when banner appears\n    align-items: center !important;\n    justify-content: center !important;\n    z-index: 1005 !important; // Above translate banner\n    box-shadow: 0 2px 8px rgba(94, 161, 216, 0.3) !important;\n    transition: all 0.3s ease !important;\n    font-size: 12px !important;\n    line-height: 1 !important;\n    padding: 0 !important;\n    \n    &:hover {\n      background-color: #4a8fc4 !important;\n      transform: scale(1.1) !important;\n      box-shadow: 0 4px 12px rgba(94, 161, 216, 0.4) !important;\n    }\n    \n    &:active {\n      transform: scale(0.95) !important;\n    }\n    \n    // Icon - chevron down when expanded (to collapse)\n    &::before {\n      content: \"▼\" !important;\n      display: block !important;\n      transition: transform 0.3s ease !important;\n    }\n    \n    // Icon - chevron up when collapsed (to expand)\n    &.collapsed::before {\n      content: \"▲\" !important;\n    }\n  }\n  \n  // Show toggle button when banner frame is visible (not collapsed)\n  body:has(.goog-te-banner-frame:not(.translate-collapsed)),\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)) {\n    .translate-banner-toggle {\n      display: flex !important;\n      top: 74px !important; // Position below translate banner (60px + 14px)\n    }\n  }\n  \n  // Position toggle button at header level when banner is collapsed\n  body:has(.goog-te-banner-frame.translate-collapsed),\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed) {\n    .translate-banner-toggle {\n      display: flex !important;\n      top: 14px !important; // Position at header level\n    }\n  }\n  \n  // Toggle button for translate iframe - positioned in header area\n  .translate-toggle-button {\n    position: fixed !important;\n    top: 14px !important;\n    right: 20px !important;\n    width: 36px !important;\n    height: 36px !important;\n    background-color: var(--fc-brand, #5ea1d8) !important;\n    color: #ffffff !important;\n    border: none !important;\n    border-radius: 50% !important;\n    cursor: pointer !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    z-index: 1005 !important; // Above translate iframe\n    box-shadow: 0 2px 8px rgba(94, 161, 216, 0.3) !important;\n    transition: all 0.3s ease !important;\n    font-size: 14px !important;\n    line-height: 1 !important;\n    padding: 0 !important;\n    \n    &:hover {\n      background-color: #4a8fc4 !important;\n      transform: scale(1.1) !important;\n      box-shadow: 0 4px 12px rgba(94, 161, 216, 0.4) !important;\n    }\n    \n    &:active {\n      transform: scale(0.95) !important;\n    }\n    \n    // Icon content - chevron down when expanded (to collapse)\n    &::before {\n      content: \"▼\" !important;\n      display: block !important;\n      transition: transform 0.3s ease !important;\n      font-size: 14px !important;\n    }\n    \n    // Icon content - chevron up when collapsed (to expand)\n    &.collapsed::before {\n      content: \"▲\" !important;\n      transform: rotate(0deg) !important;\n    }\n    \n    // When translate is collapsed, move button to header level\n    &.collapsed {\n      top: 14px !important; // Position at header level when collapsed\n    }\n  }\n  \n  // Collapsed state for translate elements - completely hidden\n  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed,\n  .goog-te-banner-frame.translate-collapsed {\n    height: 0 !important;\n    min-height: 0 !important;\n    max-height: 0 !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n    display: none !important;\n    border-bottom: none !important;\n    overflow: hidden !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  \n  // Adjust header margin when translate is collapsed - remove translate space\n  body:has(.translate-collapsed) .app-header,\n  body:has(iframe.translate-collapsed) .app-header,\n  body:has(.goog-te-banner-frame.translate-collapsed) .app-header {\n    margin-top: 0 !important;\n    top: 0 !important;\n  }\n  \n  // Adjust body padding when translate is collapsed - remove translate space\n  body:has(.translate-collapsed),\n  body:has(iframe.translate-collapsed),\n  body:has(.goog-te-banner-frame.translate-collapsed) {\n    padding-top: 0 !important;\n  }\n  \n  // Adjust main content padding when translate is collapsed - only header height\n  body:has(.translate-collapsed) .app-main-content,\n  body:has(iframe.translate-collapsed) .app-main-content,\n  body:has(.goog-te-banner-frame.translate-collapsed) .app-main-content {\n    padding-top: 56px !important; // Only header height when collapsed\n  }\n\n  // Exclude legal pages from translate banner padding-top rules\n  body:has(.legal-page) .app-main-content,\n  body:has(app-legal-center-layout) .app-main-content {\n    padding-top: 0px !important;\n  }\n  \n  // Adjust sidebar when translate is collapsed\n  body:has(.translate-collapsed) .app-sidebar,\n  body:has(iframe.translate-collapsed) .app-sidebar,\n  body:has(.goog-te-banner-frame.translate-collapsed) .app-sidebar {\n    top: 56px !important; // Only header height\n    height: calc(100vh - 56px) !important;\n  }\n\n  // Style the banner content on desktop - positioned at bottom right\n  .goog-te-banner-frame skipptr {\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important; // Border at top since it's at bottom\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important; // Shadow above\n    padding: 16px !important;\n    padding-bottom: max(16px, env(safe-area-inset-bottom)) !important;\n    min-height: 60px !important; // Ensure enough height to show selected language\n    max-height: 300px !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    display: flex !important;\n    justify-content: flex-end !important; // Align content to right\n    align-items: center !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    text-align: right !important;\n    \n    // Style the text content inside - align to right\n    * {\n      color: #212529 !important; // Dark text color\n      font-family: \"Raleway\", \"Roboto\", \"Arial\", sans-serif !important;\n      font-size: 14px !important;\n      font-weight: 500 !important;\n      line-height: 1.5 !important;\n      text-align: right !important;\n    }\n    \n    // Style links/buttons inside\n    a,\n    button {\n      color: var(--fc-brand, #5ea1d8) !important; // Brand color for links\n      text-decoration: none !important;\n      transition: color 0.2s ease !important;\n      text-align: right !important;\n      \n      &:hover {\n        color: #4a8fc4 !important; // Darker on hover\n        text-decoration: underline !important;\n      }\n    }\n  }\n  \n  // Additional custom styling for translate iframe container when language is selected\n  // Note: Accent bar removed since translate banner is now at bottom (border-top on iframe provides visual indicator)\n  \n  // Style the Google Translate menu dropdown when opened (desktop)\n  // Note: Direct iframe content styling is limited due to cross-origin restrictions\n  // But we can style the container and any overlay elements\n  .goog-te-menu-frame {\n    border-radius: 8px !important;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;\n    border: 1px solid #e0e0e0 !important;\n    overflow: hidden !important;\n    \n    // Style menu items\n    .goog-te-menu2 {\n      background-color: #ffffff !important;\n      border-radius: 8px !important;\n      \n      .goog-te-menu2-item {\n        padding: 10px 16px !important;\n        color: #212529 !important;\n        font-family: \"Raleway\", \"Roboto\", sans-serif !important;\n        font-size: 14px !important;\n        transition: background-color 0.2s ease !important;\n        \n        &:hover {\n          background-color: #f0f7ff !important; // Light blue hover\n          color: var(--fc-brand, #5ea1d8) !important;\n        }\n        \n        &.goog-te-menu2-item-selected {\n          background-color: var(--fc-brand, #5ea1d8) !important;\n          color: #ffffff !important;\n          font-weight: 600 !important;\n        }\n      }\n    }\n  }\n  \n  // Style for when a language is actively selected (showing selected language text)\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd[style*=\"visibility:visible\"]) {\n    // Ensure the translate banner has custom styling\n    .goog-te-banner-frame {\n      background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%) !important;\n      border-top: 2px solid var(--fc-brand, #5ea1d8) !important; // Border at top since it's at bottom\n      \n      // Style the \"Show original\" or language selection text\n      skipptr {\n        * {\n          color: #212529 !important;\n          font-family: \"Raleway\", \"Roboto\", sans-serif !important;\n          \n          // Style the language name or action text\n          &:first-child {\n            font-weight: 600 !important;\n            color: var(--fc-brand, #5ea1d8) !important;\n          }\n        }\n      }\n    }\n  }\n  \n  // Additional responsive adjustments for translate iframe on desktop\n  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd {\n    // Smooth transitions\n    transition: all 0.3s ease !important;\n    \n    // When visible and language selected\n    &[style*=\"visibility:visible\"] {\n      // Enhanced shadow on hover (if user hovers near it) - shadow above since it's at bottom\n      &:hover {\n        box-shadow: 0 -6px 20px rgba(94, 161, 216, 0.25) !important;\n      }\n    }\n  }\n\n  // Header stays at top - no adjustment needed when banner is at bottom\n  body:has(iframe.skiptranslate:not(.translate-collapsed)) .app-header,\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)) .app-header,\n  body:has(iframe[class*=\"skiptranslate\"]:not(.translate-collapsed)) .app-header,\n  body:has(iframe[id*=\"container\"]:not(.translate-collapsed)) .app-header,\n  body:has(iframe[class*=\"VIpgJd\"]:not(.translate-collapsed)) .app-header,\n  body:has(.goog-te-banner-frame:not(.translate-collapsed)) .app-header {\n    margin-top: 0 !important;\n    top: 0 !important;\n  }\n  \n  // When translate is collapsed, header stays at top\n  body:has(iframe.skiptranslate.translate-collapsed) .app-header,\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed) .app-header,\n  body:has(iframe[class*=\"skiptranslate\"].translate-collapsed) .app-header,\n  body:has(iframe[id*=\"container\"].translate-collapsed) .app-header,\n  body:has(iframe[class*=\"VIpgJd\"].translate-collapsed) .app-header,\n  body:has(.goog-te-banner-frame.translate-collapsed) .app-header {\n    margin-top: 0 !important;\n    top: 0 !important;\n  }\n  \n  // No extra padding on body - translate banner is fixed at bottom and doesn't need body padding\n  body:has(iframe.skiptranslate:not(.translate-collapsed)),\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)),\n  body:has(iframe[class*=\"skiptranslate\"]:not(.translate-collapsed)),\n  body:has(iframe[class*=\"VIpgJd\"]:not(.translate-collapsed)),\n  body:has(.goog-te-banner-frame:not(.translate-collapsed)) {\n    padding-bottom: 0 !important; // No extra padding - translate banner is fixed\n  }\n  \n  // When collapsed, no bottom padding needed\n  body:has(iframe.skiptranslate.translate-collapsed),\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed),\n  body:has(iframe[class*=\"skiptranslate\"].translate-collapsed),\n  body:has(iframe[class*=\"VIpgJd\"].translate-collapsed),\n  body:has(.goog-te-banner-frame.translate-collapsed) {\n    padding-bottom: 0 !important;\n  }\n\n  body:has(iframe.skiptranslate:not(.translate-collapsed)) .app-main-content,\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)) .app-main-content,\n  body:has(iframe[class*=\"skiptranslate\"]:not(.translate-collapsed)) .app-main-content,\n  body:has(iframe[id*=\"container\"]:not(.translate-collapsed)) .app-main-content,\n  body:has(iframe[class*=\"VIpgJd\"]:not(.translate-collapsed)) .app-main-content,\n  body:has(.goog-te-banner-frame:not(.translate-collapsed)) .app-main-content {\n    padding-top: 56px !important; // Header height\n    padding-bottom: 0 !important; // No extra padding - translate banner is fixed at bottom\n  }\n  \n  // When collapsed, keep 56px padding as before\n  body:has(iframe.skiptranslate.translate-collapsed) .app-main-content,\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed) .app-main-content,\n  body:has(iframe[class*=\"skiptranslate\"].translate-collapsed) .app-main-content,\n  body:has(iframe[id*=\"container\"].translate-collapsed) .app-main-content,\n  body:has(iframe[class*=\"VIpgJd\"].translate-collapsed) .app-main-content,\n  body:has(.goog-te-banner-frame.translate-collapsed) .app-main-content {\n    padding-top: 56px !important; // Keep 56px as it was earlier\n    padding-bottom: 0 !important;\n  }\n\n  // Exclude legal pages from all translate banner padding-top rules - use simpler selector\n  body:has(.legal-page) .app-main-content,\n  body:has(app-legal-center-layout) .app-main-content {\n    padding-top: 0px !important;\n  }\n\n  body:has(iframe.skiptranslate:not(.translate-collapsed)) .app-sidebar,\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not(.translate-collapsed)) .app-sidebar,\n  body:has(iframe[class*=\"skiptranslate\"]:not(.translate-collapsed)) .app-sidebar,\n  body:has(iframe[id*=\"container\"]:not(.translate-collapsed)) .app-sidebar,\n  body:has(iframe[class*=\"VIpgJd\"]:not(.translate-collapsed)) .app-sidebar,\n  body:has(.goog-te-banner-frame:not(.translate-collapsed)) .app-sidebar {\n    top: 56px !important; // Only header height\n    height: calc(100vh - 56px) !important; // Full height minus header\n  }\n  \n  // When collapsed, only header height\n  body:has(iframe.skiptranslate.translate-collapsed) .app-sidebar,\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd.translate-collapsed) .app-sidebar,\n  body:has(iframe[class*=\"skiptranslate\"].translate-collapsed) .app-sidebar,\n  body:has(iframe[id*=\"container\"].translate-collapsed) .app-sidebar,\n  body:has(iframe[class*=\"VIpgJd\"].translate-collapsed) .app-sidebar,\n  body:has(.goog-te-banner-frame.translate-collapsed) .app-sidebar {\n    top: 56px !important; // Only header height\n    height: calc(100vh - 56px) !important;\n  }\n\n  // Header stays at top\n  iframe.skiptranslate ~ * .app-header,\n  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd ~ * .app-header,\n  iframe[class*=\"skiptranslate\"] ~ * .app-header,\n  iframe[class*=\"VIpgJd\"] ~ * .app-header,\n  .goog-te-banner-frame ~ * .app-header {\n    position: sticky !important;\n    top: 0 !important; // Header sticks to top\n  }\n  \n  // No top padding needed since banner is at bottom\n  body:has(.goog-te-banner-frame),\n  html:has(.goog-te-banner-frame) {\n    padding-top: 0 !important;\n  }\n  \n  // Ensure translate banner container (body) allows fixed positioning\n  body:has(.goog-te-banner-frame) {\n    position: relative !important;\n  }\n\n  // Final override to ensure translate iframe is at bottom right on desktop - highest priority\n  // This must override ALL other styles including inline styles from Google Translate\n  body iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,\n  html body iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,\n  body iframe[class*=\"VIpgJd-ZVi9od-ORHb-OEVmcd\"],\n  html body iframe[class*=\"VIpgJd-ZVi9od-ORHb-OEVmcd\"],\n  body iframe.skiptranslate,\n  html body iframe.skiptranslate,\n  body iframe[class*=\"skiptranslate\"],\n  html body iframe[class*=\"skiptranslate\"],\n  body iframe[class*=\"VIpgJd\"],\n  html body iframe[class*=\"VIpgJd\"],\n  body iframe[id*=\"container\"],\n  html body iframe[id*=\"container\"] {\n    position: fixed !important;\n    bottom: 0 !important;\n    top: auto !important;\n    left: auto !important;\n    right: 0 !important;\n    width: auto !important;\n    max-width: 400px !important;\n    margin: 0 !important;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    transform: none !important;\n  }\n  \n  // Absolute final override - must be last rule in desktop media query\n  // Target with maximum specificity to override any inline styles\n  // Use :not() to increase specificity even more\n  html body iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not([style*=\"display: none\"]),\n  html body iframe[class*=\"VIpgJd-ZVi9od-ORHb-OEVmcd\"]:not([style*=\"display: none\"]),\n  html body iframe.skiptranslate:not([style*=\"display: none\"]),\n  html body iframe[class*=\"skiptranslate\"]:not([style*=\"display: none\"]),\n  html body iframe[class*=\"VIpgJd\"]:not([style*=\"display: none\"]),\n  html body iframe[id*=\"container\"]:not([style*=\"display: none\"]),\n  // Also target without :not() for maximum coverage\n  html body iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,\n  html body iframe[class*=\"VIpgJd-ZVi9od-ORHb-OEVmcd\"],\n  html body iframe.skiptranslate,\n  html body iframe[class*=\"skiptranslate\"],\n  html body iframe[class*=\"VIpgJd\"],\n  html body iframe[id*=\"container\"] {\n    position: fixed !important;\n    bottom: 0 !important;\n    top: auto !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    padding: 0 !important;\n    padding-top: 0 !important;\n    transform: none !important;\n    z-index: 1001 !important;\n    // Ensure it's not positioned relative to any parent\n    vertical-align: baseline !important;\n  }\n}\n\n// Mobile translate positioning - ensure it doesn't overlap header\n@media (max-width: 955px) {\n  #google_translate_element {\n    position: fixed !important;\n    top: 56px !important; // Below header\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 1000 !important;\n    background-color: #ffffff !important;\n    padding: 8px !important;\n    border-bottom: 1px solid #e0e0e0 !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n\n    // Style the translate widget on mobile\n    .goog-te-gadget {\n      width: 100% !important;\n    }\n\n    .goog-te-gadget-simple {\n      width: 100% !important;\n      justify-content: center !important;\n    }\n  }\n\n  // Move Google Translate banner frame to footer on mobile\n  .goog-te-banner-frame {\n    position: fixed !important;\n    bottom: 0 !important; // Position at footer\n    top: auto !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 1001 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: 60px !important; // Minimum height to show selected language\n    max-height: 300px !important; // Limit max height so it doesn't cover too much\n    margin-bottom: 0 !important;\n    overflow-y: auto !important; // Enable scrolling if content exceeds height\n    overflow-x: hidden !important;\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    display: block !important;\n  }\n\n  // Make language selection dropdown scrollable on mobile\n  .goog-te-menu-frame {\n    max-width: 100% !important;\n    max-height: 70vh !important; // Limit height to 70% of viewport\n    overflow-y: auto !important; // Enable vertical scrolling\n    overflow-x: hidden !important;\n    -webkit-overflow-scrolling: touch !important; // Smooth scrolling on iOS\n    \n    // Style the menu container inside the iframe\n    .goog-te-menu2 {\n      max-height: 70vh !important;\n      overflow-y: auto !important;\n      overflow-x: hidden !important;\n      -webkit-overflow-scrolling: touch !important;\n    }\n  }\n\n  // Ensure the language selection dropdown is scrollable when opened\n  #google_translate_element_mobile .goog-te-menu-frame,\n  .mobile-translate-container .goog-te-menu-frame {\n    max-height: 60vh !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    -webkit-overflow-scrolling: touch !important;\n  }\n\n  // Fix chatbot footer to appear above translate footer on mobile\n  // Set higher z-index and adjust position when translate banner is visible\n  .chatbot-stickyfooter {\n    z-index: 1002 !important; // Higher than translate footer (1001)\n    position: fixed !important; // Change from sticky to fixed for better control\n    bottom: 0 !important;\n    transition: bottom 0.3s ease !important; // Smooth transition when translate appears/disappears\n  }\n\n  // When translate banner frame is visible, position chatbot above it\n  body:has(.goog-te-banner-frame:not([style*=\"display: none\"])) .chatbot-stickyfooter,\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not([style*=\"display: none\"])) .chatbot-stickyfooter {\n    bottom: 60px !important; // Position above translate banner (minimum height)\n  }\n\n  // Also handle chatbot wrapper on mobile - ensure it's above translate footer\n  .chatbot-wrapper {\n    z-index: 1002 !important; // Higher than translate footer (1001)\n    transition: bottom 0.3s ease !important; // Smooth transition\n  }\n\n  // When translate banner is visible, adjust chatbot wrapper position\n  body:has(.goog-te-banner-frame:not([style*=\"display: none\"])) .chatbot-wrapper,\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd:not([style*=\"display: none\"])) .chatbot-wrapper {\n    bottom: 60px !important; // Position above translate banner\n  }\n\n  // When any Angular Material dialog/overlay is open, hide chatbot entirely so it does not overlap modals\n  body:has(.dialoguebox),\n  body:has(.cdk-overlay-pane),\n  body:has(.cdk-overlay-backdrop) {\n    .chatbot-wrapper,\n    .chatbot-btn,\n    .chatbot-stickyfooter {\n    display: none !important;\n    }\n  }\n\n  // Move Google Translate iframe to footer on mobile - when language is selected\n  iframe.skiptranslate,\n  iframe.VIpgJd-ZVi9od-ORHb-OEVmcd,\n  iframe[class*=\"skiptranslate\"],\n  iframe[id*=\"container\"] {\n    position: fixed !important;\n    bottom: 0 !important; // Position at footer\n    top: auto !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 1001 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    height: auto !important;\n    min-height: 60px !important; // Minimum height to show selected language\n    max-height: 300px !important; // Limit max height so it doesn't cover too much\n    margin-bottom: 0 !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    display: block !important;\n    overflow-y: auto !important; // Enable scrolling if content exceeds height\n    overflow-x: hidden !important;\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;\n  }\n\n  // Style the banner content\n  .goog-te-banner-frame skipptr {\n    background-color: #ffffff !important;\n    border-top: 1px solid #e0e0e0 !important;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;\n    padding: 16px !important;\n    padding-bottom: max(16px, env(safe-area-inset-bottom)) !important;\n    min-height: 60px !important; // Ensure enough height to show selected language\n    max-height: 300px !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  // Ensure banner frame content is scrollable\n  .goog-te-banner-frame {\n    & > * {\n      max-height: 100% !important;\n      overflow-y: auto !important;\n    }\n  }\n\n  // Add padding to main content when language selector iframe is visible\n  body:has(iframe.skiptranslate),\n  body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd),\n  body:has(iframe[class*=\"skiptranslate\"]),\n  body:has(iframe[id*=\"container\"]) {\n    .app-main-content {\n      padding-bottom: 180px !important; // Space for language selector iframe (max 300px) + floating button (50px) + extra margin (30px)\n    }\n  }\n\n  // Don't adjust main content padding from top when banner is at footer\n  body:has(.goog-te-banner-frame) {\n    .app-main-content {\n      padding-top: 0 !important;\n      padding-bottom: 180px !important; // Space for footer banner (max 300px) + floating button (50px) + margin (30px)\n    }\n  }\n\n  // Shared Translate Floating Button Style - Used by both mobile and desktop\n  .mobile-translate-floating-btn {\n    position: fixed !important;\n    bottom: 40px !important;\n    right: 16px !important;\n    width: 50px !important;\n    height: 50px !important;\n    border-radius: 50% !important;\n    background-color: var(--fc-brand, #5ea1d8) !important;\n    color: #ffffff !important;\n    border: none !important;\n    outline: none !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n    cursor: pointer !important;\n    z-index: 900 !important; // Below Angular Material dialogs (overlay wrapper 1000)\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    transition: all 0.3s ease !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    padding: 0 !important;\n    padding-bottom: max(20px, env(safe-area-inset-bottom)) !important;\n    margin: 0 !important;\n    min-width: 50px !important;\n    max-width: 50px !important;\n    min-height: 50px !important;\n    max-height: 50px !important;\n    box-sizing: border-box !important;\n\n    mat-icon {\n      font-size: 24px !important;\n      width: 24px !important;\n      height: 24px !important;\n      margin: 0 auto !important; // Center the icon\n      padding: 0 !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n      color: #ffffff !important; // Ensure white icon\n      line-height: 1 !important;\n      border: none !important;\n      outline: none !important;\n    }\n\n    // Hide language badge if it exists\n    .selected-language-badge {\n      display: none !important;\n    }\n\n    &:hover {\n      background-color: #4a8fc4 !important;\n      transform: scale(1.05) !important;\n      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;\n    }\n\n    &:active {\n      transform: scale(0.95) !important;\n    }\n  }\n\n  // Hide translate button entirely whenever a modal/dialog (dialoguebox) is open,\n  // so it never overlaps bottom content like comment or transfer dialogs.\n  body:has(.dialoguebox) .mobile-translate-floating-btn {\n    display: none !important;\n  }\n \n  // Mobile Translate Expandable Container (Works on both mobile and desktop)\n  .mobile-translate-container {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1002; // Above other content, below button\n    background-color: transparent;\n    border-radius: 0;\n    width: 100%;\n    min-height: 0;\n    max-height: 0;\n    overflow: hidden;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n    pointer-events: none;\n\n    &.expanded {\n      min-height: 80px;\n      max-height: 400px;\n      opacity: 1 !important;\n      visibility: visible !important;\n      pointer-events: auto;\n      padding: 16px;\n      padding-bottom: calc(\n        16px + 60px\n      ); // Space for floating button (50px + 10px margin)\n      background-color: #ffffff;\n      backdrop-filter: blur(10px);\n      box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);\n      border-top: 1px solid rgba(0, 0, 0, 0.1);\n      display: block !important;\n\n      // Ensure all content inside is visible\n      * {\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n      }\n\n      .goog-te-gadget {\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n      }\n\n      .goog-te-gadget-simple {\n        display: flex !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n      }\n\n      .goog-te-combo {\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n      }\n\n      #google_translate_element_mobile {\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n        min-height: 40px;\n      }\n    }\n\n    // Style the Google Translate widget inside\n    .goog-te-gadget {\n      font-family: \"Roboto\", \"Arial\", sans-serif !important;\n      font-size: 14px !important;\n      display: block !important;\n      width: 100% !important;\n      margin: 0 !important;\n    }\n\n    .goog-te-gadget-simple {\n      background-color: transparent !important;\n      border: 1px solid rgba(0, 0, 0, 0.1) !important;\n      border-radius: 8px !important;\n      padding: 8px 12px !important;\n      font-size: 14px !important;\n      color: #000000 !important;\n      width: 100% !important;\n      display: flex !important;\n      align-items: center !important;\n      margin: 0 !important;\n    }\n\n    .goog-te-menu-value {\n      color: #000000 !important;\n    }\n\n    // Ensure translate element and all its children are visible\n    #google_translate_element_mobile {\n      display: block !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n\n      * {\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n      }\n\n      .goog-te-gadget {\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n        width: 100% !important;\n      }\n\n      .goog-te-gadget-simple {\n        display: flex !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n        width: 100% !important;\n      }\n\n      .goog-te-menu-value {\n        display: inline-block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n      }\n    }\n\n    // Style the translate select dropdown - make it scrollable on mobile\n    .goog-te-menu-frame {\n      max-width: 100% !important;\n      max-height: 70vh !important; // Limit height to 70% of viewport\n      overflow-y: auto !important; // Enable vertical scrolling\n      overflow-x: hidden !important;\n      -webkit-overflow-scrolling: touch !important; // Smooth scrolling on iOS\n      \n      // Style the menu container inside\n      .goog-te-menu2 {\n        max-height: 70vh !important;\n        overflow-y: auto !important;\n        overflow-x: hidden !important;\n        -webkit-overflow-scrolling: touch !important;\n      }\n    }\n  }\n}\n\n\n.header-icon {\n  background: none;\n  border: none;\n  color: #000000;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: background-color 0.2s;\n}\n\n.header-icon:hover {\n  background-color: #f0f0f0;\n}\n\n.theme-toggle-button {\n  border-radius: 999px;\n  padding: 2px;\n  background: transparent;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.theme-toggle-button:focus,\n.theme-toggle-button:active,\n.theme-toggle-button:focus-visible {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.theme-toggle-button:hover {\n  background: transparent;\n}\n\n.theme-toggle-track {\n  width: 48px;\n  height: 26px;\n  border-radius: 999px;\n  background: #e5e7eb;\n  border: none;\n  outline: none !important;\n  box-shadow: none !important;\n  display: inline-flex;\n  align-items: center;\n  padding: 1px;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.theme-toggle-track.active {\n  background: #1f2937;\n  border: none;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.theme-toggle-thumb {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #ffffff;\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateX(0);\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.theme-toggle-track.active .theme-toggle-thumb {\n  transform: translateX(22px);\n  color: #f8fafc;\n  background: #0f172a;\n}\n\n.theme-toggle-thumb mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background-color: #ff0000;\n  color: transparent; // hide numeric text\n  border-radius: 50%;\n  width: 10px; // small dot\n  height: 10px;\n  font-size: 0; // ensure no number is visible\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: relative;\n  \n  &:focus,\n  &:active,\n  &:focus-visible {\n    outline: none;\n    border: none;\n  }\n  \n  mat-icon {\n    outline: none;\n    transition: box-shadow 0.2s ease;\n    border-radius: 50%;\n    \n    &:focus,\n    &:active,\n    &:focus-visible {\n      outline: none;\n      border: none;\n    }\n  }\n}\n\n.profile-image {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  transition: box-shadow 0.2s ease;\n}\n\n// Blue circle around profile image/icon when button is active or menu is open\n.profile-button:focus .profile-image,\n.profile-button:active .profile-image,\n.profile-button.cdk-focused .profile-image,\n.profile-button[aria-expanded=\"true\"] .profile-image,\n.profile-button.mat-mdc-menu-trigger[aria-expanded=\"true\"] .profile-image,\n.profile-button.active-profile .profile-image {\n  box-shadow: 0 0 0 3px var(--fc-brand, #5ea1d8);\n}\n\n.profile-button:focus mat-icon,\n.profile-button:active mat-icon,\n.profile-button.cdk-focused mat-icon,\n.profile-button[aria-expanded=\"true\"] mat-icon,\n.profile-button.mat-mdc-menu-trigger[aria-expanded=\"true\"] mat-icon,\n.profile-button.active-profile mat-icon {\n  box-shadow: 0 0 0 3px var(--fc-brand, #5ea1d8);\n  border-radius: 50%;\n}\n\n// Ensure it works on mobile devices\n@media (max-width: 768px) {\n  .profile-button {\n    &:focus .profile-image,\n    &:active .profile-image,\n    &.cdk-focused .profile-image,\n    &[aria-expanded=\"true\"] .profile-image,\n    &.mat-mdc-menu-trigger[aria-expanded=\"true\"] .profile-image,\n    &.active-profile .profile-image {\n      box-shadow: 0 0 0 3px var(--fc-brand, #5ea1d8);\n    }\n    \n    &:focus mat-icon,\n    &:active mat-icon,\n    &.cdk-focused mat-icon,\n    &[aria-expanded=\"true\"] mat-icon,\n    &.mat-mdc-menu-trigger[aria-expanded=\"true\"] mat-icon,\n    &.active-profile mat-icon {\n      box-shadow: 0 0 0 3px var(--fc-brand, #5ea1d8);\n      border-radius: 50%;\n    }\n  }\n}\n\n.app-sidebar {\n  position: fixed;\n  left: 0;\n  top: 56px;\n  width: 240px;\n  height: calc(100vh - 56px);\n  background-color: #ffffff;\n  border-right: 1px solid #e0e0e0;\n  overflow-y: auto;\n  transition: transform 0.3s ease;\n  z-index: 999;\n}\n\n// On pages without main header (about-us, how-it-works), position sidebar at top\n.about-us-page ~ .app-sidebar,\n.how-it-works-page ~ .app-sidebar,\n.faq-support-page ~ .app-sidebar,\nbody:has(.about-us-page) .app-sidebar,\nbody:has(.how-it-works-page) .app-sidebar,\nbody:has(.faq-support-page) .app-sidebar {\n  top: 0 !important;\n  height: 100vh !important;\n  z-index: 1001 !important;\n}\n\n\n.app-sidebar.sidebar-collapsed {\n  transform: translateX(-100%);\n}\n\n.sidebar-backdrop {\n  display: none;\n  z-index: 1500;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n\n  @media (max-width: 768px) {\n    display: block;\n    position: fixed;\n    top: 56px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n  }\n\n  &.show {\n    opacity: 1;\n    pointer-events: auto;\n  }\n}\n\n// On pages without main header (about-us, how-it-works), position backdrop at top\nbody:has(.about-us-page) .sidebar-backdrop,\nbody:has(.how-it-works-page) .sidebar-backdrop,\nbody:has(.faq-support-page) .sidebar-backdrop {\n  @media (max-width: 768px) {\n    top: 0 !important;\n  }\n}\n\n.sidebar-content {\n  padding: 12px 0;\n}\n\n.sidebar-section {\n  margin-bottom: 16px;\n\n  .sidebar-section-header {\n    padding: 8px 24px 4px;\n    margin-bottom: 4px;\n\n    h3 {\n      font-size: 11px;\n      font-weight: 500;\n      color: #606060;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      margin: 0;\n      padding: 0;\n    }\n  }\n}\n\n.sidebar-account-type {\n  padding: 0 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sidebar-account-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: #212427;\n  cursor: pointer;\n  text-align: left;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #606060;\n    transition: color 0.15s ease;\n  }\n\n  &:hover:not(.sidebar-account-option--active) {\n    background: rgba(94, 161, 216, 0.08);\n\n    mat-icon {\n      color: var(--fc-brand, #5ea1d8);\n    }\n\n    .sidebar-account-option-name {\n      color: #1a3d5c;\n    }\n  }\n\n  &--active {\n    background: rgba(94, 161, 216, 0.12);\n    border-color: rgba(94, 161, 216, 0.35);\n\n    mat-icon {\n      color: var(--fc-brand, #5ea1d8);\n    }\n\n    .sidebar-account-option-name {\n      font-weight: 600;\n    }\n\n    &:hover mat-icon {\n      color: var(--fc-brand, #5ea1d8);\n    }\n  }\n}\n\n.sidebar-account-option-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.sidebar-account-option-name {\n  display: block;\n  font-size: 13px;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-account-option-role {\n  display: block;\n  margin-top: 2px;\n  font-size: 11px;\n  line-height: 1.2;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-account-option--active .sidebar-account-option-role {\n  color: #3d7aad;\n  font-weight: 500;\n}\n\n.sidebar-account-option-check {\n  color: var(--fc-brand, #5ea1d8) !important;\n  flex-shrink: 0;\n}\n\n.header-org-role {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 140px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.14);\n  border: 1px solid rgba(94, 161, 216, 0.35);\n  color: #2f5f82;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    color: inherit;\n  }\n}\n\n.header-org-role-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.profile-menu {\n  min-width: 240px;\n}\n\n::ng-deep .profile-menu .profile-menu-account-trigger .menu-account-current,\n::ng-deep .mat-mdc-menu-panel.profile-menu .menu-account-current,\n::ng-deep .profile-menu .profile-menu-role-row .menu-account-current,\n::ng-deep .mat-mdc-menu-panel.profile-menu .profile-menu-role-row .menu-account-current {\n  margin-left: auto;\n  padding-left: 12px;\n  font-size: 12px;\n  color: #6b7280;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n::ng-deep .profile-menu .profile-menu-role-row,\n::ng-deep .mat-mdc-menu-panel.profile-menu .profile-menu-role-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 40px;\n  padding: 0 16px;\n  color: #374151;\n  font-size: 14px;\n  pointer-events: none;\n\n  mat-icon {\n    color: #3d7aad;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n\n  .menu-account-current {\n    color: #1a3d5c;\n    font-weight: 600;\n  }\n}\n\n::ng-deep .mat-mdc-menu-panel.account-type-submenu,\n::ng-deep .mat-menu-panel.account-type-submenu {\n  min-width: 280px;\n  max-width: 320px;\n}\n\n::ng-deep .account-type-submenu .account-type-menu-item,\n::ng-deep .mat-mdc-menu-panel.account-type-submenu .account-type-menu-item,\n::ng-deep .mat-menu-panel.account-type-submenu .account-type-menu-item {\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px;\n  height: auto !important;\n  min-height: 48px !important;\n  line-height: 1.2 !important;\n  padding: 10px 14px 10px 12px !important;\n  position: relative;\n\n  /* Keep only the leading icon in Material's icon slot; badge is not an icon. */\n  .account-type-menu-leading.mat-icon,\n  .mat-icon.account-type-menu-leading,\n  mat-icon.account-type-menu-leading {\n    flex-shrink: 0;\n    margin-right: 0 !important;\n    color: #606060;\n    transition: color 0.15s ease;\n  }\n\n  &:hover {\n    background: rgba(94, 161, 216, 0.1) !important;\n\n    .account-type-menu-leading.mat-icon,\n    .mat-icon.account-type-menu-leading,\n    mat-icon.account-type-menu-leading {\n      color: #3d7aad;\n    }\n\n    .account-type-menu-name {\n      color: #1a3d5c;\n    }\n  }\n\n  .account-type-menu-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n    flex: 1 1 auto;\n    overflow: hidden;\n    padding-right: 4px;\n  }\n\n  .account-type-menu-name {\n    display: block;\n    font-size: 14px;\n    font-weight: 500;\n    color: #212427;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .account-type-menu-desc {\n    display: block;\n    font-size: 11px;\n    color: #6b7280;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .account-type-selected-badge {\n    flex: 0 0 auto;\n    margin-left: auto;\n    padding: 3px 8px;\n    border-radius: 999px;\n    font-size: 10px;\n    font-weight: 650;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: #2f5f82;\n    background: rgba(94, 161, 216, 0.22);\n    border: 1px solid rgba(94, 161, 216, 0.35);\n    line-height: 1.2;\n    white-space: nowrap;\n  }\n\n  &.account-type-menu-item--active {\n    background: rgba(94, 161, 216, 0.1);\n\n    .account-type-menu-name {\n      font-weight: 600;\n    }\n\n    .account-type-menu-leading.mat-icon,\n    .mat-icon.account-type-menu-leading,\n    mat-icon.account-type-menu-leading {\n      color: #3d7aad;\n    }\n\n    &:hover {\n      background: rgba(94, 161, 216, 0.16) !important;\n    }\n  }\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n  padding: 10px 24px;\n  background: none;\n  border: none;\n  color: #212427;\n  cursor: pointer;\n  font-size: 14px;\n  outline: none;\n  border-radius: 8px;\n  \n  &:focus,\n  &:active,\n  &:focus-visible {\n    outline: none;\n    border: none;\n    box-shadow: none;\n  }\n  font-weight: 400;\n\n  &.active {\n    background: #e3f2fd;\n    color: #0b3c61;\n    font-weight: 600;\n  }\n  text-align: left;\n  transition: background-color 0.2s ease;\n  border-radius: 0;\n\n  &:hover {\n    background-color: #f0f0f0;\n  }\n\n  &.active {\n    background-color: #f0f0f0;\n    font-weight: 500;\n  }\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #212427;\n  }\n\n  .bundle-menu-icon {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n  }\n\n  span {\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.app-main-content {\n  margin-left: 240px;\n  background-color: #ffffff;\n  min-height: 100vh;\n  transition: margin-left 0.3s ease;\n  padding-top: 56px; /* start content immediately below fixed header */\n}\n\n/* Leave room so content is not hidden behind the fixed platform footer. */\n.app-layout:has(.flowchest-platform-footer) .app-main-content {\n  padding-bottom: 3rem;\n}\n\n// Remove padding-top, margin-left, and background for about-us and how-it-works pages\nbody:has(.about-us-page) .app-main-content,\nbody:has(.how-it-works-page) .app-main-content,\nbody:has(.faq-support-page) .app-main-content,\nbody:has(.legal-page) .app-main-content,\nbody:has(app-legal-center-layout) .app-main-content,\n.app-main-content:has(.legal-page),\n.app-main-content:has(app-legal-center-layout) {\n  padding-top: 0px !important;\n  margin-left: 0 !important;\n  background-color: transparent !important;\n  background: transparent !important;\n}\n\n// Remove margin-top from page-header on about-us, how-it-works, and faq pages\nbody:has(.about-us-page) .page-header,\nbody:has(.how-it-works-page) .page-header,\nbody:has(.faq-support-page) .page-header {\n  margin-top: 0 !important;\n}\n\n// Remove margin-top and padding from main-container on about-us, how-it-works, and faq pages\nbody:has(.about-us-page) .main-container,\nbody:has(.how-it-works-page) .main-container,\nbody:has(.faq-support-page) .main-container {\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n}\n\n/* Full-width routes (dashboards, settings, profiles) should not reserve sidebar space */\n.app-main-content.sidebar-overlay {\n  margin-left: 0;\n  padding-top: 56px; /* keep consistent top offset on full-width routes */\n}\n\n// Exclude legal pages from sidebar-overlay padding-top\nbody:has(.legal-page) .app-main-content.sidebar-overlay,\nbody:has(app-legal-center-layout) .app-main-content.sidebar-overlay {\n  padding-top: 0px !important;\n}\n\n/* Mobile search box when active in header */\n.mobile-search-box-in-header {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: visible; // Allow dropdown to show\n  z-index: 1001; // Ensure it's above header\n}\n\n\n.mobile-search-box-in-header .mobile-search-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  overflow: visible; // Allow dropdown to show\n  gap: 4px;\n  height: 100%;\n}\n\n.mobile-search-box-in-header .mobile-search-field mat-chip-grid {\n  flex: 0 1 auto;\n  max-width: 45%;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n}\n\n.mobile-search-box-in-header .mobile-search-field mat-chip-grid::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-search-box-in-header .mobile-search-field mat-chip-row {\n  display: inline-flex;\n}\n\n.mobile-search-box-in-header .mobile-search-field .app-search-input {\n  flex: 1;\n  min-width: 80px; // keep input usable even with many chips\n  padding: 8px 12px;\n  padding-right: 8px; // Reduced padding since icons are outside\n  border: none;       // border is on the outer search-box, not the raw input\n  border-radius: 0;   // the outer pill provides rounding\n  font-size: 16px;\n  background: transparent;\n  color: #111827;\n  height: 32px;\n  outline: none;\n}\n\n.mobile-search-box-in-header .mobile-search-field .cancel-icon-button,\n.mobile-search-box-in-header .mobile-search-field .search-icon-button {\n  flex-shrink: 0;\n  padding: 8px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #606060;\n}\n\n.mobile-search-box-in-header .mobile-search-field .cancel-icon-button:hover,\n.mobile-search-box-in-header .mobile-search-field .search-icon-button:hover {\n  background: transparent;\n}\n\n.mobile-search-box-in-header .mobile-search-field .cancel-icon-button mat-icon,\n.mobile-search-box-in-header .mobile-search-field .search-icon-button mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n/* Mobile search container when active */\n.app-search-container.mobile-search-active {\n  flex: 1;\n  margin: 0 8px;\n  min-width: 0;\n  position: relative;\n  overflow: visible; /* Allow dropdown to show */\n  z-index: 1001; /* Ensure it's above header */\n}\n\n.mobile-search-field .cancel-icon-button {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  color: #666666;\n  border-radius: 50%;\n  transition: color 0.2s, background-color 0.2s;\n  flex-shrink: 0;\n  \n  &:hover {\n    color: #000000;\n    background-color: #f0f0f0;\n  }\n}\n\n.mobile-search-field .cancel-icon-button mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.mobile-search-icon-button {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  color: #666666;\n  border-radius: 50%;\n  transition: color 0.2s, background-color 0.2s;\n  flex-shrink: 0;\n  \n  &:hover {\n    color: #000000;\n    background-color: #f0f0f0;\n  }\n  \n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.mobile-search-box .cancel-button {\n  background: none;\n  border: none;\n  color: #212427;\n  font-size: 14px;\n  padding: 6px 8px;\n  cursor: pointer;\n  margin-left: 4px;\n}\n\n.app-main-content.sidebar-collapsed {\n  margin-left: 0;\n  // padding-top: 10px !important; /* Override inline styles */\n}\n\n.notification-menu {\n  max-width: 400px;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.notification-menu-section-title {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #888;\n  padding: 8px 16px 4px;\n  margin: 0;\n}\n\n// ── Bell dropdown notification items ──────────────────────────────────────\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 16px 10px 20px;  // extra left padding to accommodate accent stripe\n  border-bottom: 1px solid #f0f0f0;\n  position: relative;\n  transition: background-color 0.15s ease;\n  cursor: pointer;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.03);\n  }\n\n  // ── Unread state (light mode) ────────────────────────────────────────\n  &.unread {\n    background-color: rgba(6, 95, 212, 0.06);\n\n    // Left accent stripe\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      width: 3px;\n      background-color: #065fd4;\n      border-radius: 0 2px 2px 0;\n    }\n\n    &:hover {\n      background-color: rgba(6, 95, 212, 0.10);\n    }\n  }\n}\n\n// Unread dot shown inside unread items (spans)\n.notification-unread-dot {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #065fd4;\n  flex-shrink: 0;\n  pointer-events: none;\n}\n\n.notification-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.notification-avatar-icon {\n  width: 40px;\n  height: 40px;\n  font-size: 40px;\n  color: #666666;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n  cursor: pointer;\n}\n\n.notification-message {\n  display: block;\n  font-size: 14px;\n  font-weight: 400;\n  color: #444;\n  margin: 0 0 4px 0;\n  line-height: 1.5;\n  /* Preserve API newlines: title / body / meta on separate lines */\n  white-space: pre-line;\n\n  // Unread: bolder + darker text for clear distinction\n  &.notification-message--unread {\n    font-weight: 600;\n    color: #111;\n  }\n}\n\n.notification-time {\n  font-size: 12px;\n  color: #888;\n}\n\n.notification-menu .notification-thumbnail {\n  flex-shrink: 0;\n  width: 72px;\n  height: 54px;\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: #f9f9f9;\n\n  .thumbnail-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n}\n\n.notification-menu .notification-thumbnail--clickable {\n  cursor: pointer;\n}\n\n// ── Dark mode overrides for the bell dropdown ────────────────────────────\nbody.theme-dark {\n  .notification-menu-section-title {\n    color: #94a3b8;\n  }\n\n  .notification-item {\n    border-bottom-color: rgba(148, 163, 184, 0.15);\n\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.05);\n    }\n\n    &.unread {\n      background-color: rgba(59, 130, 246, 0.14);\n\n      &::before {\n        background-color: #60a5fa;\n      }\n\n      &:hover {\n        background-color: rgba(59, 130, 246, 0.20);\n      }\n    }\n  }\n\n  .notification-unread-dot {\n    background-color: #60a5fa;\n  }\n\n  .notification-message {\n    color: #cbd5e1;\n\n    &.notification-message--unread {\n      font-weight: 600;\n      color: #f1f5f9;\n    }\n  }\n\n  .notification-time {\n    color: #94a3b8;\n  }\n\n  .notification-avatar-icon {\n    color: #94a3b8;\n  }\n\n  .notification-menu .notification-thumbnail {\n    background-color: #1e293b;\n  }\n}\n\n// Create Flow Menu Styles\n::ng-deep .create-flow-menu {\n  .mat-mdc-menu-content {\n    padding: 8px 0;\n    min-width: 280px;\n  }\n\n  .mat-mdc-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    min-height: auto;\n    height: auto;\n\n    mat-icon {\n      color: var(--fc-brand, #5ea1d8);\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n      flex-shrink: 0;\n    }\n\n    .menu-item-content {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      flex: 1;\n      min-width: 0;\n\n      .menu-item-title {\n        font-size: 14px;\n        font-weight: 600;\n        color: #111827;\n        line-height: 1.2;\n      }\n\n      .menu-item-description {\n        font-size: 12px;\n        color: #6b7280;\n        line-height: 1.2;\n        white-space: normal;\n      }\n    }\n\n    &:hover {\n      background: #f3f4f6;\n    }\n  }\n}\n\n/* Tablet View */\n:root {\n  --app-header: 56px;\n}\n\n@media (max-width: 1024px) {\n  .app-sidebar {\n    width: 200px;\n  }\n\n  .app-main-content {\n    margin-left: 200px;\n  }\n\n  .app-search-container {\n    max-width: 400px;\n    margin: 0 20px;\n  }\n}\n\n/* Mobile view - app style */\n/* Ensure translate button is always visible on mobile */\n@media (max-width: 768px) {\n  .mobile-translate-floating-btn {\n    position: fixed !important;\n    bottom: 40px !important;\n    right: 16px !important;\n    width: 50px !important;\n    height: 50px !important;\n    border-radius: 50% !important;\n    background-color: var(--fc-brand, #5ea1d8) !important;\n    color: #ffffff !important;\n    border: none !important;\n    outline: none !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    padding: 0 !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n    cursor: pointer !important;\n    z-index: 1003 !important;\n    margin: 0 !important;\n    min-width: 50px !important;\n    max-width: 50px !important;\n    min-height: 50px !important;\n    max-height: 50px !important;\n    box-sizing: border-box !important;\n    \n    mat-icon {\n      font-size: 24px !important;\n      width: 24px !important;\n      height: 24px !important;\n      color: #ffffff !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      border: none !important;\n      outline: none !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n      line-height: 1 !important;\n    }\n  }\n}\n\n/* Ensure translate button is always visible on desktop - same style as mobile */\n@media (min-width: 769px) {\n  .mobile-translate-floating-btn {\n    position: fixed !important;\n    bottom: 40px !important;\n    right: 16px !important;\n    width: 50px !important;\n    height: 50px !important;\n    border-radius: 50% !important;\n    background-color: var(--fc-brand, #5ea1d8) !important;\n    color: #ffffff !important;\n    border: none !important;\n    outline: none !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    z-index: 1003 !important; // Above translate banner\n    \n    mat-icon {\n      color: #ffffff !important;\n      margin: 0 auto !important;\n      padding: 0 !important;\n      border: none !important;\n      outline: none !important;\n    }\n  }\n  \n  // Ensure translate container works on desktop\n  .mobile-translate-container {\n    position: fixed !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 1002 !important;\n    \n    &.expanded {\n      display: block !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n    }\n  }\n  \n  // Ensure translate button is not affected by Google Translate banner styles\n  body:has(.goog-te-banner-frame) .mobile-translate-floating-btn,\n  body:has(iframe.skiptranslate) .mobile-translate-floating-btn {\n    position: fixed !important;\n    bottom: 40px !important;\n    right: 16px !important;\n    width: 50px !important;\n    height: 50px !important;\n    border-radius: 50% !important;\n    background-color: var(--fc-brand, #5ea1d8) !important;\n    color: #ffffff !important;\n    border: none !important;\n    outline: none !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    \n    mat-icon {\n      color: #ffffff !important;\n      margin: 0 auto !important;\n      padding: 0 !important;\n      border: none !important;\n      outline: none !important;\n    }\n  }\n}\n\n/* Mobile view - app style */\n@media (max-width: 768px) {\n  .app-header {\n    padding: 0 8px;\n    height: 56px;\n    column-gap: 8px; /* tighten gaps to avoid crowding */\n    box-sizing: border-box;\n  }\n\n  .app-logo img {\n    height: 35px;\n    display: block; /* prevent inline baseline shift */\n  }\n\n  .app-search-container {\n    max-width: none;\n    margin: 0 4px; /* tighter to increase available width */\n    flex: 1 1 auto;\n    min-width: 0; /* Allow flex shrinking */\n    overflow: hidden; /* Prevent content from overflowing */\n  }\n\n  .app-header-left {\n    gap: 8px;\n    flex-shrink: 0; /* Prevent left section from shrinking */\n  }\n\n  .app-header-right {\n    gap: 6px;\n    align-items: center;\n    flex-shrink: 0; /* Prevent right section from shrinking */\n  }\n\n  /* Keep role discoverable via profile menu on small screens. */\n  .header-org-role {\n    max-width: 34px;\n    padding: 4px 6px;\n    justify-content: center;\n\n    .header-org-role-text {\n      display: none;\n    }\n  }\n\n  // On mobile the search icon button shows (not the expanded box) by default.\n  // When mobile search IS active the search-box becomes the full pill.\n  .search-box {\n    height: 36px;\n    width: auto;\n    background: transparent; /* icon only */\n    border: none;\n    border-radius: 0;\n  }\n\n  // Full-width pill when mobile search is active\n  .mobile-search-box-in-header {\n    background: #ffffff;\n    border: 1px solid #d0d0d0;\n    border-radius: 24px;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n    overflow: visible;\n\n    // Only change the border colour on focus — no shape changes\n    &.search-box-focused {\n      border-color: #1a73e8;\n    }\n  }\n\n  .search-button {\n    background: transparent;\n    -webkit-appearance: none;\n    box-shadow: none;\n  }\n\n  .app-search-input {\n    font-size: 16px;\n    padding: 0 12px;\n  }\n\n  .search-button {\n    padding: 8px 12px;\n    background: transparent;\n    -webkit-appearance: none;\n    box-shadow: none;\n  }\n\n  .header-icon {\n    padding: 6px;\n  }\n\n  .profile-image {\n    width: 28px;\n    height: 28px;\n  }\n\n  .menu-button {\n    padding: 6px;\n  }\n\n  /* Sidebar - Hidden by default on mobile */\n  .app-sidebar {\n    width: 100%;\n    max-width: 280px;\n    position: fixed;\n    top: 0px;\n    left: 0;\n    height: calc(100vh - 0px);\n    transform: translateX(-100%);\n    z-index: 2000;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .app-sidebar:not(.sidebar-collapsed) {\n    transform: translateX(0);\n  }\n\n  /* Main content - Full width on mobile */\n  .app-main-content {\n    margin-left: 0 !important;\n    width: 100%;\n    padding-bottom: 200px !important; // Base padding for floating button\n\n    // When language selector iframe is visible, add more padding\n    body:has(iframe.skiptranslate) &,\n    body:has(iframe.VIpgJd-ZVi9od-ORHb-OEVmcd) &,\n    body:has(iframe[class*=\"skiptranslate\"]) &,\n    body:has(iframe[id*=\"container\"]) & {\n      padding-bottom: 250px !important; // Space for language selector iframe (120px) + floating button (50px) + margin (80px)\n    }\n  }\n\n  /* Mobile search active styles */\n  .app-search-container.mobile-search-active {\n    flex: 1;\n    margin: 0 8px;\n    min-width: 0;\n  }\n\n  .mobile-search-box-in-header {\n    height: 100%;\n  }\n\n  .mobile-search-box-in-header .mobile-search-field {\n    height: 36px;\n  }\n\n  .mobile-search-box-in-header .mobile-search-field mat-chip-grid {\n    max-width: 40vw;\n  }\n\n  .mobile-search-box-in-header .mobile-search-field .app-search-input {\n    font-size: 16px;\n    padding: 8px 12px;\n    min-width: 110px;\n  }\n\n  .mobile-search-box-in-header .mobile-search-history {\n    max-height: calc(100vh - 100px); /* Ensure dropdown doesn't go off screen */\n  }\n\n  /* Sidebar item adjustments for mobile */\n  .sidebar-item {\n    padding: 12px 20px;\n    gap: 20px;\n    font-size: 16px;\n  }\n\n  .sidebar-item mat-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n/* Extra Small Mobile */\n@media (max-width: 480px) {\n  .app-header {\n    padding: 0 4px;\n  }\n\n  .app-search-container {\n    margin: 0 4px;\n  }\n\n  .search-box {\n    height: 32px;\n  }\n\n  .app-search-input {\n    font-size: 16px;\n    padding: 0 8px;\n  }\n\n  .app-logo img {\n    height: 35px;\n  }\n\n  .menu-button,\n  .header-icon {\n    padding: 4px;\n  }\n\n  .profile-image {\n    width: 24px;\n    height: 24px;\n  }\n\n  .app-sidebar {\n    max-width: 260px;\n  }\n}\n\n// Auth Modal Styles\n.app-layout.modal-blur {\n  filter: blur(5px);\n  pointer-events: none;\n  transition: filter 0.3s ease-in-out;\n}\n\n/* Routed auth page sits under the overlay — hide it so it is not visible behind the modal. */\n.app-main-content.hide-behind-auth-modal {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.auth-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  /* Above cdk-overlay-container (1100) and body:has(.auth-modal-overlay) bump (10050) */\n  z-index: 10100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.auth-modal-container {\n  position: relative;\n  max-width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease-in-out;\n  z-index: 10000;\n  margin-top: 0; // Ensure no top margin\n  \n  // Hide scrollbar but keep functionality\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 10px;\n    \n    &:hover {\n      background: #555;\n    }\n  }\n}\n\n.auth-modal-close {\n  position: fixed;\n  top: 8px; // Align with header icons (header is 56px tall, icons are 40px, so (56-40)/2 = 8px from top)\n  right: 16px;\n  background: rgba(255, 255, 255, 0.95);\n  border: none;\n  cursor: pointer;\n  z-index: 10001;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  width: 40px;\n  height: 40px;\n  \n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  }\n  \n  mat-icon {\n    color: #606060;\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n    transition: color 0.2s ease;\n  }\n  \n  &:hover mat-icon {\n    color: #333;\n  }\n  \n  // Adjust for mobile - align with header\n  @media screen and (max-width: 768px) {\n    top: 8px;\n    right: 12px;\n    width: 40px;\n    height: 40px;\n    \n    mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n// Ensure modal content is properly styled for all modals\n.auth-modal-container {\n  padding: 0;\n  margin: 0;\n  position: relative;\n  background: white;\n  z-index: 10101;\n  \n  app-login,\n  app-registration,\n  app-activateaccount,\n  app-forget-password-modal,\n  app-change-password {\n    display: block;\n    width: 100%;\n    position: relative;\n    z-index: 10001;\n    \n    .Login {\n      background-color: white;\n      padding: 20px;\n      margin: 0;\n      width: 100%;\n      position: relative;\n      z-index: 10001;\n    }\n    \n    #formContent,\n    .formContent {\n      box-shadow: none;\n      border: none;\n      max-width: 100%;\n      padding: 20px;\n      margin: 0;\n      width: 100%;\n      box-sizing: border-box;\n      background: white;\n      position: relative;\n      z-index: 10001;\n    }\n    \n    // Remove any header/footer styling\n    .fadeIn.first {\n      margin-top: 0;\n      padding-top: 0;\n    }\n    \n    // Footer strip stays transparent; button look is owned by each auth component\n    #formFooter {\n      background: transparent !important;\n      border-top: none !important;\n      padding: 15px 0 0 0;\n      margin-top: 15px;\n      text-align: center;\n    }\n    \n    // Ensure spinner is positioned correctly in modal\n    .img-div-left {\n      position: fixed;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 10002;\n    }\n  }\n}\n\n/* Dark mode: auth modals (Sign In / Sign Up) — readable text + fields */\nbody.theme-dark .auth-modal-container {\n  background: #1f2937 !important;\n\n  app-login,\n  app-registration,\n  app-activateaccount,\n  app-forget-password-modal,\n  app-change-password {\n    .Login {\n      background-color: #1f2937 !important;\n      color: #e5e7eb !important;\n    }\n\n    #formContent,\n    .formContent {\n      background: #1f2937 !important;\n      color: #e5e7eb !important;\n      border-color: transparent !important;\n    }\n\n    #formFooter {\n      background: transparent !important;\n      border-top: none !important;\n    }\n\n    p,\n    .example-margin,\n    .checkbox-section,\n    .example-section {\n      color: #e5e7eb !important;\n    }\n\n    /* “I agree…” checkbox label + trademark copy */\n    .mat-mdc-checkbox,\n    .mat-checkbox,\n    .mat-mdc-checkbox .mdc-label,\n    .mat-mdc-checkbox label,\n    .mat-checkbox-label,\n    .mat-mdc-checkbox .mdc-form-field > label {\n      color: #e5e7eb !important;\n    }\n\n    .mat-mdc-checkbox a,\n    .mat-checkbox a,\n    .checkbox-section a {\n      color: #93c5fd !important;\n    }\n\n    .mat-mdc-checkbox .mdc-checkbox__background,\n    .mat-checkbox-frame {\n      border-color: #94a3b8 !important;\n    }\n\n    .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,\n    .mat-checkbox-checked .mat-checkbox-background {\n      background-color: var(--fc-brand, #5ea1d8) !important;\n      border-color: var(--fc-brand, #5ea1d8) !important;\n    }\n\n    /* User Type dropdown (mat-form-field / mat-select) */\n    .mat-mdc-form-field,\n    .mat-form-field {\n      color: #e5e7eb !important;\n    }\n\n    .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled),\n    .mat-mdc-text-field-wrapper,\n    .mat-mdc-form-field-focus-overlay {\n      background-color: #111827 !important;\n    }\n\n    .mat-mdc-form-field .mdc-floating-label,\n    .mat-mdc-form-field .mat-mdc-floating-label,\n    .mat-mdc-form-field mat-label,\n    .mat-form-field-label {\n      color: #94a3b8 !important;\n    }\n\n    .mat-mdc-select-value,\n    .mat-mdc-select-min-line,\n    .mat-select-value,\n    .mat-select-value-text,\n    .mat-mdc-select-placeholder {\n      color: #e5e7eb !important;\n    }\n\n    .mat-mdc-select-arrow,\n    .mat-select-arrow {\n      color: #94a3b8 !important;\n    }\n\n    .mdc-line-ripple::before,\n    .mdc-line-ripple::after,\n    .mat-mdc-form-field-underline,\n    .mat-form-field-underline {\n      background-color: rgba(148, 163, 184, 0.35) !important;\n      border-bottom-color: rgba(148, 163, 184, 0.35) !important;\n    }\n\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing {\n      border-color: rgba(148, 163, 184, 0.35) !important;\n    }\n  }\n}\n\n// Final override to ensure legal pages never have padding-top: 56px\n// This must come last to override all other rules\nbody:has(.legal-page) .app-main-content,\nbody:has(app-legal-center-layout) .app-main-content,\n.app-main-content:has(.legal-page),\n.app-main-content:has(app-legal-center-layout),\n.app-layout:has(.legal-page) .app-main-content,\n.app-layout:has(app-legal-center-layout) .app-main-content,\n.app-main-content app-legal-center-layout,\n.app-main-content .legal-page,\n.app-main-content .legal-center-wrapper {\n  padding-top: 0 !important;\n}\n\n// Also ensure the parent app-main-content doesn't have padding when it contains legal pages\n.app-main-content:has(app-legal-center-layout),\n.app-main-content:has(.legal-page),\n.app-main-content.has-legal-page,\nbody.has-legal-page .app-main-content {\n  padding-top: 0 !important;\n}\n\n// Starter free trial strip (top of main content while the trial runs)\n.trial-strip {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.6rem 1rem;\n  margin: 0.75rem 1rem 0;\n  padding: 0.6rem 0.9rem;\n  border-radius: 10px;\n  border: 1px solid rgba(94, 161, 216, 0.35);\n  background: rgba(94, 161, 216, 0.1);\n  color: #0f172a;\n  font-size: 0.875rem;\n\n  .trial-strip-icon {\n    color: #4a92c8;\n    font-size: 1.2rem;\n  }\n\n  .trial-strip-text {\n    flex: 1;\n    min-width: 12rem;\n  }\n\n  &.trial-strip--error {\n    border-color: rgba(220, 38, 38, 0.35);\n    background: rgba(254, 226, 226, 0.7);\n\n    .trial-strip-icon {\n      color: #b91c1c;\n    }\n  }\n\n  .trial-strip-link {\n    border: none;\n    background: none;\n    padding: 0;\n    color: #2f74b0;\n    font-weight: 700;\n    text-decoration: none;\n    cursor: pointer;\n\n    &.muted {\n      color: #475569;\n      font-weight: 600;\n    }\n  }\n\n  .trial-strip-close {\n    border: none;\n    background: none;\n    padding: 0;\n    color: #64748b;\n    cursor: pointer;\n    line-height: 1;\n\n    .material-icons {\n      font-size: 1.1rem;\n    }\n  }\n}\n\n:host-context(body.dark-mode) .trial-strip,\n:host-context(.dark-theme) .trial-strip {\n  color: #e2e8f0;\n  background: rgba(94, 161, 216, 0.16);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
